/* eslint-disable */
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDateTime: { input: any; output: any; }
  AWSJSON: { input: any; output: any; }
};

export type CalendarAndResultsGlider = {
  __typename?: 'CalendarAndResultsGlider';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  currentRound?: Maybe<Scalars['Int']['output']>;
  rounds?: Maybe<Array<Maybe<CalendarAndResultsGliderRound>>>;
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CalendarAndResultsGliderRound = {
  __typename?: 'CalendarAndResultsGliderRound';
  competitionPhase?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CalendarAndResultsGliderRoundInput = {
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CalendarAndResultsMatchDayList = {
  __typename?: 'CalendarAndResultsMatchDayList';
  competitionId: Scalars['ID']['output'];
  competitionPhase?: Maybe<Scalars['String']['output']>;
  competitionPhaseRound?: Maybe<Scalars['String']['output']>;
  customCompetitionName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  matchList?: Maybe<Array<Maybe<CalendarAndResultsMatchList>>>;
  round?: Maybe<Scalars['Int']['output']>;
  roundGroup?: Maybe<Scalars['String']['output']>;
  seasonId: Scalars['ID']['output'];
};

export type CalendarAndResultsMatchDayListInput = {
  competitionId: Scalars['ID']['input'];
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  matchList?: InputMaybe<Array<InputMaybe<CalendarAndResultsMatchListInput>>>;
  round?: InputMaybe<Scalars['Int']['input']>;
  roundGroup?: InputMaybe<Scalars['String']['input']>;
  seasonId: Scalars['ID']['input'];
};

export type CalendarAndResultsMatchList = {
  __typename?: 'CalendarAndResultsMatchList';
  away?: Maybe<CalendarAndResultsTeam>;
  competitionPhaseWinnerTeamId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  home?: Maybe<CalendarAndResultsTeam>;
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  liveOnSky?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CalendarAndResultsMatchListInput = {
  away?: InputMaybe<CalendarAndResultsTeamInput>;
  competitionPhaseWinnerTeamId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<CalendarAndResultsTeamInput>;
  id: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  liveOnSky?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CalendarAndResultsTeam = {
  __typename?: 'CalendarAndResultsTeam';
  goal?: Maybe<Scalars['Int']['output']>;
  homepageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  overtimeGoal?: Maybe<Scalars['Int']['output']>;
  penaltiesGoal?: Maybe<Scalars['Int']['output']>;
  regularTimeGoal?: Maybe<Scalars['Int']['output']>;
  seoName?: Maybe<Scalars['String']['output']>;
  shootoutGoal?: Maybe<Scalars['Int']['output']>;
  totalGoalLegs?: Maybe<Scalars['Int']['output']>;
};

export type CalendarAndResultsTeamInput = {
  goal?: InputMaybe<Scalars['Int']['input']>;
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overtimeGoal?: InputMaybe<Scalars['Int']['input']>;
  penaltiesGoal?: InputMaybe<Scalars['Int']['input']>;
  regularTimeGoal?: InputMaybe<Scalars['Int']['input']>;
  seoName?: InputMaybe<Scalars['String']['input']>;
  shootoutGoal?: InputMaybe<Scalars['Int']['input']>;
  totalGoalLegs?: InputMaybe<Scalars['Int']['input']>;
};

export type CardCompetitionCalendar = {
  __typename?: 'CardCompetitionCalendar';
  calendarAndResultsLink?: Maybe<Scalars['String']['output']>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  customCompetitionName?: Maybe<Scalars['String']['output']>;
  matchRoundList?: Maybe<Array<Maybe<CardCompetitionCalendarMatchRound>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CardCompetitionCalendarMatch = {
  __typename?: 'CardCompetitionCalendarMatch';
  away?: Maybe<CardCompetitionCalendarMatchTeam>;
  competitionPhaseRound?: Maybe<Scalars['String']['output']>;
  competitionPhaseWinnerTeamId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  home?: Maybe<CardCompetitionCalendarMatchTeam>;
  id?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  roundGroup?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CardCompetitionCalendarMatchDay = {
  __typename?: 'CardCompetitionCalendarMatchDay';
  date?: Maybe<Scalars['String']['output']>;
  matchList?: Maybe<Array<Maybe<CardCompetitionCalendarMatch>>>;
};

export type CardCompetitionCalendarMatchDayInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  matchList?: InputMaybe<Array<InputMaybe<CardCompetitionCalendarMatchInput>>>;
};

export type CardCompetitionCalendarMatchInput = {
  away?: InputMaybe<CardCompetitionCalendarMatchTeamInput>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseWinnerTeamId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<CardCompetitionCalendarMatchTeamInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  roundGroup?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CardCompetitionCalendarMatchRound = {
  __typename?: 'CardCompetitionCalendarMatchRound';
  competitionPhase?: Maybe<Scalars['String']['output']>;
  matchDayList?: Maybe<Array<Maybe<CardCompetitionCalendarMatchDay>>>;
  round?: Maybe<Scalars['Int']['output']>;
};

export type CardCompetitionCalendarMatchRoundInput = {
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  matchDayList?: InputMaybe<Array<InputMaybe<CardCompetitionCalendarMatchDayInput>>>;
  round?: InputMaybe<Scalars['Int']['input']>;
};

export type CardCompetitionCalendarMatchTeam = {
  __typename?: 'CardCompetitionCalendarMatchTeam';
  id?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  negativeLogoUrl?: Maybe<Scalars['String']['output']>;
  seoName?: Maybe<Scalars['String']['output']>;
};

export type CardCompetitionCalendarMatchTeamInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  negativeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  seoName?: InputMaybe<Scalars['String']['input']>;
};

export type CardCompetitionRanking = {
  __typename?: 'CardCompetitionRanking';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  customCompetitionName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<CardCompetitionRankingGroup>>>;
  rankingLink?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CardCompetitionRankingGroup = {
  __typename?: 'CardCompetitionRankingGroup';
  roundName?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Maybe<CardCompetitionRankingTeam>>>;
};

export type CardCompetitionRankingGroupInput = {
  roundName?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<InputMaybe<CardCompetitionRankingTeamInput>>>;
};

export type CardCompetitionRankingTeam = {
  __typename?: 'CardCompetitionRankingTeam';
  games?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  negativeLogoUrl?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  teamUrl?: Maybe<Scalars['String']['output']>;
  trend?: Maybe<Scalars['String']['output']>;
};

export type CardCompetitionRankingTeamInput = {
  games?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  negativeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  teamUrl?: InputMaybe<Scalars['String']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
};

export type Competition = {
  __typename?: 'Competition';
  competitionId: Scalars['ID']['output'];
  competitionJson: Scalars['AWSJSON']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  editorialData?: Maybe<EditorialData>;
  editorialDataId: Scalars['ID']['output'];
  match?: Maybe<ModelMatchConnection>;
  players?: Maybe<ModelPlayerConnection>;
  playersRanking?: Maybe<ModelPlayerRankingConnection>;
  previousCompetition?: Maybe<Competition>;
  previousSeasonAndCompId?: Maybe<Scalars['ID']['output']>;
  ranking?: Maybe<ModelRankingConnection>;
  season?: Maybe<Season>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['ID']['output'];
  teams?: Maybe<ModelTeamConnection>;
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type CompetitionmatchArgs = {
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<ModelIDKeyConditionInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CompetitionplayersArgs = {
  filter?: InputMaybe<ModelPlayerFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<ModelIDKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CompetitionplayersRankingArgs = {
  filter?: InputMaybe<ModelPlayerRankingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<ModelIDKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CompetitionrankingArgs = {
  filter?: InputMaybe<ModelRankingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId?: InputMaybe<ModelIDKeyConditionInput>;
};


export type CompetitionteamsArgs = {
  filter?: InputMaybe<ModelTeamFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId?: InputMaybe<ModelIDKeyConditionInput>;
};

export type CompetitionBoard = {
  __typename?: 'CompetitionBoard';
  boardSponsorLink?: Maybe<Scalars['String']['output']>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  customCompetitionName?: Maybe<Scalars['String']['output']>;
  matchList?: Maybe<Array<Maybe<CompetitionBoardPhaseRound>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CompetitionBoardLinkedMatch = {
  __typename?: 'CompetitionBoardLinkedMatch';
  away?: Maybe<CompetitionBoardTeam>;
  competitionPhaseRound?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  home?: Maybe<CompetitionBoardTeam>;
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CompetitionBoardLinkedMatchInput = {
  away?: InputMaybe<CompetitionBoardTeamInput>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<CompetitionBoardTeamInput>;
  id: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionBoardPhaseRound = {
  __typename?: 'CompetitionBoardPhaseRound';
  away?: Maybe<CompetitionBoardTeam>;
  competitionPhase?: Maybe<Scalars['String']['output']>;
  competitionPhaseRound?: Maybe<Scalars['String']['output']>;
  competitionPhaseWinnerTeamId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  gamesPhaseCount?: Maybe<Scalars['Int']['output']>;
  home?: Maybe<CompetitionBoardTeam>;
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  linkedMatch?: Maybe<CompetitionBoardLinkedMatch>;
  round?: Maybe<Scalars['Int']['output']>;
  roundGroup?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CompetitionBoardPhaseRoundInput = {
  away?: InputMaybe<CompetitionBoardTeamInput>;
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseWinnerTeamId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  gamesPhaseCount?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<CompetitionBoardTeamInput>;
  id: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  linkedMatch?: InputMaybe<CompetitionBoardLinkedMatchInput>;
  round?: InputMaybe<Scalars['Int']['input']>;
  roundGroup?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionBoardTeam = {
  __typename?: 'CompetitionBoardTeam';
  goal?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  prevMatch?: Maybe<Scalars['ID']['output']>;
  shootoutGoal?: Maybe<Scalars['Int']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export type CompetitionBoardTeamInput = {
  goal?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prevMatch?: InputMaybe<Scalars['ID']['input']>;
  shootoutGoal?: InputMaybe<Scalars['Int']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionCalendarAndResults = {
  __typename?: 'CompetitionCalendarAndResults';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  currentRound?: Maybe<Scalars['Int']['output']>;
  customCompetitionName?: Maybe<Scalars['String']['output']>;
  matchRoundList?: Maybe<Array<Maybe<CompetitionCalendarAndResultsMatchRound>>>;
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CompetitionCalendarAndResultsMatch = {
  __typename?: 'CompetitionCalendarAndResultsMatch';
  away?: Maybe<CompetitionCalendarAndResultsTeam>;
  competitionPhaseRound?: Maybe<Scalars['String']['output']>;
  competitionPhaseWinnerTeamId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  home?: Maybe<CompetitionCalendarAndResultsTeam>;
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  liveOnSky?: Maybe<Scalars['String']['output']>;
  roundGroup?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CompetitionCalendarAndResultsMatchDay = {
  __typename?: 'CompetitionCalendarAndResultsMatchDay';
  date?: Maybe<Scalars['String']['output']>;
  matchList?: Maybe<Array<Maybe<CompetitionCalendarAndResultsMatch>>>;
};

export type CompetitionCalendarAndResultsMatchDayInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  matchList?: InputMaybe<Array<InputMaybe<CompetitionCalendarAndResultsMatchInput>>>;
};

export type CompetitionCalendarAndResultsMatchInput = {
  away?: InputMaybe<CompetitionCalendarAndResultsTeamInput>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseWinnerTeamId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<CompetitionCalendarAndResultsTeamInput>;
  id: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  liveOnSky?: InputMaybe<Scalars['String']['input']>;
  roundGroup?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionCalendarAndResultsMatchRound = {
  __typename?: 'CompetitionCalendarAndResultsMatchRound';
  competitionPhase?: Maybe<Scalars['String']['output']>;
  matchDayList?: Maybe<Array<Maybe<CompetitionCalendarAndResultsMatchDay>>>;
  round?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CompetitionCalendarAndResultsMatchRoundInput = {
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  matchDayList?: InputMaybe<Array<InputMaybe<CompetitionCalendarAndResultsMatchDayInput>>>;
  round?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionCalendarAndResultsTeam = {
  __typename?: 'CompetitionCalendarAndResultsTeam';
  goal?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  overtimeGoal?: Maybe<Scalars['Int']['output']>;
  penaltiesGoal?: Maybe<Scalars['Int']['output']>;
  regularTimeGoal?: Maybe<Scalars['Int']['output']>;
  seoName?: Maybe<Scalars['String']['output']>;
  shootoutGoal?: Maybe<Scalars['Int']['output']>;
  totalGoalLegs?: Maybe<Scalars['Int']['output']>;
};

export type CompetitionCalendarAndResultsTeamInput = {
  goal?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overtimeGoal?: InputMaybe<Scalars['Int']['input']>;
  penaltiesGoal?: InputMaybe<Scalars['Int']['input']>;
  regularTimeGoal?: InputMaybe<Scalars['Int']['input']>;
  seoName?: InputMaybe<Scalars['String']['input']>;
  shootoutGoal?: InputMaybe<Scalars['Int']['input']>;
  totalGoalLegs?: InputMaybe<Scalars['Int']['input']>;
};

export type CompetitionRanking = {
  __typename?: 'CompetitionRanking';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  rankingLists?: Maybe<Array<Maybe<CompetitionRankingRankingList>>>;
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CompetitionRankingGroup = {
  __typename?: 'CompetitionRankingGroup';
  roundName?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Maybe<CompetitionRankingTeam>>>;
};

export type CompetitionRankingGroupInput = {
  roundName?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<InputMaybe<CompetitionRankingTeamInput>>>;
};

export type CompetitionRankingLastMatchesTrend = {
  __typename?: 'CompetitionRankingLastMatchesTrend';
  away?: Maybe<CompetitionRankingTrend>;
  home?: Maybe<CompetitionRankingTrend>;
  label?: Maybe<Scalars['String']['output']>;
};

export type CompetitionRankingLastMatchesTrendInput = {
  away?: InputMaybe<CompetitionRankingTrendInput>;
  home?: InputMaybe<CompetitionRankingTrendInput>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionRankingRankingList = {
  __typename?: 'CompetitionRankingRankingList';
  competitionId: Scalars['ID']['output'];
  customCompetitionName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<CompetitionRankingGroup>>>;
  seasonId: Scalars['ID']['output'];
};

export type CompetitionRankingRankingListInput = {
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<CompetitionRankingGroupInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type CompetitionRankingTeam = {
  __typename?: 'CompetitionRankingTeam';
  games?: Maybe<Scalars['Int']['output']>;
  gamesDraw?: Maybe<Scalars['Int']['output']>;
  gamesLost?: Maybe<Scalars['Int']['output']>;
  gamesWon?: Maybe<Scalars['Int']['output']>;
  goalsConceded?: Maybe<Scalars['Int']['output']>;
  goalsDifference?: Maybe<Scalars['Int']['output']>;
  goalsScored?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastMatchesTrend?: Maybe<Array<Maybe<CompetitionRankingLastMatchesTrend>>>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  qualification?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  teamUrl?: Maybe<Scalars['String']['output']>;
  trend?: Maybe<Scalars['String']['output']>;
};

export type CompetitionRankingTeamInput = {
  games?: InputMaybe<Scalars['Int']['input']>;
  gamesDraw?: InputMaybe<Scalars['Int']['input']>;
  gamesLost?: InputMaybe<Scalars['Int']['input']>;
  gamesWon?: InputMaybe<Scalars['Int']['input']>;
  goalsConceded?: InputMaybe<Scalars['Int']['input']>;
  goalsDifference?: InputMaybe<Scalars['Int']['input']>;
  goalsScored?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  lastMatchesTrend?: InputMaybe<Array<InputMaybe<CompetitionRankingLastMatchesTrendInput>>>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  qualification?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  teamUrl?: InputMaybe<Scalars['String']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionRankingTrend = {
  __typename?: 'CompetitionRankingTrend';
  goal?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CompetitionRankingTrendInput = {
  goal?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionReports = {
  __typename?: 'CompetitionReports';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  reports?: Maybe<Array<Maybe<CompetitionReportsList>>>;
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CompetitionReportsList = {
  __typename?: 'CompetitionReportsList';
  competitionPhase?: Maybe<Scalars['String']['output']>;
  matchList?: Maybe<Array<Maybe<CompetitionReportsMatch>>>;
  reportsDetailsUrl?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['Int']['output']>;
};

export type CompetitionReportsListInput = {
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  matchList?: InputMaybe<Array<InputMaybe<CompetitionReportsMatchInput>>>;
  reportsDetailsUrl?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Int']['input']>;
};

export type CompetitionReportsMatch = {
  __typename?: 'CompetitionReportsMatch';
  away?: Maybe<CompetitionReportsMatchTeam>;
  date?: Maybe<Scalars['String']['output']>;
  home?: Maybe<CompetitionReportsMatchTeam>;
  matchId?: Maybe<Scalars['ID']['output']>;
  reportStatus?: Maybe<Scalars['String']['output']>;
  reportUrl?: Maybe<Scalars['String']['output']>;
  roundGroup?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusLabel?: Maybe<Scalars['String']['output']>;
};

export type CompetitionReportsMatchInput = {
  away?: InputMaybe<CompetitionReportsMatchTeamInput>;
  date?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<CompetitionReportsMatchTeamInput>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  reportStatus?: InputMaybe<Scalars['String']['input']>;
  reportUrl?: InputMaybe<Scalars['String']['input']>;
  roundGroup?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionReportsMatchTeam = {
  __typename?: 'CompetitionReportsMatchTeam';
  goal?: Maybe<Scalars['Int']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  seoName?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['ID']['output']>;
};

export type CompetitionReportsMatchTeamInput = {
  goal?: InputMaybe<Scalars['Int']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seoName?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type CompetitionScorersRanking = {
  __typename?: 'CompetitionScorersRanking';
  competitionId: Scalars['ID']['output'];
  competitionScorersUrl?: Maybe<Scalars['String']['output']>;
  competitionSeoName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  page: Scalars['String']['output'];
  pages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  scorers?: Maybe<Array<Maybe<CompetitionScorersRankingScorer>>>;
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CompetitionScorersRankingScorer = {
  __typename?: 'CompetitionScorersRankingScorer';
  areaIn?: Maybe<Scalars['Int']['output']>;
  areaOut?: Maybe<Scalars['Int']['output']>;
  goal?: Maybe<Scalars['Int']['output']>;
  head?: Maybe<Scalars['Int']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  penalty?: Maybe<Scalars['Int']['output']>;
  playerId?: Maybe<Scalars['ID']['output']>;
  playerName?: Maybe<Scalars['String']['output']>;
  playerPageLink?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  seoTeamName?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['ID']['output']>;
  teamUrl?: Maybe<Scalars['String']['output']>;
};

export type CompetitionScorersRankingScorerInput = {
  areaIn?: InputMaybe<Scalars['Int']['input']>;
  areaOut?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['Int']['input']>;
  head?: InputMaybe<Scalars['Int']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  penalty?: InputMaybe<Scalars['Int']['input']>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  playerName?: InputMaybe<Scalars['String']['input']>;
  playerPageLink?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  seoTeamName?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  teamUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionTeam = {
  __typename?: 'CompetitionTeam';
  competitions?: Maybe<Array<Maybe<CompetitionTeamCompetition>>>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CompetitionTeamCompetition = {
  __typename?: 'CompetitionTeamCompetition';
  homepageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  seasonAndCompId: Scalars['ID']['output'];
  seasonLabel?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Maybe<CompetitionTeamTeam>>>;
};

export type CompetitionTeamCompetitionInput = {
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonLabel?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<InputMaybe<CompetitionTeamTeamInput>>>;
};

export type CompetitionTeamTeam = {
  __typename?: 'CompetitionTeamTeam';
  homepageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CompetitionTeamTeamInput = {
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ComposerListCompetitions = {
  __typename?: 'ComposerListCompetitions';
  items: Array<Maybe<Competition>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type CreateCalendarAndResultsGliderInput = {
  competitionId: Scalars['ID']['input'];
  currentRound?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Array<InputMaybe<CalendarAndResultsGliderRoundInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type CreateCardCompetitionCalendarInput = {
  calendarAndResultsLink?: InputMaybe<Scalars['String']['input']>;
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  matchRoundList?: InputMaybe<Array<InputMaybe<CardCompetitionCalendarMatchRoundInput>>>;
};

export type CreateCardCompetitionRankingInput = {
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<CardCompetitionRankingGroupInput>>>;
  rankingLink?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompetitionBoardInput = {
  boardSponsorLink?: InputMaybe<Scalars['String']['input']>;
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  matchList?: InputMaybe<Array<InputMaybe<CompetitionBoardPhaseRoundInput>>>;
};

export type CreateCompetitionCalendarAndResultsInput = {
  competitionId: Scalars['ID']['input'];
  currentRound?: InputMaybe<Scalars['Int']['input']>;
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  matchRoundList?: InputMaybe<Array<InputMaybe<CompetitionCalendarAndResultsMatchRoundInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type CreateCompetitionInput = {
  competitionId: Scalars['ID']['input'];
  competitionJson: Scalars['AWSJSON']['input'];
  editorialDataId: Scalars['ID']['input'];
  previousSeasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CreateCompetitionRankingInput = {
  competitionId: Scalars['ID']['input'];
  rankingLists?: InputMaybe<Array<InputMaybe<CompetitionRankingRankingListInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type CreateCompetitionReportsInput = {
  competitionId: Scalars['ID']['input'];
  reports?: InputMaybe<Array<InputMaybe<CompetitionReportsListInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type CreateCompetitionScorersRankingInput = {
  competitionId: Scalars['ID']['input'];
  competitionScorersUrl?: InputMaybe<Scalars['String']['input']>;
  competitionSeoName?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['String']['input'];
  pages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scorers?: InputMaybe<Array<InputMaybe<CompetitionScorersRankingScorerInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type CreateCompetitionTeamInput = {
  competitions?: InputMaybe<Array<InputMaybe<CompetitionTeamCompetitionInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCrossLinkInput = {
  crossLinkJson: Scalars['AWSJSON']['input'];
  matchId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type CreateEditorialDataInput = {
  editorialDataId: Scalars['ID']['input'];
  editorialJson: Scalars['AWSJSON']['input'];
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
};

export type CreateLastAndNextMatchInput = {
  lastMatch?: InputMaybe<LastAndNextMatchMatchInput>;
  nextMatch?: InputMaybe<LastAndNextMatchMatchInput>;
  teamId: Scalars['ID']['input'];
};

export type CreateLiveScoreInput = {
  currentDay?: InputMaybe<Array<InputMaybe<LiveScoreDayInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  nextDay?: InputMaybe<Array<InputMaybe<LiveScoreDayInput>>>;
  previousDay?: InputMaybe<Array<InputMaybe<LiveScoreDayInput>>>;
};

export type CreateLmpHeroInput = {
  away?: InputMaybe<LmpHeroTeamInput>;
  competition?: InputMaybe<LmpHeroCompetitionInput>;
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseWinnerTeamId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  hasFollowMatch?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<LmpHeroTeamInput>;
  matchDetailUrl?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['ID']['input'];
  round?: InputMaybe<Scalars['Int']['input']>;
  roundGroup?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusStartDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  venue?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLmpHeroStickyInput = {
  away?: InputMaybe<LmpHeroTeamInput>;
  competition?: InputMaybe<LmpHeroCompetitionInput>;
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseWinnerTeamId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  home?: InputMaybe<LmpHeroTeamInput>;
  matchDetailUrl?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['ID']['input'];
  round?: InputMaybe<Scalars['Int']['input']>;
  roundGroup?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusStartDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  venue?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLmpLineupInput = {
  away?: InputMaybe<LmpLineupTeamInput>;
  home?: InputMaybe<LmpLineupTeamInput>;
  matchId: Scalars['ID']['input'];
  referees?: InputMaybe<Array<InputMaybe<LmpLineupRefereeInput>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLmpMatchChangeInput = {
  matchId: Scalars['ID']['input'];
  matchList?: InputMaybe<Array<InputMaybe<LmpMatchChangeMatchInput>>>;
};

export type CreateLmpPredictedLineupDetailsInput = {
  away?: InputMaybe<LmpPredictedLineupDetailsTeamInput>;
  date?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<LmpPredictedLineupDetailsTeamInput>;
  matchId: Scalars['ID']['input'];
  round?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLmpPreviewTextInput = {
  away?: InputMaybe<LmpPreviewTextDataTeamInput>;
  calendar?: InputMaybe<LmpPreviewTextDataInfoInput>;
  competition?: InputMaybe<LmpPreviewTextDataInfoInput>;
  competitionName?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<LmpPreviewTextDataTeamInput>;
  matchId: Scalars['ID']['input'];
  matchStartDateTime?: InputMaybe<Scalars['String']['input']>;
  ranking?: InputMaybe<LmpPreviewTextDataInfoInput>;
  results?: InputMaybe<LmpPreviewTextDataInfoInput>;
  venue?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLmpStatisticsInput = {
  away?: InputMaybe<LmpStatisticsTeamInput>;
  home?: InputMaybe<LmpStatisticsTeamInput>;
  matchId: Scalars['ID']['input'];
  matchStatisticsList?: InputMaybe<Array<InputMaybe<LmpStatisticsMatchStatisticsInput>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMatchCardInput = {
  away?: InputMaybe<MatchCardTeamInput>;
  competition?: InputMaybe<MatchCardCompetitionInput>;
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseWinnerTeamId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  home?: InputMaybe<MatchCardTeamInput>;
  matchDetailUrl?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMatchChangeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  matchList?: InputMaybe<Array<InputMaybe<MatchChangeMatchInput>>>;
};

export type CreateMatchCommentInput = {
  commentId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['String']['input']>;
  matchCommentJson: Scalars['AWSJSON']['input'];
  matchId: Scalars['ID']['input'];
  minute?: InputMaybe<Scalars['Int']['input']>;
  player1Id?: InputMaybe<Scalars['ID']['input']>;
  player2Id?: InputMaybe<Scalars['ID']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  second?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMatchCommentsInput = {
  awayTeam?: InputMaybe<SeoCustomDataInput>;
  comments?: InputMaybe<Array<InputMaybe<MatchCommentsCommentInput>>>;
  competition?: InputMaybe<SeoCustomDataInput>;
  firstCommentDate?: InputMaybe<Scalars['String']['input']>;
  homeTeam?: InputMaybe<SeoCustomDataInput>;
  lastCommentDate?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['ID']['input'];
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pagination?: InputMaybe<MatchCommentsPaginationInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMatchDataInput = {
  data: Scalars['AWSJSON']['input'];
  matchId: Scalars['ID']['input'];
  messageType: Scalars['String']['input'];
};

export type CreateMatchInput = {
  awayTeamId: Scalars['ID']['input'];
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Int']['input'];
  homeTeamId: Scalars['ID']['input'];
  matchId: Scalars['ID']['input'];
  matchJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  refereeId?: InputMaybe<Scalars['String']['input']>;
  round: Scalars['Int']['input'];
  roundGroup?: InputMaybe<Scalars['String']['input']>;
  scheduleJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

export type CreateNotificationMatchInput = {
  away?: InputMaybe<NotificationMatchTeamInput>;
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseWinnerTeamId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  home?: InputMaybe<NotificationMatchTeamInput>;
  matchDetailUrl?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['ID']['input'];
  matchJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  round?: InputMaybe<Scalars['Int']['input']>;
  roundGroup?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updates?: InputMaybe<NotificationMatchUpdatesInput>;
};

export type CreatePlayerDataInput = {
  action: Scalars['String']['input'];
  competitionId: Scalars['String']['input'];
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
  messageType: Scalars['String']['input'];
  playerId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  seasonId: Scalars['String']['input'];
};

export type CreatePlayerInput = {
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  playerId: Scalars['ID']['input'];
  playerJson: Scalars['AWSJSON']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type CreatePlayerPagesStatsInput = {
  playerId: Scalars['ID']['input'];
  playerRole: Scalars['String']['input'];
  statistics?: InputMaybe<Array<InputMaybe<PlayerPagesStatsSeasonCompStatInput>>>;
};

export type CreatePlayerRankingInput = {
  playerId: Scalars['ID']['input'];
  playerRankingJson: Scalars['AWSJSON']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type CreatePlayerStatsInput = {
  playerId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  statsJson?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type CreatePredictedLineupDetailsInput = {
  competitionId: Scalars['ID']['input'];
  hasHeadshots?: InputMaybe<Scalars['Boolean']['input']>;
  matchData?: InputMaybe<PredictedLineupMatchInput>;
  predictedHpLink?: InputMaybe<Scalars['String']['input']>;
  predictedSponsorLink?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['ID']['input'];
};

export type CreatePredictedLineupHomepageInput = {
  competitionId: Scalars['ID']['input'];
  matchList?: InputMaybe<Array<InputMaybe<PredictedLineupMatchInput>>>;
  round: Scalars['String']['input'];
};

export type CreatePredictedLineupInput = {
  awayTeamId: Scalars['ID']['input'];
  homeTeamId: Scalars['ID']['input'];
  matchId: Scalars['ID']['input'];
  predictedLineupJson: Scalars['AWSJSON']['input'];
  round: Scalars['Int']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

export type CreatePredictedLineupRoundInput = {
  round: Scalars['Int']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type CreateRankingInput = {
  matchDayId: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
  rankingJson: Scalars['AWSJSON']['input'];
  roundName: Scalars['String']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type CreateReportDetailsInput = {
  competitionId: Scalars['ID']['input'];
  reports?: InputMaybe<Array<InputMaybe<ReportDetailsMatchInput>>>;
  reportsHomepageUrl?: InputMaybe<Scalars['String']['input']>;
  round: Scalars['Int']['input'];
  seasonId: Scalars['ID']['input'];
};

export type CreateReportInput = {
  matchId: Scalars['ID']['input'];
  reportJson: Scalars['AWSJSON']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

export type CreateScorersRankingPlayerPageInput = {
  competitionCalendarUrl?: InputMaybe<Scalars['String']['input']>;
  competitionId: Scalars['ID']['input'];
  competitionName?: InputMaybe<Scalars['String']['input']>;
  competitionSlugName?: InputMaybe<Scalars['String']['input']>;
  scorers?: InputMaybe<Array<InputMaybe<ScorersRankingInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type CreateSeasonInput = {
  editorialData?: InputMaybe<Scalars['AWSJSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTeamCalendarAndResultsInput = {
  matchDayList?: InputMaybe<Array<InputMaybe<CalendarAndResultsMatchDayListInput>>>;
  teamId: Scalars['ID']['input'];
};

export type CreateTeamInput = {
  editorialDataId: Scalars['ID']['input'];
  isPlaceholder?: InputMaybe<Scalars['Boolean']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  teamJson: Scalars['AWSJSON']['input'];
};

export type CreateTeamPlayersInput = {
  competition?: InputMaybe<TeamPlayersCompetitionInput>;
  players?: InputMaybe<Array<InputMaybe<TeamPlayersPlayerInput>>>;
  season?: InputMaybe<TeamPlayersSeasonInput>;
  team?: InputMaybe<TeamPlayersTeamInput>;
  teamId: Scalars['ID']['input'];
};

export type CreateTeamRankingInput = {
  rankingLists?: InputMaybe<Array<InputMaybe<TeamRankingRankingListInput>>>;
  teamId: Scalars['ID']['input'];
};

export type CrossLink = {
  __typename?: 'CrossLink';
  createdAt: Scalars['AWSDateTime']['output'];
  crossLinkJson: Scalars['AWSJSON']['output'];
  matchId: Scalars['ID']['output'];
  seasonAndCompId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CurrentRound = {
  __typename?: 'CurrentRound';
  round?: Maybe<Scalars['Int']['output']>;
};

export type CurrentTime = {
  __typename?: 'CurrentTime';
  currentTime?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type DayItem = {
  __typename?: 'DayItem';
  competitionPhase?: Maybe<Scalars['String']['output']>;
  competitionPhaseRound?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['Int']['output']>;
};

export type DayList = {
  __typename?: 'DayList';
  items?: Maybe<Array<Maybe<DayItem>>>;
};

export type DeleteCalendarAndResultsGliderInput = {
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type DeleteCardCompetitionCalendarInput = {
  competitionId: Scalars['ID']['input'];
};

export type DeleteCardCompetitionRankingInput = {
  competitionId: Scalars['ID']['input'];
};

export type DeleteCompetitionBoardInput = {
  competitionId: Scalars['ID']['input'];
};

export type DeleteCompetitionCalendarAndResultsInput = {
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type DeleteCompetitionInput = {
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteCompetitionRankingInput = {
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type DeleteCompetitionReportsInput = {
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type DeleteCompetitionScorersRankingInput = {
  competitionId: Scalars['ID']['input'];
  page: Scalars['String']['input'];
  seasonId: Scalars['ID']['input'];
};

export type DeleteCompetitionTeamInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCrossLinkInput = {
  matchId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteEditorialDataInput = {
  editorialDataId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteLastAndNextMatchInput = {
  teamId: Scalars['ID']['input'];
};

export type DeleteLiveScoreInput = {
  id: Scalars['ID']['input'];
};

export type DeleteLmpHeroInput = {
  matchId: Scalars['ID']['input'];
};

export type DeleteLmpHeroStickyInput = {
  matchId: Scalars['ID']['input'];
};

export type DeleteLmpLineupInput = {
  matchId: Scalars['ID']['input'];
};

export type DeleteLmpMatchChangeInput = {
  matchId: Scalars['ID']['input'];
};

export type DeleteLmpPredictedLineupDetailsInput = {
  matchId: Scalars['ID']['input'];
};

export type DeleteLmpPreviewTextInput = {
  matchId: Scalars['ID']['input'];
};

export type DeleteLmpStatisticsInput = {
  matchId: Scalars['ID']['input'];
};

export type DeleteMatchCardInput = {
  matchId: Scalars['ID']['input'];
};

export type DeleteMatchChangeInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMatchCommentInput = {
  commentId: Scalars['ID']['input'];
  matchId: Scalars['ID']['input'];
};

export type DeleteMatchCommentsInput = {
  matchId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
};

export type DeleteMatchDataInput = {
  matchId: Scalars['ID']['input'];
};

export type DeleteMatchInput = {
  matchId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteNotificationMatchInput = {
  matchId: Scalars['ID']['input'];
};

export type DeletePlayerDataInput = {
  playerId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeletePlayerInput = {
  playerId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeletePlayerPagesStatsInput = {
  playerId: Scalars['ID']['input'];
};

export type DeletePlayerRankingInput = {
  playerId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeletePlayerStatsInput = {
  playerId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeletePredictedLineupDetailsInput = {
  competitionId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type DeletePredictedLineupHomepageInput = {
  competitionId: Scalars['ID']['input'];
};

export type DeletePredictedLineupInput = {
  matchId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeletePredictedLineupRoundInput = {
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteRankingInput = {
  seasonAndCompId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type DeleteReportDetailsInput = {
  competitionId: Scalars['ID']['input'];
  round: Scalars['Int']['input'];
  seasonId: Scalars['ID']['input'];
};

export type DeleteReportInput = {
  matchId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type DeleteScorersRankingPlayerPageInput = {
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};

export type DeleteSeasonInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTeamCalendarAndResultsInput = {
  teamId: Scalars['ID']['input'];
};

export type DeleteTeamInput = {
  seasonAndCompId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type DeleteTeamPlayersInput = {
  teamId: Scalars['ID']['input'];
};

export type DeleteTeamRankingInput = {
  teamId: Scalars['ID']['input'];
};

export type EditorialData = {
  __typename?: 'EditorialData';
  competition?: Maybe<Competition>;
  createdAt: Scalars['AWSDateTime']['output'];
  editorialDataId: Scalars['ID']['output'];
  editorialJson: Scalars['AWSJSON']['output'];
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  seasonAndCompId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LastAndNextMatch = {
  __typename?: 'LastAndNextMatch';
  createdAt: Scalars['AWSDateTime']['output'];
  lastMatch?: Maybe<LastAndNextMatchMatch>;
  nextMatch?: Maybe<LastAndNextMatchMatch>;
  teamId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LastAndNextMatchMatch = {
  __typename?: 'LastAndNextMatchMatch';
  away?: Maybe<LastAndNextMatchMatchTeam>;
  competition?: Maybe<LastAndNextMatchMatchCompetition>;
  competitionPhase?: Maybe<Scalars['String']['output']>;
  competitionPhaseRound?: Maybe<Scalars['String']['output']>;
  competitionPhaseWinnerTeamId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  home?: Maybe<LastAndNextMatchMatchTeam>;
  id?: Maybe<Scalars['ID']['output']>;
  liveOnSky?: Maybe<Scalars['String']['output']>;
  matchDetailUrl?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['Int']['output']>;
  roundGroup?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LastAndNextMatchMatchCompetition = {
  __typename?: 'LastAndNextMatchMatchCompetition';
  homepageUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LastAndNextMatchMatchCompetitionInput = {
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LastAndNextMatchMatchInput = {
  away?: InputMaybe<LastAndNextMatchMatchTeamInput>;
  competition?: InputMaybe<LastAndNextMatchMatchCompetitionInput>;
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseWinnerTeamId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<LastAndNextMatchMatchTeamInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  liveOnSky?: InputMaybe<Scalars['String']['input']>;
  matchDetailUrl?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Int']['input']>;
  roundGroup?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type LastAndNextMatchMatchTeam = {
  __typename?: 'LastAndNextMatchMatchTeam';
  goal?: Maybe<Scalars['Int']['output']>;
  homepageUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  overtimeGoal?: Maybe<Scalars['Int']['output']>;
  penaltiesGoal?: Maybe<Scalars['Int']['output']>;
  regularTimeGoal?: Maybe<Scalars['Int']['output']>;
  shootoutGoal?: Maybe<Scalars['Int']['output']>;
  totalGoalLegs?: Maybe<Scalars['Int']['output']>;
};

export type LastAndNextMatchMatchTeamInput = {
  goal?: InputMaybe<Scalars['Int']['input']>;
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overtimeGoal?: InputMaybe<Scalars['Int']['input']>;
  penaltiesGoal?: InputMaybe<Scalars['Int']['input']>;
  regularTimeGoal?: InputMaybe<Scalars['Int']['input']>;
  shootoutGoal?: InputMaybe<Scalars['Int']['input']>;
  totalGoalLegs?: InputMaybe<Scalars['Int']['input']>;
};

export type LiveScore = {
  __typename?: 'LiveScore';
  createdAt: Scalars['AWSDateTime']['output'];
  currentDay?: Maybe<Array<Maybe<LiveScoreDay>>>;
  id: Scalars['ID']['output'];
  nextDay?: Maybe<Array<Maybe<LiveScoreDay>>>;
  previousDay?: Maybe<Array<Maybe<LiveScoreDay>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LiveScoreDay = {
  __typename?: 'LiveScoreDay';
  calendarResultsUrl?: Maybe<Scalars['String']['output']>;
  competitionBoardUrl?: Maybe<Scalars['String']['output']>;
  competitionId: Scalars['ID']['output'];
  customCompetitionName?: Maybe<Scalars['String']['output']>;
  matchRoundList?: Maybe<Array<Maybe<LiveScoreDayRound>>>;
  rankingUrl?: Maybe<Scalars['String']['output']>;
  seasonId: Scalars['ID']['output'];
};

export type LiveScoreDayInput = {
  calendarResultsUrl?: InputMaybe<Scalars['String']['input']>;
  competitionBoardUrl?: InputMaybe<Scalars['String']['input']>;
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  matchRoundList?: InputMaybe<Array<InputMaybe<LiveScoreDayRoundInput>>>;
  rankingUrl?: InputMaybe<Scalars['String']['input']>;
  seasonId: Scalars['ID']['input'];
};

export type LiveScoreDayMatch = {
  __typename?: 'LiveScoreDayMatch';
  away?: Maybe<LiveScoreTeam>;
  competitionPhaseWinnerTeamId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  home?: Maybe<LiveScoreTeam>;
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LiveScoreDayMatchDay = {
  __typename?: 'LiveScoreDayMatchDay';
  date?: Maybe<Scalars['String']['output']>;
  matchList?: Maybe<Array<Maybe<LiveScoreDayMatch>>>;
};

export type LiveScoreDayMatchDayInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  matchList?: InputMaybe<Array<InputMaybe<LiveScoreDayMatchInput>>>;
};

export type LiveScoreDayMatchInput = {
  away?: InputMaybe<LiveScoreTeamInput>;
  competitionPhaseWinnerTeamId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<LiveScoreTeamInput>;
  id: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type LiveScoreDayRound = {
  __typename?: 'LiveScoreDayRound';
  competitionPhase?: Maybe<Scalars['String']['output']>;
  matchDayList?: Maybe<Array<Maybe<LiveScoreDayMatchDay>>>;
  round?: Maybe<Scalars['Int']['output']>;
};

export type LiveScoreDayRoundInput = {
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  matchDayList?: InputMaybe<Array<InputMaybe<LiveScoreDayMatchDayInput>>>;
  round?: InputMaybe<Scalars['Int']['input']>;
};

export type LiveScoreTeam = {
  __typename?: 'LiveScoreTeam';
  goal?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  overtimeGoal?: Maybe<Scalars['Int']['output']>;
  penaltiesGoal?: Maybe<Scalars['Int']['output']>;
  regularTimeGoal?: Maybe<Scalars['Int']['output']>;
  seoName?: Maybe<Scalars['String']['output']>;
  shootoutGoal?: Maybe<Scalars['Int']['output']>;
  totalGoalLegs?: Maybe<Scalars['Int']['output']>;
};

export type LiveScoreTeamInput = {
  goal?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overtimeGoal?: InputMaybe<Scalars['Int']['input']>;
  penaltiesGoal?: InputMaybe<Scalars['Int']['input']>;
  regularTimeGoal?: InputMaybe<Scalars['Int']['input']>;
  seoName?: InputMaybe<Scalars['String']['input']>;
  shootoutGoal?: InputMaybe<Scalars['Int']['input']>;
  totalGoalLegs?: InputMaybe<Scalars['Int']['input']>;
};

export type LmpHero = {
  __typename?: 'LmpHero';
  away?: Maybe<LmpHeroTeam>;
  competition?: Maybe<LmpHeroCompetition>;
  competitionPhase?: Maybe<Scalars['String']['output']>;
  competitionPhaseRound?: Maybe<Scalars['String']['output']>;
  competitionPhaseWinnerTeamId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  date?: Maybe<Scalars['AWSDateTime']['output']>;
  hasFollowMatch?: Maybe<Scalars['Boolean']['output']>;
  home?: Maybe<LmpHeroTeam>;
  matchDetailUrl?: Maybe<Scalars['String']['output']>;
  matchId: Scalars['ID']['output'];
  round?: Maybe<Scalars['Int']['output']>;
  roundGroup?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusStartDateTime?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  venue?: Maybe<Scalars['String']['output']>;
};

export type LmpHeroCompetition = {
  __typename?: 'LmpHeroCompetition';
  homepageUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LmpHeroCompetitionInput = {
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LmpHeroScoreboard = {
  __typename?: 'LmpHeroScoreboard';
  matchStatus?: Maybe<Scalars['String']['output']>;
  minute?: Maybe<Scalars['Int']['output']>;
  player?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LmpHeroScoreboardInput = {
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  minute?: InputMaybe<Scalars['Int']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type LmpHeroSticky = {
  __typename?: 'LmpHeroSticky';
  away?: Maybe<LmpHeroTeam>;
  competition?: Maybe<LmpHeroCompetition>;
  competitionPhase?: Maybe<Scalars['String']['output']>;
  competitionPhaseRound?: Maybe<Scalars['String']['output']>;
  competitionPhaseWinnerTeamId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  date?: Maybe<Scalars['AWSDateTime']['output']>;
  home?: Maybe<LmpHeroTeam>;
  matchDetailUrl?: Maybe<Scalars['String']['output']>;
  matchId: Scalars['ID']['output'];
  round?: Maybe<Scalars['Int']['output']>;
  roundGroup?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusStartDateTime?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  venue?: Maybe<Scalars['String']['output']>;
};

export type LmpHeroTeam = {
  __typename?: 'LmpHeroTeam';
  goal?: Maybe<Scalars['Int']['output']>;
  homepageUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  negativeLogoUrl?: Maybe<Scalars['String']['output']>;
  overtimeGoal?: Maybe<Scalars['Int']['output']>;
  penaltiesGoal?: Maybe<Scalars['Int']['output']>;
  regularTimeGoal?: Maybe<Scalars['Int']['output']>;
  scoreboard?: Maybe<Array<Maybe<LmpHeroScoreboard>>>;
  seoName?: Maybe<Scalars['String']['output']>;
  shootoutGoal?: Maybe<Scalars['Int']['output']>;
  totalGoalLegs?: Maybe<Scalars['Int']['output']>;
};

export type LmpHeroTeamInput = {
  goal?: InputMaybe<Scalars['Int']['input']>;
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  negativeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  overtimeGoal?: InputMaybe<Scalars['Int']['input']>;
  penaltiesGoal?: InputMaybe<Scalars['Int']['input']>;
  regularTimeGoal?: InputMaybe<Scalars['Int']['input']>;
  scoreboard?: InputMaybe<Array<InputMaybe<LmpHeroScoreboardInput>>>;
  seoName?: InputMaybe<Scalars['String']['input']>;
  shootoutGoal?: InputMaybe<Scalars['Int']['input']>;
  totalGoalLegs?: InputMaybe<Scalars['Int']['input']>;
};

export type LmpLineup = {
  __typename?: 'LmpLineup';
  away?: Maybe<LmpLineupTeam>;
  createdAt: Scalars['AWSDateTime']['output'];
  home?: Maybe<LmpLineupTeam>;
  matchId: Scalars['ID']['output'];
  referees?: Maybe<Array<Maybe<LmpLineupReferee>>>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LmpLineupEvent = {
  __typename?: 'LmpLineupEvent';
  id?: Maybe<Scalars['ID']['output']>;
  minutes?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LmpLineupEventInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  minutes?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type LmpLineupManager = {
  __typename?: 'LmpLineupManager';
  fullname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type LmpLineupManagerInput = {
  fullname?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type LmpLineupPlayerDetails = {
  __typename?: 'LmpLineupPlayerDetails';
  formationPlace?: Maybe<Scalars['String']['output']>;
  fullname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  jerseyNum?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  playerPageLink?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type LmpLineupPlayerDetailsInput = {
  formationPlace?: InputMaybe<Scalars['String']['input']>;
  fullname?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jerseyNum?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  playerPageLink?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type LmpLineupPlayerList = {
  __typename?: 'LmpLineupPlayerList';
  manager?: Maybe<LmpLineupManager>;
  startingLineup?: Maybe<Array<Maybe<LmpLineupPlayerDetails>>>;
  substitutes?: Maybe<Array<Maybe<LmpLineupPlayerDetails>>>;
};

export type LmpLineupPlayerListInput = {
  manager?: InputMaybe<LmpLineupManagerInput>;
  startingLineup?: InputMaybe<Array<InputMaybe<LmpLineupPlayerDetailsInput>>>;
  substitutes?: InputMaybe<Array<InputMaybe<LmpLineupPlayerDetailsInput>>>;
};

export type LmpLineupPlayerSubstitution = {
  __typename?: 'LmpLineupPlayerSubstitution';
  minutes?: Maybe<Scalars['Int']['output']>;
  playerIdIn?: Maybe<Scalars['ID']['output']>;
  playerIdOut?: Maybe<Scalars['ID']['output']>;
};

export type LmpLineupPlayerSubstitutionInput = {
  minutes?: InputMaybe<Scalars['Int']['input']>;
  playerIdIn?: InputMaybe<Scalars['ID']['input']>;
  playerIdOut?: InputMaybe<Scalars['ID']['input']>;
};

export type LmpLineupReferee = {
  __typename?: 'LmpLineupReferee';
  fullname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type LmpLineupRefereeInput = {
  fullname?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type LmpLineupTeam = {
  __typename?: 'LmpLineupTeam';
  formation?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<Array<Maybe<LmpLineupEvent>>>;
  id?: Maybe<Scalars['ID']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  negativeLogoUrl?: Maybe<Scalars['String']['output']>;
  playerList?: Maybe<LmpLineupPlayerList>;
  scorersCards?: Maybe<Array<Maybe<LmpLineupEvent>>>;
  substitution?: Maybe<Array<Maybe<LmpLineupPlayerSubstitution>>>;
  topPlayerId?: Maybe<Scalars['ID']['output']>;
};

export type LmpLineupTeamInput = {
  formation?: InputMaybe<Scalars['String']['input']>;
  goals?: InputMaybe<Array<InputMaybe<LmpLineupEventInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  negativeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  playerList?: InputMaybe<LmpLineupPlayerListInput>;
  scorersCards?: InputMaybe<Array<InputMaybe<LmpLineupEventInput>>>;
  substitution?: InputMaybe<Array<InputMaybe<LmpLineupPlayerSubstitutionInput>>>;
  topPlayerId?: InputMaybe<Scalars['ID']['input']>;
};

export type LmpMatchChange = {
  __typename?: 'LmpMatchChange';
  createdAt: Scalars['AWSDateTime']['output'];
  matchId: Scalars['ID']['output'];
  matchList?: Maybe<Array<Maybe<LmpMatchChangeMatch>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LmpMatchChangeMatch = {
  __typename?: 'LmpMatchChangeMatch';
  away?: Maybe<LmpMatchChangeTeam>;
  date?: Maybe<Scalars['AWSDateTime']['output']>;
  home?: Maybe<LmpMatchChangeTeam>;
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LmpMatchChangeMatchInput = {
  away?: InputMaybe<LmpMatchChangeTeamInput>;
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  home?: InputMaybe<LmpMatchChangeTeamInput>;
  id: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type LmpMatchChangeTeam = {
  __typename?: 'LmpMatchChangeTeam';
  goal?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
};

export type LmpMatchChangeTeamInput = {
  goal?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type LmpPredictedLineupDetails = {
  __typename?: 'LmpPredictedLineupDetails';
  away?: Maybe<LmpPredictedLineupDetailsTeam>;
  createdAt: Scalars['AWSDateTime']['output'];
  date?: Maybe<Scalars['String']['output']>;
  home?: Maybe<LmpPredictedLineupDetailsTeam>;
  matchId: Scalars['ID']['output'];
  round?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LmpPredictedLineupDetailsPlayer = {
  __typename?: 'LmpPredictedLineupDetailsPlayer';
  formationPlace?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  jerseyNum?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  playerPageLink?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type LmpPredictedLineupDetailsPlayerInput = {
  formationPlace?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  jerseyNum?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  playerPageLink?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type LmpPredictedLineupDetailsPlayerList = {
  __typename?: 'LmpPredictedLineupDetailsPlayerList';
  disqualifiedPlayers?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<Scalars['String']['output']>;
  potentialPlayers?: Maybe<Scalars['String']['output']>;
  predictedLineup?: Maybe<Array<Maybe<LmpPredictedLineupDetailsPlayer>>>;
  substitutePlayers?: Maybe<Scalars['String']['output']>;
  unavailablePlayers?: Maybe<Scalars['String']['output']>;
};

export type LmpPredictedLineupDetailsPlayerListInput = {
  disqualifiedPlayers?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<Scalars['String']['input']>;
  potentialPlayers?: InputMaybe<Scalars['String']['input']>;
  predictedLineup?: InputMaybe<Array<InputMaybe<LmpPredictedLineupDetailsPlayerInput>>>;
  substitutePlayers?: InputMaybe<Scalars['String']['input']>;
  unavailablePlayers?: InputMaybe<Scalars['String']['input']>;
};

export type LmpPredictedLineupDetailsTeam = {
  __typename?: 'LmpPredictedLineupDetailsTeam';
  customName?: Maybe<Scalars['String']['output']>;
  customSeoName?: Maybe<Scalars['String']['output']>;
  formation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  negativeLogoUrl?: Maybe<Scalars['String']['output']>;
  playerList?: Maybe<LmpPredictedLineupDetailsPlayerList>;
  predictedTeamLink?: Maybe<Scalars['String']['output']>;
  teamShortName?: Maybe<Scalars['String']['output']>;
};

export type LmpPredictedLineupDetailsTeamInput = {
  customName?: InputMaybe<Scalars['String']['input']>;
  customSeoName?: InputMaybe<Scalars['String']['input']>;
  formation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  negativeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  playerList?: InputMaybe<LmpPredictedLineupDetailsPlayerListInput>;
  predictedTeamLink?: InputMaybe<Scalars['String']['input']>;
  teamShortName?: InputMaybe<Scalars['String']['input']>;
};

export type LmpPreviewText = {
  __typename?: 'LmpPreviewText';
  away?: Maybe<LmpPreviewTextDataTeam>;
  calendar?: Maybe<LmpPreviewTextDataInfo>;
  competition?: Maybe<LmpPreviewTextDataInfo>;
  competitionName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  home?: Maybe<LmpPreviewTextDataTeam>;
  matchId: Scalars['ID']['output'];
  matchStartDateTime?: Maybe<Scalars['String']['output']>;
  ranking?: Maybe<LmpPreviewTextDataInfo>;
  results?: Maybe<LmpPreviewTextDataInfo>;
  updatedAt: Scalars['AWSDateTime']['output'];
  venue?: Maybe<Scalars['String']['output']>;
};

export type LmpPreviewTextDataInfo = {
  __typename?: 'LmpPreviewTextDataInfo';
  link?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type LmpPreviewTextDataInfoInput = {
  link?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type LmpPreviewTextDataTeam = {
  __typename?: 'LmpPreviewTextDataTeam';
  coach?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LmpPreviewTextDataTeamInput = {
  coach?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LmpStatistics = {
  __typename?: 'LmpStatistics';
  away?: Maybe<LmpStatisticsTeam>;
  createdAt: Scalars['AWSDateTime']['output'];
  home?: Maybe<LmpStatisticsTeam>;
  matchId: Scalars['ID']['output'];
  matchStatisticsList?: Maybe<Array<Maybe<LmpStatisticsMatchStatistics>>>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LmpStatisticsMatchStatistics = {
  __typename?: 'LmpStatisticsMatchStatistics';
  id?: Maybe<Scalars['ID']['output']>;
  value?: Maybe<LmpStatisticsValue>;
};

export type LmpStatisticsMatchStatisticsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<LmpStatisticsValueInput>;
};

export type LmpStatisticsTeam = {
  __typename?: 'LmpStatisticsTeam';
  id?: Maybe<Scalars['ID']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LmpStatisticsTeamInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LmpStatisticsValue = {
  __typename?: 'LmpStatisticsValue';
  away?: Maybe<Scalars['String']['output']>;
  home?: Maybe<Scalars['String']['output']>;
};

export type LmpStatisticsValueInput = {
  away?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<Scalars['String']['input']>;
};

export type Match = {
  __typename?: 'Match';
  awayTeam?: Maybe<Team>;
  awayTeamId: Scalars['ID']['output'];
  comments?: Maybe<ModelMatchCommentConnection>;
  competition?: Maybe<Competition>;
  competitionPhase?: Maybe<Scalars['String']['output']>;
  competitionPhaseRound?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  crossLink?: Maybe<CrossLink>;
  date: Scalars['Int']['output'];
  homeTeam?: Maybe<Team>;
  homeTeamId: Scalars['ID']['output'];
  matchId: Scalars['ID']['output'];
  matchJson?: Maybe<Scalars['AWSJSON']['output']>;
  predictedLineup?: Maybe<PredictedLineup>;
  refereeId?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Report>;
  round: Scalars['Int']['output'];
  roundGroup?: Maybe<Scalars['String']['output']>;
  scheduleJson?: Maybe<Scalars['AWSJSON']['output']>;
  seasonAndCompId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type MatchcommentsArgs = {
  filter?: InputMaybe<ModelMatchCommentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type MatchCard = {
  __typename?: 'MatchCard';
  away?: Maybe<MatchCardTeam>;
  competition?: Maybe<MatchCardCompetition>;
  competitionPhase?: Maybe<Scalars['String']['output']>;
  competitionPhaseRound?: Maybe<Scalars['String']['output']>;
  competitionPhaseWinnerTeamId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  date?: Maybe<Scalars['AWSDateTime']['output']>;
  home?: Maybe<MatchCardTeam>;
  matchDetailUrl?: Maybe<Scalars['String']['output']>;
  matchId: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type MatchCardCompetition = {
  __typename?: 'MatchCardCompetition';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MatchCardCompetitionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MatchCardScoreboard = {
  __typename?: 'MatchCardScoreboard';
  minute?: Maybe<Scalars['Int']['output']>;
  player?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MatchCardTeam = {
  __typename?: 'MatchCardTeam';
  goal?: Maybe<Scalars['Int']['output']>;
  homepageUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  negativeLogoUrl?: Maybe<Scalars['String']['output']>;
  overtimeGoal?: Maybe<Scalars['Int']['output']>;
  penaltiesGoal?: Maybe<Scalars['Int']['output']>;
  regularTimeGoal?: Maybe<Scalars['Int']['output']>;
  seoName?: Maybe<Scalars['String']['output']>;
  shootoutGoal?: Maybe<Scalars['Int']['output']>;
  totalGoalLegs?: Maybe<Scalars['Int']['output']>;
};

export type MatchCardTeamInput = {
  goal?: InputMaybe<Scalars['Int']['input']>;
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  negativeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  overtimeGoal?: InputMaybe<Scalars['Int']['input']>;
  penaltiesGoal?: InputMaybe<Scalars['Int']['input']>;
  regularTimeGoal?: InputMaybe<Scalars['Int']['input']>;
  seoName?: InputMaybe<Scalars['String']['input']>;
  shootoutGoal?: InputMaybe<Scalars['Int']['input']>;
  totalGoalLegs?: InputMaybe<Scalars['Int']['input']>;
};

export type MatchChange = {
  __typename?: 'MatchChange';
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  matchList?: Maybe<Array<Maybe<MatchChangeMatch>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type MatchChangeMatch = {
  __typename?: 'MatchChangeMatch';
  away?: Maybe<MatchChangeTeam>;
  competitionPhase?: Maybe<Scalars['String']['output']>;
  competitionPhaseRound?: Maybe<Scalars['String']['output']>;
  competitionPhaseWinnerTeamId?: Maybe<Scalars['String']['output']>;
  customCompetitionName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  hasVideoHighlights?: Maybe<Scalars['Boolean']['output']>;
  home?: Maybe<MatchChangeTeam>;
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type MatchChangeMatchInput = {
  away?: InputMaybe<MatchChangeTeamInput>;
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseWinnerTeamId?: InputMaybe<Scalars['String']['input']>;
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  hasVideoHighlights?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<MatchChangeTeamInput>;
  id: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type MatchChangeTeam = {
  __typename?: 'MatchChangeTeam';
  goal?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  negativeLogoUrl?: Maybe<Scalars['String']['output']>;
  overtimeGoal?: Maybe<Scalars['Int']['output']>;
  shootoutGoal?: Maybe<Scalars['Int']['output']>;
  totalGoalLegs?: Maybe<Scalars['Int']['output']>;
};

export type MatchChangeTeamInput = {
  goal?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  negativeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  overtimeGoal?: InputMaybe<Scalars['Int']['input']>;
  shootoutGoal?: InputMaybe<Scalars['Int']['input']>;
  totalGoalLegs?: InputMaybe<Scalars['Int']['input']>;
};

export type MatchComment = {
  __typename?: 'MatchComment';
  commentId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  matchCommentJson: Scalars['AWSJSON']['output'];
  matchId: Scalars['ID']['output'];
  minute?: Maybe<Scalars['Int']['output']>;
  player1?: Maybe<Player>;
  player1Id?: Maybe<Scalars['ID']['output']>;
  player2?: Maybe<Player>;
  player2Id?: Maybe<Scalars['ID']['output']>;
  seasonAndCompId: Scalars['ID']['output'];
  second?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type MatchComments = {
  __typename?: 'MatchComments';
  awayTeam?: Maybe<SeoCustomData>;
  comments?: Maybe<Array<Maybe<MatchCommentsComment>>>;
  competition?: Maybe<SeoCustomData>;
  createdAt: Scalars['AWSDateTime']['output'];
  firstCommentDate?: Maybe<Scalars['String']['output']>;
  homeTeam?: Maybe<SeoCustomData>;
  lastCommentDate?: Maybe<Scalars['String']['output']>;
  matchId: Scalars['ID']['output'];
  matchStatus?: Maybe<Scalars['String']['output']>;
  page: Scalars['Int']['output'];
  pagination?: Maybe<MatchCommentsPagination>;
  updatedAt: Scalars['AWSDateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type MatchCommentsComment = {
  __typename?: 'MatchCommentsComment';
  commentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type MatchCommentsCommentInput = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type MatchCommentsPagination = {
  __typename?: 'MatchCommentsPagination';
  items?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  nextLink?: Maybe<Scalars['String']['output']>;
  prevLink?: Maybe<Scalars['String']['output']>;
};

export type MatchCommentsPaginationInput = {
  items?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  nextLink?: InputMaybe<Scalars['String']['input']>;
  prevLink?: InputMaybe<Scalars['String']['input']>;
};

export type MatchData = {
  __typename?: 'MatchData';
  createdAt: Scalars['AWSDateTime']['output'];
  data: Scalars['AWSJSON']['output'];
  matchId: Scalars['ID']['output'];
  messageType: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type MatchPlayersForReport = {
  __typename?: 'MatchPlayersForReport';
  away?: Maybe<MatchPlayersForReportTeam>;
  home?: Maybe<MatchPlayersForReportTeam>;
  matchId?: Maybe<Scalars['ID']['output']>;
  referees?: Maybe<Array<Maybe<MatchPlayersForReportReferee>>>;
  reportStatus?: Maybe<Scalars['String']['output']>;
};

export type MatchPlayersForReportPlayer = {
  __typename?: 'MatchPlayersForReportPlayer';
  fullname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  startingLineup?: Maybe<Scalars['Boolean']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  topPlayer?: Maybe<Scalars['Boolean']['output']>;
  vote?: Maybe<Scalars['String']['output']>;
};

export type MatchPlayersForReportReferee = {
  __typename?: 'MatchPlayersForReportReferee';
  fullname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  topPlayer?: Maybe<Scalars['Boolean']['output']>;
  vote?: Maybe<Scalars['String']['output']>;
};

export type MatchPlayersForReportTeam = {
  __typename?: 'MatchPlayersForReportTeam';
  goal?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  playerList?: Maybe<Array<Maybe<MatchPlayersForReportPlayer>>>;
};

export type MatchReportByRound = {
  __typename?: 'MatchReportByRound';
  competitionId?: Maybe<Scalars['ID']['output']>;
  competitionName?: Maybe<Scalars['String']['output']>;
  matchList?: Maybe<Array<Maybe<ReportByRoundMatch>>>;
  round?: Maybe<Scalars['Int']['output']>;
  seasonId?: Maybe<Scalars['ID']['output']>;
};

export type ModelBooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModelCalendarAndResultsGliderConnection = {
  __typename?: 'ModelCalendarAndResultsGliderConnection';
  items: Array<Maybe<CalendarAndResultsGlider>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCalendarAndResultsGliderFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCalendarAndResultsGliderFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  currentRound?: InputMaybe<ModelIntFilterInput>;
  not?: InputMaybe<ModelCalendarAndResultsGliderFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCalendarAndResultsGliderFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelCardCompetitionCalendarConnection = {
  __typename?: 'ModelCardCompetitionCalendarConnection';
  items: Array<Maybe<CardCompetitionCalendar>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCardCompetitionCalendarFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCardCompetitionCalendarFilterInput>>>;
  calendarAndResultsLink?: InputMaybe<ModelStringFilterInput>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  customCompetitionName?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelCardCompetitionCalendarFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCardCompetitionCalendarFilterInput>>>;
};

export type ModelCardCompetitionRankingConnection = {
  __typename?: 'ModelCardCompetitionRankingConnection';
  items: Array<Maybe<CardCompetitionRanking>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCardCompetitionRankingFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCardCompetitionRankingFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  customCompetitionName?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelCardCompetitionRankingFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCardCompetitionRankingFilterInput>>>;
  rankingLink?: InputMaybe<ModelStringFilterInput>;
};

export type ModelCompetitionBoardConnection = {
  __typename?: 'ModelCompetitionBoardConnection';
  items: Array<Maybe<CompetitionBoard>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCompetitionBoardFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCompetitionBoardFilterInput>>>;
  boardSponsorLink?: InputMaybe<ModelStringFilterInput>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  customCompetitionName?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelCompetitionBoardFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCompetitionBoardFilterInput>>>;
};

export type ModelCompetitionCalendarAndResultsConnection = {
  __typename?: 'ModelCompetitionCalendarAndResultsConnection';
  items: Array<Maybe<CompetitionCalendarAndResults>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCompetitionCalendarAndResultsFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCompetitionCalendarAndResultsFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  currentRound?: InputMaybe<ModelIntFilterInput>;
  customCompetitionName?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelCompetitionCalendarAndResultsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCompetitionCalendarAndResultsFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelCompetitionConnection = {
  __typename?: 'ModelCompetitionConnection';
  items: Array<Maybe<Competition>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCompetitionFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCompetitionFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  competitionJson?: InputMaybe<ModelStringFilterInput>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelCompetitionFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCompetitionFilterInput>>>;
  previousSeasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelCompetitionRankingConnection = {
  __typename?: 'ModelCompetitionRankingConnection';
  items: Array<Maybe<CompetitionRanking>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCompetitionRankingFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCompetitionRankingFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelCompetitionRankingFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCompetitionRankingFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelCompetitionReportsConnection = {
  __typename?: 'ModelCompetitionReportsConnection';
  items: Array<Maybe<CompetitionReports>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCompetitionReportsFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCompetitionReportsFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelCompetitionReportsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCompetitionReportsFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelCompetitionScorersRankingConnection = {
  __typename?: 'ModelCompetitionScorersRankingConnection';
  items: Array<Maybe<CompetitionScorersRanking>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCompetitionScorersRankingFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCompetitionScorersRankingFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  competitionScorersUrl?: InputMaybe<ModelStringFilterInput>;
  competitionSeoName?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelCompetitionScorersRankingFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCompetitionScorersRankingFilterInput>>>;
  page?: InputMaybe<ModelStringFilterInput>;
  pages?: InputMaybe<ModelStringFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelCompetitionScorersRankingPrimaryCompositeKeyConditionInput = {
  beginsWith?: InputMaybe<ModelCompetitionScorersRankingPrimaryCompositeKeyInput>;
  between?: InputMaybe<Array<InputMaybe<ModelCompetitionScorersRankingPrimaryCompositeKeyInput>>>;
  eq?: InputMaybe<ModelCompetitionScorersRankingPrimaryCompositeKeyInput>;
  ge?: InputMaybe<ModelCompetitionScorersRankingPrimaryCompositeKeyInput>;
  gt?: InputMaybe<ModelCompetitionScorersRankingPrimaryCompositeKeyInput>;
  le?: InputMaybe<ModelCompetitionScorersRankingPrimaryCompositeKeyInput>;
  lt?: InputMaybe<ModelCompetitionScorersRankingPrimaryCompositeKeyInput>;
};

export type ModelCompetitionScorersRankingPrimaryCompositeKeyInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelCompetitionTeamConnection = {
  __typename?: 'ModelCompetitionTeamConnection';
  items: Array<Maybe<CompetitionTeam>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCompetitionTeamFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCompetitionTeamFilterInput>>>;
  id?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelCompetitionTeamFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCompetitionTeamFilterInput>>>;
};

export type ModelCrossLinkConnection = {
  __typename?: 'ModelCrossLinkConnection';
  items: Array<Maybe<CrossLink>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCrossLinkFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCrossLinkFilterInput>>>;
  crossLinkJson?: InputMaybe<ModelStringFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelCrossLinkFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCrossLinkFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelEditorialDataConnection = {
  __typename?: 'ModelEditorialDataConnection';
  items: Array<Maybe<EditorialData>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelEditorialDataFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelEditorialDataFilterInput>>>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  editorialJson?: InputMaybe<ModelStringFilterInput>;
  isCurrent?: InputMaybe<ModelBooleanFilterInput>;
  isPrimary?: InputMaybe<ModelBooleanFilterInput>;
  not?: InputMaybe<ModelEditorialDataFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelEditorialDataFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelFloatFilterInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
};

export type ModelGetDayListFilterInput = {
  matchByStatus?: InputMaybe<ModelInInput>;
};

export type ModelIDFilterInput = {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelIDKeyConditionInput = {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelInInput = {
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ModelIntFilterInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelIntKeyConditionInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelLastAndNextMatchConnection = {
  __typename?: 'ModelLastAndNextMatchConnection';
  items: Array<Maybe<LastAndNextMatch>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLastAndNextMatchFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLastAndNextMatchFilterInput>>>;
  not?: InputMaybe<ModelLastAndNextMatchFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLastAndNextMatchFilterInput>>>;
  teamId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelLiveScoreConnection = {
  __typename?: 'ModelLiveScoreConnection';
  items: Array<Maybe<LiveScore>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLiveScoreFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLiveScoreFilterInput>>>;
  id?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelLiveScoreFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLiveScoreFilterInput>>>;
};

export type ModelLmpHeroConnection = {
  __typename?: 'ModelLmpHeroConnection';
  items: Array<Maybe<LmpHero>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLmpHeroFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLmpHeroFilterInput>>>;
  competitionPhase?: InputMaybe<ModelStringFilterInput>;
  competitionPhaseRound?: InputMaybe<ModelStringFilterInput>;
  competitionPhaseWinnerTeamId?: InputMaybe<ModelStringFilterInput>;
  date?: InputMaybe<ModelStringFilterInput>;
  hasFollowMatch?: InputMaybe<ModelBooleanFilterInput>;
  matchDetailUrl?: InputMaybe<ModelStringFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelLmpHeroFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLmpHeroFilterInput>>>;
  round?: InputMaybe<ModelIntFilterInput>;
  roundGroup?: InputMaybe<ModelStringFilterInput>;
  status?: InputMaybe<ModelStringFilterInput>;
  statusStartDateTime?: InputMaybe<ModelStringFilterInput>;
  venue?: InputMaybe<ModelStringFilterInput>;
};

export type ModelLmpHeroStickyConnection = {
  __typename?: 'ModelLmpHeroStickyConnection';
  items: Array<Maybe<LmpHeroSticky>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLmpHeroStickyFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLmpHeroStickyFilterInput>>>;
  competitionPhase?: InputMaybe<ModelStringFilterInput>;
  competitionPhaseRound?: InputMaybe<ModelStringFilterInput>;
  competitionPhaseWinnerTeamId?: InputMaybe<ModelStringFilterInput>;
  date?: InputMaybe<ModelStringFilterInput>;
  matchDetailUrl?: InputMaybe<ModelStringFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelLmpHeroStickyFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLmpHeroStickyFilterInput>>>;
  round?: InputMaybe<ModelIntFilterInput>;
  roundGroup?: InputMaybe<ModelStringFilterInput>;
  status?: InputMaybe<ModelStringFilterInput>;
  statusStartDateTime?: InputMaybe<ModelStringFilterInput>;
  venue?: InputMaybe<ModelStringFilterInput>;
};

export type ModelLmpLineupConnection = {
  __typename?: 'ModelLmpLineupConnection';
  items: Array<Maybe<LmpLineup>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLmpLineupFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLmpLineupFilterInput>>>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelLmpLineupFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLmpLineupFilterInput>>>;
  status?: InputMaybe<ModelStringFilterInput>;
};

export type ModelLmpMatchChangeConnection = {
  __typename?: 'ModelLmpMatchChangeConnection';
  items: Array<Maybe<LmpMatchChange>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLmpMatchChangeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLmpMatchChangeFilterInput>>>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelLmpMatchChangeFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLmpMatchChangeFilterInput>>>;
};

export type ModelLmpPredictedLineupDetailsConnection = {
  __typename?: 'ModelLmpPredictedLineupDetailsConnection';
  items: Array<Maybe<LmpPredictedLineupDetails>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLmpPredictedLineupDetailsFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLmpPredictedLineupDetailsFilterInput>>>;
  date?: InputMaybe<ModelStringFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelLmpPredictedLineupDetailsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLmpPredictedLineupDetailsFilterInput>>>;
  round?: InputMaybe<ModelStringFilterInput>;
  status?: InputMaybe<ModelStringFilterInput>;
};

export type ModelLmpPreviewTextConnection = {
  __typename?: 'ModelLmpPreviewTextConnection';
  items: Array<Maybe<LmpPreviewText>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLmpPreviewTextFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLmpPreviewTextFilterInput>>>;
  competitionName?: InputMaybe<ModelStringFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  matchStartDateTime?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelLmpPreviewTextFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLmpPreviewTextFilterInput>>>;
  venue?: InputMaybe<ModelStringFilterInput>;
};

export type ModelLmpStatisticsConnection = {
  __typename?: 'ModelLmpStatisticsConnection';
  items: Array<Maybe<LmpStatistics>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLmpStatisticsFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLmpStatisticsFilterInput>>>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelLmpStatisticsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLmpStatisticsFilterInput>>>;
  status?: InputMaybe<ModelStringFilterInput>;
};

export type ModelMatchCardConnection = {
  __typename?: 'ModelMatchCardConnection';
  items: Array<Maybe<MatchCard>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelMatchCardFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelMatchCardFilterInput>>>;
  competitionPhase?: InputMaybe<ModelStringFilterInput>;
  competitionPhaseRound?: InputMaybe<ModelStringFilterInput>;
  competitionPhaseWinnerTeamId?: InputMaybe<ModelStringFilterInput>;
  date?: InputMaybe<ModelStringFilterInput>;
  matchDetailUrl?: InputMaybe<ModelStringFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelMatchCardFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelMatchCardFilterInput>>>;
  status?: InputMaybe<ModelStringFilterInput>;
};

export type ModelMatchChangeConnection = {
  __typename?: 'ModelMatchChangeConnection';
  items: Array<Maybe<MatchChange>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelMatchChangeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelMatchChangeFilterInput>>>;
  id?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelMatchChangeFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelMatchChangeFilterInput>>>;
};

export type ModelMatchCommentConnection = {
  __typename?: 'ModelMatchCommentConnection';
  items: Array<Maybe<MatchComment>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelMatchCommentFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelMatchCommentFilterInput>>>;
  commentId?: InputMaybe<ModelIDFilterInput>;
  matchCommentJson?: InputMaybe<ModelStringFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  minute?: InputMaybe<ModelIntFilterInput>;
  not?: InputMaybe<ModelMatchCommentFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelMatchCommentFilterInput>>>;
  player1Id?: InputMaybe<ModelIDFilterInput>;
  player2Id?: InputMaybe<ModelIDFilterInput>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  second?: InputMaybe<ModelIntFilterInput>;
  type?: InputMaybe<ModelStringFilterInput>;
};

export type ModelMatchCommentsConnection = {
  __typename?: 'ModelMatchCommentsConnection';
  items: Array<Maybe<MatchComments>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelMatchCommentsFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelMatchCommentsFilterInput>>>;
  firstCommentDate?: InputMaybe<ModelStringFilterInput>;
  lastCommentDate?: InputMaybe<ModelStringFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  matchStatus?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelMatchCommentsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelMatchCommentsFilterInput>>>;
  page?: InputMaybe<ModelIntFilterInput>;
  url?: InputMaybe<ModelStringFilterInput>;
};

export type ModelMatchConnection = {
  __typename?: 'ModelMatchConnection';
  items: Array<Maybe<Match>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelMatchDataConnection = {
  __typename?: 'ModelMatchDataConnection';
  items: Array<Maybe<MatchData>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelMatchDataFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelMatchDataFilterInput>>>;
  data?: InputMaybe<ModelStringFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  messageType?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelMatchDataFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelMatchDataFilterInput>>>;
};

export type ModelMatchFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelMatchFilterInput>>>;
  awayTeamId?: InputMaybe<ModelIDFilterInput>;
  competitionPhase?: InputMaybe<ModelStringFilterInput>;
  competitionPhaseRound?: InputMaybe<ModelStringFilterInput>;
  date?: InputMaybe<ModelIntFilterInput>;
  homeTeamId?: InputMaybe<ModelIDFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  matchJson?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelMatchFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelMatchFilterInput>>>;
  refereeId?: InputMaybe<ModelStringFilterInput>;
  round?: InputMaybe<ModelIntFilterInput>;
  roundGroup?: InputMaybe<ModelStringFilterInput>;
  scheduleJson?: InputMaybe<ModelStringFilterInput>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  status?: InputMaybe<ModelStringFilterInput>;
};

export type ModelNotificationMatchConnection = {
  __typename?: 'ModelNotificationMatchConnection';
  items: Array<Maybe<NotificationMatch>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelNotificationMatchFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelNotificationMatchFilterInput>>>;
  competitionPhase?: InputMaybe<ModelStringFilterInput>;
  competitionPhaseRound?: InputMaybe<ModelStringFilterInput>;
  competitionPhaseWinnerTeamId?: InputMaybe<ModelStringFilterInput>;
  date?: InputMaybe<ModelStringFilterInput>;
  matchDetailUrl?: InputMaybe<ModelStringFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  matchJson?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelNotificationMatchFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelNotificationMatchFilterInput>>>;
  round?: InputMaybe<ModelIntFilterInput>;
  roundGroup?: InputMaybe<ModelStringFilterInput>;
  status?: InputMaybe<ModelStringFilterInput>;
};

export type ModelPlayerConnection = {
  __typename?: 'ModelPlayerConnection';
  items: Array<Maybe<Player>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelPlayerDataConnection = {
  __typename?: 'ModelPlayerDataConnection';
  items: Array<Maybe<PlayerData>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelPlayerDataFilterInput = {
  action?: InputMaybe<ModelStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ModelPlayerDataFilterInput>>>;
  competitionId?: InputMaybe<ModelStringFilterInput>;
  data?: InputMaybe<ModelStringFilterInput>;
  messageType?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelPlayerDataFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPlayerDataFilterInput>>>;
  playerId?: InputMaybe<ModelIDFilterInput>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  seasonId?: InputMaybe<ModelStringFilterInput>;
};

export type ModelPlayerFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPlayerFilterInput>>>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelPlayerFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPlayerFilterInput>>>;
  playerId?: InputMaybe<ModelIDFilterInput>;
  playerJson?: InputMaybe<ModelStringFilterInput>;
  role?: InputMaybe<ModelStringFilterInput>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  teamId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelPlayerPagesStatsConnection = {
  __typename?: 'ModelPlayerPagesStatsConnection';
  items: Array<Maybe<PlayerPagesStats>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelPlayerPagesStatsFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPlayerPagesStatsFilterInput>>>;
  not?: InputMaybe<ModelPlayerPagesStatsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPlayerPagesStatsFilterInput>>>;
  playerId?: InputMaybe<ModelIDFilterInput>;
  playerRole?: InputMaybe<ModelStringFilterInput>;
};

export type ModelPlayerRankingConnection = {
  __typename?: 'ModelPlayerRankingConnection';
  items: Array<Maybe<PlayerRanking>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelPlayerRankingFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPlayerRankingFilterInput>>>;
  not?: InputMaybe<ModelPlayerRankingFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPlayerRankingFilterInput>>>;
  playerId?: InputMaybe<ModelIDFilterInput>;
  playerRankingJson?: InputMaybe<ModelStringFilterInput>;
  position?: InputMaybe<ModelIntFilterInput>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  teamId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelPlayerStatsConnection = {
  __typename?: 'ModelPlayerStatsConnection';
  items: Array<Maybe<PlayerStats>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelPlayerStatsFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPlayerStatsFilterInput>>>;
  not?: InputMaybe<ModelPlayerStatsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPlayerStatsFilterInput>>>;
  playerId?: InputMaybe<ModelIDFilterInput>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  statsJson?: InputMaybe<ModelStringFilterInput>;
};

export type ModelPredictedLineupConnection = {
  __typename?: 'ModelPredictedLineupConnection';
  items: Array<Maybe<PredictedLineup>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelPredictedLineupDetailsConnection = {
  __typename?: 'ModelPredictedLineupDetailsConnection';
  items: Array<Maybe<PredictedLineupDetails>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelPredictedLineupDetailsFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPredictedLineupDetailsFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  hasHeadshots?: InputMaybe<ModelBooleanFilterInput>;
  not?: InputMaybe<ModelPredictedLineupDetailsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPredictedLineupDetailsFilterInput>>>;
  predictedHpLink?: InputMaybe<ModelStringFilterInput>;
  predictedSponsorLink?: InputMaybe<ModelStringFilterInput>;
  teamId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelPredictedLineupFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPredictedLineupFilterInput>>>;
  awayTeamId?: InputMaybe<ModelIDFilterInput>;
  homeTeamId?: InputMaybe<ModelIDFilterInput>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelPredictedLineupFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPredictedLineupFilterInput>>>;
  predictedLineupJson?: InputMaybe<ModelStringFilterInput>;
  round?: InputMaybe<ModelIntFilterInput>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  status?: InputMaybe<ModelStringFilterInput>;
};

export type ModelPredictedLineupHomepageConnection = {
  __typename?: 'ModelPredictedLineupHomepageConnection';
  items: Array<Maybe<PredictedLineupHomepage>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelPredictedLineupHomepageFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPredictedLineupHomepageFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelPredictedLineupHomepageFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPredictedLineupHomepageFilterInput>>>;
  round?: InputMaybe<ModelStringFilterInput>;
};

export type ModelPredictedLineupRoundConnection = {
  __typename?: 'ModelPredictedLineupRoundConnection';
  items: Array<Maybe<PredictedLineupRound>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelPredictedLineupRoundFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPredictedLineupRoundFilterInput>>>;
  not?: InputMaybe<ModelPredictedLineupRoundFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPredictedLineupRoundFilterInput>>>;
  round?: InputMaybe<ModelIntFilterInput>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelRankingConnection = {
  __typename?: 'ModelRankingConnection';
  items: Array<Maybe<Ranking>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelRankingFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelRankingFilterInput>>>;
  matchDayId?: InputMaybe<ModelIntFilterInput>;
  not?: InputMaybe<ModelRankingFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelRankingFilterInput>>>;
  position?: InputMaybe<ModelIntFilterInput>;
  rankingJson?: InputMaybe<ModelStringFilterInput>;
  roundName?: InputMaybe<ModelStringFilterInput>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  teamId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelReportConnection = {
  __typename?: 'ModelReportConnection';
  items: Array<Maybe<Report>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelReportDetailsConnection = {
  __typename?: 'ModelReportDetailsConnection';
  items: Array<Maybe<ReportDetails>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelReportDetailsFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelReportDetailsFilterInput>>>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelReportDetailsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelReportDetailsFilterInput>>>;
  reportsHomepageUrl?: InputMaybe<ModelStringFilterInput>;
  round?: InputMaybe<ModelIntFilterInput>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelReportDetailsPrimaryCompositeKeyConditionInput = {
  beginsWith?: InputMaybe<ModelReportDetailsPrimaryCompositeKeyInput>;
  between?: InputMaybe<Array<InputMaybe<ModelReportDetailsPrimaryCompositeKeyInput>>>;
  eq?: InputMaybe<ModelReportDetailsPrimaryCompositeKeyInput>;
  ge?: InputMaybe<ModelReportDetailsPrimaryCompositeKeyInput>;
  gt?: InputMaybe<ModelReportDetailsPrimaryCompositeKeyInput>;
  le?: InputMaybe<ModelReportDetailsPrimaryCompositeKeyInput>;
  lt?: InputMaybe<ModelReportDetailsPrimaryCompositeKeyInput>;
};

export type ModelReportDetailsPrimaryCompositeKeyInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelReportFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelReportFilterInput>>>;
  matchId?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelReportFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelReportFilterInput>>>;
  reportJson?: InputMaybe<ModelStringFilterInput>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  status?: InputMaybe<ModelStringFilterInput>;
};

export type ModelScorersRankingPlayerPageConnection = {
  __typename?: 'ModelScorersRankingPlayerPageConnection';
  items: Array<Maybe<ScorersRankingPlayerPage>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelScorersRankingPlayerPageFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelScorersRankingPlayerPageFilterInput>>>;
  competitionCalendarUrl?: InputMaybe<ModelStringFilterInput>;
  competitionId?: InputMaybe<ModelIDFilterInput>;
  competitionName?: InputMaybe<ModelStringFilterInput>;
  competitionSlugName?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelScorersRankingPlayerPageFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelScorersRankingPlayerPageFilterInput>>>;
  seasonId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelSeasonConnection = {
  __typename?: 'ModelSeasonConnection';
  items: Array<Maybe<Season>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSeasonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSeasonFilterInput>>>;
  editorialData?: InputMaybe<ModelStringFilterInput>;
  id?: InputMaybe<ModelIDFilterInput>;
  not?: InputMaybe<ModelSeasonFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSeasonFilterInput>>>;
};

export enum ModelSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ModelStringFilterInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
};

export type ModelTeamCalendarAndResultsConnection = {
  __typename?: 'ModelTeamCalendarAndResultsConnection';
  items: Array<Maybe<TeamCalendarAndResults>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTeamCalendarAndResultsFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTeamCalendarAndResultsFilterInput>>>;
  not?: InputMaybe<ModelTeamCalendarAndResultsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTeamCalendarAndResultsFilterInput>>>;
  teamId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelTeamConnection = {
  __typename?: 'ModelTeamConnection';
  items: Array<Maybe<Team>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTeamFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTeamFilterInput>>>;
  editorialDataId?: InputMaybe<ModelIDFilterInput>;
  isPlaceholder?: InputMaybe<ModelBooleanFilterInput>;
  not?: InputMaybe<ModelTeamFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTeamFilterInput>>>;
  seasonAndCompId?: InputMaybe<ModelIDFilterInput>;
  teamId?: InputMaybe<ModelIDFilterInput>;
  teamJson?: InputMaybe<ModelStringFilterInput>;
};

export type ModelTeamPlayersConnection = {
  __typename?: 'ModelTeamPlayersConnection';
  items: Array<Maybe<TeamPlayers>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTeamPlayersFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTeamPlayersFilterInput>>>;
  not?: InputMaybe<ModelTeamPlayersFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTeamPlayersFilterInput>>>;
  teamId?: InputMaybe<ModelIDFilterInput>;
};

export type ModelTeamRankingConnection = {
  __typename?: 'ModelTeamRankingConnection';
  items: Array<Maybe<TeamRanking>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTeamRankingFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTeamRankingFilterInput>>>;
  not?: InputMaybe<ModelTeamRankingFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTeamRankingFilterInput>>>;
  teamId?: InputMaybe<ModelIDFilterInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createCalendarAndResultsGlider?: Maybe<CalendarAndResultsGlider>;
  createCardCompetitionCalendar?: Maybe<CardCompetitionCalendar>;
  createCardCompetitionRanking?: Maybe<CardCompetitionRanking>;
  createCompetition?: Maybe<Competition>;
  createCompetitionBoard?: Maybe<CompetitionBoard>;
  createCompetitionCalendarAndResults?: Maybe<CompetitionCalendarAndResults>;
  createCompetitionRanking?: Maybe<CompetitionRanking>;
  createCompetitionReports?: Maybe<CompetitionReports>;
  createCompetitionScorersRanking?: Maybe<CompetitionScorersRanking>;
  createCompetitionTeam?: Maybe<CompetitionTeam>;
  createCrossLink?: Maybe<CrossLink>;
  createEditorialData?: Maybe<EditorialData>;
  createLastAndNextMatch?: Maybe<LastAndNextMatch>;
  createLiveScore?: Maybe<LiveScore>;
  createLmpHero?: Maybe<LmpHero>;
  createLmpHeroSticky?: Maybe<LmpHeroSticky>;
  createLmpLineup?: Maybe<LmpLineup>;
  createLmpMatchChange?: Maybe<LmpMatchChange>;
  createLmpPredictedLineupDetails?: Maybe<LmpPredictedLineupDetails>;
  createLmpPreviewText?: Maybe<LmpPreviewText>;
  createLmpStatistics?: Maybe<LmpStatistics>;
  createMatch?: Maybe<Match>;
  createMatchCard?: Maybe<MatchCard>;
  createMatchChange?: Maybe<MatchChange>;
  createMatchComment?: Maybe<MatchComment>;
  createMatchComments?: Maybe<MatchComments>;
  createMatchData?: Maybe<MatchData>;
  createNotificationMatch?: Maybe<NotificationMatch>;
  createPlayer?: Maybe<Player>;
  createPlayerData?: Maybe<PlayerData>;
  createPlayerPagesStats?: Maybe<PlayerPagesStats>;
  createPlayerRanking?: Maybe<PlayerRanking>;
  createPlayerStats?: Maybe<PlayerStats>;
  createPredictedLineup?: Maybe<PredictedLineup>;
  createPredictedLineupDetails?: Maybe<PredictedLineupDetails>;
  createPredictedLineupHomepage?: Maybe<PredictedLineupHomepage>;
  createPredictedLineupRound?: Maybe<PredictedLineupRound>;
  createRanking?: Maybe<Ranking>;
  createReport?: Maybe<Report>;
  createReportDetails?: Maybe<ReportDetails>;
  createScorersRankingPlayerPage?: Maybe<ScorersRankingPlayerPage>;
  createSeason?: Maybe<Season>;
  createTeam?: Maybe<Team>;
  createTeamCalendarAndResults?: Maybe<TeamCalendarAndResults>;
  createTeamPlayers?: Maybe<TeamPlayers>;
  createTeamRanking?: Maybe<TeamRanking>;
  deleteCalendarAndResultsGlider?: Maybe<CalendarAndResultsGlider>;
  deleteCardCompetitionCalendar?: Maybe<CardCompetitionCalendar>;
  deleteCardCompetitionRanking?: Maybe<CardCompetitionRanking>;
  deleteCompetition?: Maybe<Competition>;
  deleteCompetitionBoard?: Maybe<CompetitionBoard>;
  deleteCompetitionCalendarAndResults?: Maybe<CompetitionCalendarAndResults>;
  deleteCompetitionRanking?: Maybe<CompetitionRanking>;
  deleteCompetitionReports?: Maybe<CompetitionReports>;
  deleteCompetitionScorersRanking?: Maybe<CompetitionScorersRanking>;
  deleteCompetitionTeam?: Maybe<CompetitionTeam>;
  deleteCrossLink?: Maybe<CrossLink>;
  deleteEditorialData?: Maybe<EditorialData>;
  deleteLastAndNextMatch?: Maybe<LastAndNextMatch>;
  deleteLiveScore?: Maybe<LiveScore>;
  deleteLmpHero?: Maybe<LmpHero>;
  deleteLmpHeroSticky?: Maybe<LmpHeroSticky>;
  deleteLmpLineup?: Maybe<LmpLineup>;
  deleteLmpMatchChange?: Maybe<LmpMatchChange>;
  deleteLmpPredictedLineupDetails?: Maybe<LmpPredictedLineupDetails>;
  deleteLmpPreviewText?: Maybe<LmpPreviewText>;
  deleteLmpStatistics?: Maybe<LmpStatistics>;
  deleteMatch?: Maybe<Match>;
  deleteMatchCard?: Maybe<MatchCard>;
  deleteMatchChange?: Maybe<MatchChange>;
  deleteMatchComment?: Maybe<MatchComment>;
  deleteMatchComments?: Maybe<MatchComments>;
  deleteMatchData?: Maybe<MatchData>;
  deleteNotificationMatch?: Maybe<NotificationMatch>;
  deletePlayer?: Maybe<Player>;
  deletePlayerData?: Maybe<PlayerData>;
  deletePlayerPagesStats?: Maybe<PlayerPagesStats>;
  deletePlayerRanking?: Maybe<PlayerRanking>;
  deletePlayerStats?: Maybe<PlayerStats>;
  deletePredictedLineup?: Maybe<PredictedLineup>;
  deletePredictedLineupDetails?: Maybe<PredictedLineupDetails>;
  deletePredictedLineupHomepage?: Maybe<PredictedLineupHomepage>;
  deletePredictedLineupRound?: Maybe<PredictedLineupRound>;
  deleteRanking?: Maybe<Ranking>;
  deleteReport?: Maybe<Report>;
  deleteReportDetails?: Maybe<ReportDetails>;
  deleteScorersRankingPlayerPage?: Maybe<ScorersRankingPlayerPage>;
  deleteSeason?: Maybe<Season>;
  deleteTeam?: Maybe<Team>;
  deleteTeamCalendarAndResults?: Maybe<TeamCalendarAndResults>;
  deleteTeamPlayers?: Maybe<TeamPlayers>;
  deleteTeamRanking?: Maybe<TeamRanking>;
  updateCalendarAndResultsGlider?: Maybe<CalendarAndResultsGlider>;
  updateCardCompetitionCalendar?: Maybe<CardCompetitionCalendar>;
  updateCardCompetitionRanking?: Maybe<CardCompetitionRanking>;
  updateCompetition?: Maybe<Competition>;
  updateCompetitionBoard?: Maybe<CompetitionBoard>;
  updateCompetitionCalendarAndResults?: Maybe<CompetitionCalendarAndResults>;
  updateCompetitionRanking?: Maybe<CompetitionRanking>;
  updateCompetitionReports?: Maybe<CompetitionReports>;
  updateCompetitionScorersRanking?: Maybe<CompetitionScorersRanking>;
  updateCompetitionTeam?: Maybe<CompetitionTeam>;
  updateCrossLink?: Maybe<CrossLink>;
  updateEditorialData?: Maybe<EditorialData>;
  updateLastAndNextMatch?: Maybe<LastAndNextMatch>;
  updateLiveScore?: Maybe<LiveScore>;
  updateLmpHero?: Maybe<LmpHero>;
  updateLmpHeroSticky?: Maybe<LmpHeroSticky>;
  updateLmpLineup?: Maybe<LmpLineup>;
  updateLmpMatchChange?: Maybe<LmpMatchChange>;
  updateLmpPredictedLineupDetails?: Maybe<LmpPredictedLineupDetails>;
  updateLmpPreviewText?: Maybe<LmpPreviewText>;
  updateLmpStatistics?: Maybe<LmpStatistics>;
  updateMatch?: Maybe<Match>;
  updateMatchCard?: Maybe<MatchCard>;
  updateMatchChange?: Maybe<MatchChange>;
  updateMatchComment?: Maybe<MatchComment>;
  updateMatchComments?: Maybe<MatchComments>;
  updateMatchData?: Maybe<MatchData>;
  updateNotificationMatch?: Maybe<NotificationMatch>;
  updatePlayer?: Maybe<Player>;
  updatePlayerData?: Maybe<PlayerData>;
  updatePlayerPagesStats?: Maybe<PlayerPagesStats>;
  updatePlayerRanking?: Maybe<PlayerRanking>;
  updatePlayerStats?: Maybe<PlayerStats>;
  updatePredictedLineup?: Maybe<PredictedLineup>;
  updatePredictedLineupDetails?: Maybe<PredictedLineupDetails>;
  updatePredictedLineupHomepage?: Maybe<PredictedLineupHomepage>;
  updatePredictedLineupRound?: Maybe<PredictedLineupRound>;
  updateRanking?: Maybe<Ranking>;
  updateReport?: Maybe<Report>;
  updateReportDetails?: Maybe<ReportDetails>;
  updateScorersRankingPlayerPage?: Maybe<ScorersRankingPlayerPage>;
  updateSeason?: Maybe<Season>;
  updateTeam?: Maybe<Team>;
  updateTeamCalendarAndResults?: Maybe<TeamCalendarAndResults>;
  updateTeamPlayers?: Maybe<TeamPlayers>;
  updateTeamRanking?: Maybe<TeamRanking>;
};


export type MutationcreateCalendarAndResultsGliderArgs = {
  input: CreateCalendarAndResultsGliderInput;
};


export type MutationcreateCardCompetitionCalendarArgs = {
  input: CreateCardCompetitionCalendarInput;
};


export type MutationcreateCardCompetitionRankingArgs = {
  input: CreateCardCompetitionRankingInput;
};


export type MutationcreateCompetitionArgs = {
  input: CreateCompetitionInput;
};


export type MutationcreateCompetitionBoardArgs = {
  input: CreateCompetitionBoardInput;
};


export type MutationcreateCompetitionCalendarAndResultsArgs = {
  input: CreateCompetitionCalendarAndResultsInput;
};


export type MutationcreateCompetitionRankingArgs = {
  input: CreateCompetitionRankingInput;
};


export type MutationcreateCompetitionReportsArgs = {
  input: CreateCompetitionReportsInput;
};


export type MutationcreateCompetitionScorersRankingArgs = {
  input: CreateCompetitionScorersRankingInput;
};


export type MutationcreateCompetitionTeamArgs = {
  input: CreateCompetitionTeamInput;
};


export type MutationcreateCrossLinkArgs = {
  input: CreateCrossLinkInput;
};


export type MutationcreateEditorialDataArgs = {
  input: CreateEditorialDataInput;
};


export type MutationcreateLastAndNextMatchArgs = {
  input: CreateLastAndNextMatchInput;
};


export type MutationcreateLiveScoreArgs = {
  input: CreateLiveScoreInput;
};


export type MutationcreateLmpHeroArgs = {
  input: CreateLmpHeroInput;
};


export type MutationcreateLmpHeroStickyArgs = {
  input: CreateLmpHeroStickyInput;
};


export type MutationcreateLmpLineupArgs = {
  input: CreateLmpLineupInput;
};


export type MutationcreateLmpMatchChangeArgs = {
  input: CreateLmpMatchChangeInput;
};


export type MutationcreateLmpPredictedLineupDetailsArgs = {
  input: CreateLmpPredictedLineupDetailsInput;
};


export type MutationcreateLmpPreviewTextArgs = {
  input: CreateLmpPreviewTextInput;
};


export type MutationcreateLmpStatisticsArgs = {
  input: CreateLmpStatisticsInput;
};


export type MutationcreateMatchArgs = {
  input: CreateMatchInput;
};


export type MutationcreateMatchCardArgs = {
  input: CreateMatchCardInput;
};


export type MutationcreateMatchChangeArgs = {
  input: CreateMatchChangeInput;
};


export type MutationcreateMatchCommentArgs = {
  input: CreateMatchCommentInput;
};


export type MutationcreateMatchCommentsArgs = {
  input: CreateMatchCommentsInput;
};


export type MutationcreateMatchDataArgs = {
  input: CreateMatchDataInput;
};


export type MutationcreateNotificationMatchArgs = {
  input: CreateNotificationMatchInput;
};


export type MutationcreatePlayerArgs = {
  input: CreatePlayerInput;
};


export type MutationcreatePlayerDataArgs = {
  input: CreatePlayerDataInput;
};


export type MutationcreatePlayerPagesStatsArgs = {
  input: CreatePlayerPagesStatsInput;
};


export type MutationcreatePlayerRankingArgs = {
  input: CreatePlayerRankingInput;
};


export type MutationcreatePlayerStatsArgs = {
  input: CreatePlayerStatsInput;
};


export type MutationcreatePredictedLineupArgs = {
  input: CreatePredictedLineupInput;
};


export type MutationcreatePredictedLineupDetailsArgs = {
  input: CreatePredictedLineupDetailsInput;
};


export type MutationcreatePredictedLineupHomepageArgs = {
  input: CreatePredictedLineupHomepageInput;
};


export type MutationcreatePredictedLineupRoundArgs = {
  input: CreatePredictedLineupRoundInput;
};


export type MutationcreateRankingArgs = {
  input: CreateRankingInput;
};


export type MutationcreateReportArgs = {
  input: CreateReportInput;
};


export type MutationcreateReportDetailsArgs = {
  input: CreateReportDetailsInput;
};


export type MutationcreateScorersRankingPlayerPageArgs = {
  input: CreateScorersRankingPlayerPageInput;
};


export type MutationcreateSeasonArgs = {
  input: CreateSeasonInput;
};


export type MutationcreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationcreateTeamCalendarAndResultsArgs = {
  input: CreateTeamCalendarAndResultsInput;
};


export type MutationcreateTeamPlayersArgs = {
  input: CreateTeamPlayersInput;
};


export type MutationcreateTeamRankingArgs = {
  input: CreateTeamRankingInput;
};


export type MutationdeleteCalendarAndResultsGliderArgs = {
  input: DeleteCalendarAndResultsGliderInput;
};


export type MutationdeleteCardCompetitionCalendarArgs = {
  input: DeleteCardCompetitionCalendarInput;
};


export type MutationdeleteCardCompetitionRankingArgs = {
  input: DeleteCardCompetitionRankingInput;
};


export type MutationdeleteCompetitionArgs = {
  input: DeleteCompetitionInput;
};


export type MutationdeleteCompetitionBoardArgs = {
  input: DeleteCompetitionBoardInput;
};


export type MutationdeleteCompetitionCalendarAndResultsArgs = {
  input: DeleteCompetitionCalendarAndResultsInput;
};


export type MutationdeleteCompetitionRankingArgs = {
  input: DeleteCompetitionRankingInput;
};


export type MutationdeleteCompetitionReportsArgs = {
  input: DeleteCompetitionReportsInput;
};


export type MutationdeleteCompetitionScorersRankingArgs = {
  input: DeleteCompetitionScorersRankingInput;
};


export type MutationdeleteCompetitionTeamArgs = {
  input: DeleteCompetitionTeamInput;
};


export type MutationdeleteCrossLinkArgs = {
  input: DeleteCrossLinkInput;
};


export type MutationdeleteEditorialDataArgs = {
  input: DeleteEditorialDataInput;
};


export type MutationdeleteLastAndNextMatchArgs = {
  input: DeleteLastAndNextMatchInput;
};


export type MutationdeleteLiveScoreArgs = {
  input: DeleteLiveScoreInput;
};


export type MutationdeleteLmpHeroArgs = {
  input: DeleteLmpHeroInput;
};


export type MutationdeleteLmpHeroStickyArgs = {
  input: DeleteLmpHeroStickyInput;
};


export type MutationdeleteLmpLineupArgs = {
  input: DeleteLmpLineupInput;
};


export type MutationdeleteLmpMatchChangeArgs = {
  input: DeleteLmpMatchChangeInput;
};


export type MutationdeleteLmpPredictedLineupDetailsArgs = {
  input: DeleteLmpPredictedLineupDetailsInput;
};


export type MutationdeleteLmpPreviewTextArgs = {
  input: DeleteLmpPreviewTextInput;
};


export type MutationdeleteLmpStatisticsArgs = {
  input: DeleteLmpStatisticsInput;
};


export type MutationdeleteMatchArgs = {
  input: DeleteMatchInput;
};


export type MutationdeleteMatchCardArgs = {
  input: DeleteMatchCardInput;
};


export type MutationdeleteMatchChangeArgs = {
  input: DeleteMatchChangeInput;
};


export type MutationdeleteMatchCommentArgs = {
  input: DeleteMatchCommentInput;
};


export type MutationdeleteMatchCommentsArgs = {
  input: DeleteMatchCommentsInput;
};


export type MutationdeleteMatchDataArgs = {
  input: DeleteMatchDataInput;
};


export type MutationdeleteNotificationMatchArgs = {
  input: DeleteNotificationMatchInput;
};


export type MutationdeletePlayerArgs = {
  input: DeletePlayerInput;
};


export type MutationdeletePlayerDataArgs = {
  input: DeletePlayerDataInput;
};


export type MutationdeletePlayerPagesStatsArgs = {
  input: DeletePlayerPagesStatsInput;
};


export type MutationdeletePlayerRankingArgs = {
  input: DeletePlayerRankingInput;
};


export type MutationdeletePlayerStatsArgs = {
  input: DeletePlayerStatsInput;
};


export type MutationdeletePredictedLineupArgs = {
  input: DeletePredictedLineupInput;
};


export type MutationdeletePredictedLineupDetailsArgs = {
  input: DeletePredictedLineupDetailsInput;
};


export type MutationdeletePredictedLineupHomepageArgs = {
  input: DeletePredictedLineupHomepageInput;
};


export type MutationdeletePredictedLineupRoundArgs = {
  input: DeletePredictedLineupRoundInput;
};


export type MutationdeleteRankingArgs = {
  input: DeleteRankingInput;
};


export type MutationdeleteReportArgs = {
  input: DeleteReportInput;
};


export type MutationdeleteReportDetailsArgs = {
  input: DeleteReportDetailsInput;
};


export type MutationdeleteScorersRankingPlayerPageArgs = {
  input: DeleteScorersRankingPlayerPageInput;
};


export type MutationdeleteSeasonArgs = {
  input: DeleteSeasonInput;
};


export type MutationdeleteTeamArgs = {
  input: DeleteTeamInput;
};


export type MutationdeleteTeamCalendarAndResultsArgs = {
  input: DeleteTeamCalendarAndResultsInput;
};


export type MutationdeleteTeamPlayersArgs = {
  input: DeleteTeamPlayersInput;
};


export type MutationdeleteTeamRankingArgs = {
  input: DeleteTeamRankingInput;
};


export type MutationupdateCalendarAndResultsGliderArgs = {
  input: UpdateCalendarAndResultsGliderInput;
};


export type MutationupdateCardCompetitionCalendarArgs = {
  input: UpdateCardCompetitionCalendarInput;
};


export type MutationupdateCardCompetitionRankingArgs = {
  input: UpdateCardCompetitionRankingInput;
};


export type MutationupdateCompetitionArgs = {
  input: UpdateCompetitionInput;
};


export type MutationupdateCompetitionBoardArgs = {
  input: UpdateCompetitionBoardInput;
};


export type MutationupdateCompetitionCalendarAndResultsArgs = {
  input: UpdateCompetitionCalendarAndResultsInput;
};


export type MutationupdateCompetitionRankingArgs = {
  input: UpdateCompetitionRankingInput;
};


export type MutationupdateCompetitionReportsArgs = {
  input: UpdateCompetitionReportsInput;
};


export type MutationupdateCompetitionScorersRankingArgs = {
  input: UpdateCompetitionScorersRankingInput;
};


export type MutationupdateCompetitionTeamArgs = {
  input: UpdateCompetitionTeamInput;
};


export type MutationupdateCrossLinkArgs = {
  input: UpdateCrossLinkInput;
};


export type MutationupdateEditorialDataArgs = {
  input: UpdateEditorialDataInput;
};


export type MutationupdateLastAndNextMatchArgs = {
  input: UpdateLastAndNextMatchInput;
};


export type MutationupdateLiveScoreArgs = {
  input: UpdateLiveScoreInput;
};


export type MutationupdateLmpHeroArgs = {
  input: UpdateLmpHeroInput;
};


export type MutationupdateLmpHeroStickyArgs = {
  input: UpdateLmpHeroStickyInput;
};


export type MutationupdateLmpLineupArgs = {
  input: UpdateLmpLineupInput;
};


export type MutationupdateLmpMatchChangeArgs = {
  input: UpdateLmpMatchChangeInput;
};


export type MutationupdateLmpPredictedLineupDetailsArgs = {
  input: UpdateLmpPredictedLineupDetailsInput;
};


export type MutationupdateLmpPreviewTextArgs = {
  input: UpdateLmpPreviewTextInput;
};


export type MutationupdateLmpStatisticsArgs = {
  input: UpdateLmpStatisticsInput;
};


export type MutationupdateMatchArgs = {
  input: UpdateMatchInput;
};


export type MutationupdateMatchCardArgs = {
  input: UpdateMatchCardInput;
};


export type MutationupdateMatchChangeArgs = {
  input: UpdateMatchChangeInput;
};


export type MutationupdateMatchCommentArgs = {
  input: UpdateMatchCommentInput;
};


export type MutationupdateMatchCommentsArgs = {
  input: UpdateMatchCommentsInput;
};


export type MutationupdateMatchDataArgs = {
  input: UpdateMatchDataInput;
};


export type MutationupdateNotificationMatchArgs = {
  input: UpdateNotificationMatchInput;
};


export type MutationupdatePlayerArgs = {
  input: UpdatePlayerInput;
};


export type MutationupdatePlayerDataArgs = {
  input: UpdatePlayerDataInput;
};


export type MutationupdatePlayerPagesStatsArgs = {
  input: UpdatePlayerPagesStatsInput;
};


export type MutationupdatePlayerRankingArgs = {
  input: UpdatePlayerRankingInput;
};


export type MutationupdatePlayerStatsArgs = {
  input: UpdatePlayerStatsInput;
};


export type MutationupdatePredictedLineupArgs = {
  input: UpdatePredictedLineupInput;
};


export type MutationupdatePredictedLineupDetailsArgs = {
  input: UpdatePredictedLineupDetailsInput;
};


export type MutationupdatePredictedLineupHomepageArgs = {
  input: UpdatePredictedLineupHomepageInput;
};


export type MutationupdatePredictedLineupRoundArgs = {
  input: UpdatePredictedLineupRoundInput;
};


export type MutationupdateRankingArgs = {
  input: UpdateRankingInput;
};


export type MutationupdateReportArgs = {
  input: UpdateReportInput;
};


export type MutationupdateReportDetailsArgs = {
  input: UpdateReportDetailsInput;
};


export type MutationupdateScorersRankingPlayerPageArgs = {
  input: UpdateScorersRankingPlayerPageInput;
};


export type MutationupdateSeasonArgs = {
  input: UpdateSeasonInput;
};


export type MutationupdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationupdateTeamCalendarAndResultsArgs = {
  input: UpdateTeamCalendarAndResultsInput;
};


export type MutationupdateTeamPlayersArgs = {
  input: UpdateTeamPlayersInput;
};


export type MutationupdateTeamRankingArgs = {
  input: UpdateTeamRankingInput;
};

export type NotificationMatch = {
  __typename?: 'NotificationMatch';
  away?: Maybe<NotificationMatchTeam>;
  competitionPhase?: Maybe<Scalars['String']['output']>;
  competitionPhaseRound?: Maybe<Scalars['String']['output']>;
  competitionPhaseWinnerTeamId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  date?: Maybe<Scalars['AWSDateTime']['output']>;
  home?: Maybe<NotificationMatchTeam>;
  matchDetailUrl?: Maybe<Scalars['String']['output']>;
  matchId: Scalars['ID']['output'];
  matchJson?: Maybe<Scalars['AWSJSON']['output']>;
  round?: Maybe<Scalars['Int']['output']>;
  roundGroup?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  updates?: Maybe<NotificationMatchUpdates>;
};

export type NotificationMatchTeam = {
  __typename?: 'NotificationMatchTeam';
  goal?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  overtimeGoal?: Maybe<Scalars['Int']['output']>;
  penaltiesGoal?: Maybe<Scalars['Int']['output']>;
  regularTimeGoal?: Maybe<Scalars['Int']['output']>;
  shootoutGoal?: Maybe<Scalars['Int']['output']>;
  totalGoalLegs?: Maybe<Scalars['Int']['output']>;
};

export type NotificationMatchTeamInput = {
  goal?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overtimeGoal?: InputMaybe<Scalars['Int']['input']>;
  penaltiesGoal?: InputMaybe<Scalars['Int']['input']>;
  regularTimeGoal?: InputMaybe<Scalars['Int']['input']>;
  shootoutGoal?: InputMaybe<Scalars['Int']['input']>;
  totalGoalLegs?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationMatchUpdates = {
  __typename?: 'NotificationMatchUpdates';
  goals?: Maybe<Scalars['Boolean']['output']>;
  red?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  substitutions?: Maybe<Scalars['Boolean']['output']>;
  yellow?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationMatchUpdatesInput = {
  goals?: InputMaybe<Scalars['Boolean']['input']>;
  red?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  substitutions?: InputMaybe<Scalars['Boolean']['input']>;
  yellow?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PerryCrossLinkByMatchId = {
  __typename?: 'PerryCrossLinkByMatchId';
  items: Array<Maybe<CrossLink>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type Player = {
  __typename?: 'Player';
  competition?: Maybe<Competition>;
  createdAt: Scalars['AWSDateTime']['output'];
  editorialData?: Maybe<EditorialData>;
  editorialDataId?: Maybe<Scalars['ID']['output']>;
  playerId: Scalars['ID']['output'];
  playerJson: Scalars['AWSJSON']['output'];
  role?: Maybe<Scalars['String']['output']>;
  seasonAndCompId: Scalars['ID']['output'];
  team?: Maybe<Team>;
  teamId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type PlayerData = {
  __typename?: 'PlayerData';
  action: Scalars['String']['output'];
  competitionId: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  data?: Maybe<Scalars['AWSJSON']['output']>;
  messageType: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  seasonAndCompId: Scalars['ID']['output'];
  seasonId: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type PlayerPagesStats = {
  __typename?: 'PlayerPagesStats';
  createdAt: Scalars['AWSDateTime']['output'];
  playerId: Scalars['ID']['output'];
  playerRole: Scalars['String']['output'];
  statistics?: Maybe<Array<Maybe<PlayerPagesStatsSeasonCompStat>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type PlayerPagesStatsChartStats = {
  __typename?: 'PlayerPagesStatsChartStats';
  failure?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PlayerPagesStatsChartStatsInput = {
  failure?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PlayerPagesStatsNumericStats = {
  __typename?: 'PlayerPagesStatsNumericStats';
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type PlayerPagesStatsNumericStatsInput = {
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PlayerPagesStatsSeasonCompStat = {
  __typename?: 'PlayerPagesStatsSeasonCompStat';
  charts?: Maybe<Array<Maybe<PlayerPagesStatsChartStats>>>;
  customCompetitionName?: Maybe<Scalars['String']['output']>;
  customSeasonName?: Maybe<Scalars['String']['output']>;
  seasonAndCompId?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<Array<Maybe<PlayerPagesStatsNumericStats>>>;
};

export type PlayerPagesStatsSeasonCompStatInput = {
  charts?: InputMaybe<Array<InputMaybe<PlayerPagesStatsChartStatsInput>>>;
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  customSeasonName?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['String']['input']>;
  stats?: InputMaybe<Array<InputMaybe<PlayerPagesStatsNumericStatsInput>>>;
};

export type PlayerRanking = {
  __typename?: 'PlayerRanking';
  competition?: Maybe<Competition>;
  createdAt: Scalars['AWSDateTime']['output'];
  player?: Maybe<Player>;
  playerId: Scalars['ID']['output'];
  playerRankingJson: Scalars['AWSJSON']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  seasonAndCompId: Scalars['ID']['output'];
  team?: Maybe<Team>;
  teamId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type PlayerStats = {
  __typename?: 'PlayerStats';
  createdAt: Scalars['AWSDateTime']['output'];
  player?: Maybe<Player>;
  playerId: Scalars['ID']['output'];
  seasonAndCompId: Scalars['ID']['output'];
  statsJson?: Maybe<Scalars['AWSJSON']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type PredictedLineup = {
  __typename?: 'PredictedLineup';
  awayTeam?: Maybe<Team>;
  awayTeamId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  homeTeam?: Maybe<Team>;
  homeTeamId: Scalars['ID']['output'];
  match?: Maybe<Match>;
  matchId: Scalars['ID']['output'];
  predictedLineupJson: Scalars['AWSJSON']['output'];
  predictedLineupRound?: Maybe<PredictedLineupRound>;
  round: Scalars['Int']['output'];
  seasonAndCompId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type PredictedLineupDetails = {
  __typename?: 'PredictedLineupDetails';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  hasHeadshots?: Maybe<Scalars['Boolean']['output']>;
  matchData?: Maybe<PredictedLineupMatch>;
  predictedHpLink?: Maybe<Scalars['String']['output']>;
  predictedSponsorLink?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type PredictedLineupHomepage = {
  __typename?: 'PredictedLineupHomepage';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  matchList?: Maybe<Array<Maybe<PredictedLineupMatch>>>;
  round: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type PredictedLineupMatch = {
  __typename?: 'PredictedLineupMatch';
  away?: Maybe<PredictedLineupTeam>;
  date?: Maybe<Scalars['String']['output']>;
  home?: Maybe<PredictedLineupTeam>;
  lmpLineupLink?: Maybe<Scalars['String']['output']>;
  lmpLink?: Maybe<Scalars['String']['output']>;
  matchId: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type PredictedLineupMatchInput = {
  away?: InputMaybe<PredictedLineupTeamInput>;
  date?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<PredictedLineupTeamInput>;
  lmpLineupLink?: InputMaybe<Scalars['String']['input']>;
  lmpLink?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PredictedLineupPlayer = {
  __typename?: 'PredictedLineupPlayer';
  fallbackPhotoUrl?: Maybe<Scalars['String']['output']>;
  formationPlace?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  jerseyNum?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  playerPageLink?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type PredictedLineupPlayerInput = {
  fallbackPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  formationPlace?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  jerseyNum?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  playerPageLink?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type PredictedLineupPlayerList = {
  __typename?: 'PredictedLineupPlayerList';
  disqualifiedPlayers?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<Scalars['String']['output']>;
  potentialPlayers?: Maybe<Scalars['String']['output']>;
  predictedLineup?: Maybe<Array<Maybe<PredictedLineupPlayer>>>;
  substitutePlayers?: Maybe<Scalars['String']['output']>;
  unavailablePlayers?: Maybe<Scalars['String']['output']>;
};

export type PredictedLineupPlayerListInput = {
  disqualifiedPlayers?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<Scalars['String']['input']>;
  potentialPlayers?: InputMaybe<Scalars['String']['input']>;
  predictedLineup?: InputMaybe<Array<InputMaybe<PredictedLineupPlayerInput>>>;
  substitutePlayers?: InputMaybe<Scalars['String']['input']>;
  unavailablePlayers?: InputMaybe<Scalars['String']['input']>;
};

export type PredictedLineupRound = {
  __typename?: 'PredictedLineupRound';
  createdAt: Scalars['AWSDateTime']['output'];
  round: Scalars['Int']['output'];
  seasonAndCompId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type PredictedLineupTeam = {
  __typename?: 'PredictedLineupTeam';
  customName?: Maybe<Scalars['String']['output']>;
  customSeoName?: Maybe<Scalars['String']['output']>;
  formation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  negativeLogoUrl?: Maybe<Scalars['String']['output']>;
  playerList?: Maybe<PredictedLineupPlayerList>;
  predictedTeamLink?: Maybe<Scalars['String']['output']>;
  teamShortName?: Maybe<Scalars['String']['output']>;
};

export type PredictedLineupTeamInput = {
  customName?: InputMaybe<Scalars['String']['input']>;
  customSeoName?: InputMaybe<Scalars['String']['input']>;
  formation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  negativeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  playerList?: InputMaybe<PredictedLineupPlayerListInput>;
  predictedTeamLink?: InputMaybe<Scalars['String']['input']>;
  teamShortName?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  composerListCompetitions?: Maybe<ComposerListCompetitions>;
  getCalendarAndResultsGlider?: Maybe<CalendarAndResultsGlider>;
  getCardCompetitionCalendar?: Maybe<CardCompetitionCalendar>;
  getCardCompetitionRanking?: Maybe<CardCompetitionRanking>;
  getCommentsByMatchId?: Maybe<ModelMatchCommentConnection>;
  getCompetition?: Maybe<Competition>;
  getCompetitionBoard?: Maybe<CompetitionBoard>;
  getCompetitionById?: Maybe<ModelCompetitionConnection>;
  getCompetitionBySeasonId?: Maybe<ModelCompetitionConnection>;
  getCompetitionCalendarAndResults?: Maybe<CompetitionCalendarAndResults>;
  getCompetitionRanking?: Maybe<CompetitionRanking>;
  getCompetitionReports?: Maybe<CompetitionReports>;
  getCompetitionScorersRanking?: Maybe<CompetitionScorersRanking>;
  getCompetitionTeam?: Maybe<CompetitionTeam>;
  getCrossLink?: Maybe<CrossLink>;
  getCrossLinkByMatchId?: Maybe<ModelCrossLinkConnection>;
  getCurrentRound?: Maybe<CurrentRound>;
  getCurrentTime?: Maybe<CurrentTime>;
  getDayList?: Maybe<DayList>;
  getEditorialData?: Maybe<EditorialData>;
  getEditorialDataById?: Maybe<ModelEditorialDataConnection>;
  getLastAndNextMatch?: Maybe<LastAndNextMatch>;
  getLiveScore?: Maybe<LiveScore>;
  getLmpHero?: Maybe<LmpHero>;
  getLmpHeroSticky?: Maybe<LmpHeroSticky>;
  getLmpLineup?: Maybe<LmpLineup>;
  getLmpMatchChange?: Maybe<LmpMatchChange>;
  getLmpPredictedLineupDetails?: Maybe<LmpPredictedLineupDetails>;
  getLmpPreviewText?: Maybe<LmpPreviewText>;
  getLmpStatistics?: Maybe<LmpStatistics>;
  getMatch?: Maybe<Match>;
  getMatchByDate?: Maybe<ModelMatchConnection>;
  getMatchById?: Maybe<ModelMatchConnection>;
  getMatchByRound?: Maybe<ModelMatchConnection>;
  getMatchBySeasonAndCompId?: Maybe<ModelMatchConnection>;
  getMatchCard?: Maybe<MatchCard>;
  getMatchChange?: Maybe<MatchChange>;
  getMatchComment?: Maybe<MatchComment>;
  getMatchComments?: Maybe<MatchComments>;
  getMatchData?: Maybe<MatchData>;
  getMatchPlayerForReport?: Maybe<MatchPlayersForReport>;
  getMatchReportsByRound?: Maybe<MatchReportByRound>;
  getNotificationMatch?: Maybe<NotificationMatch>;
  getPlayer?: Maybe<Player>;
  getPlayerById?: Maybe<ModelPlayerConnection>;
  getPlayerData?: Maybe<PlayerData>;
  getPlayerPagesStats?: Maybe<PlayerPagesStats>;
  getPlayerRanking?: Maybe<PlayerRanking>;
  getPlayerRankingByPosition?: Maybe<ModelPlayerRankingConnection>;
  getPlayerStats?: Maybe<PlayerStats>;
  getPlayerStatsByPlayerId?: Maybe<ModelPlayerStatsConnection>;
  getPlayersByTeam?: Maybe<ModelPlayerConnection>;
  getPredictedLineup?: Maybe<PredictedLineup>;
  getPredictedLineupByRound?: Maybe<ModelPredictedLineupConnection>;
  getPredictedLineupDetails?: Maybe<PredictedLineupDetails>;
  getPredictedLineupHomepage?: Maybe<PredictedLineupHomepage>;
  getPredictedLineupRound?: Maybe<PredictedLineupRound>;
  getRanking?: Maybe<Ranking>;
  getRankingByPosition?: Maybe<ModelRankingConnection>;
  getReport?: Maybe<Report>;
  getReportDetails?: Maybe<ReportDetails>;
  getScorersRankingPlayerPage?: Maybe<ScorersRankingPlayerPage>;
  getSeason?: Maybe<Season>;
  getTeam?: Maybe<Team>;
  getTeamById?: Maybe<ModelTeamConnection>;
  getTeamCalendarAndResults?: Maybe<TeamCalendarAndResults>;
  getTeamPlayers?: Maybe<TeamPlayers>;
  getTeamRanking?: Maybe<TeamRanking>;
  listCalendarAndResultsGliders?: Maybe<ModelCalendarAndResultsGliderConnection>;
  listCardCompetitionCalendars?: Maybe<ModelCardCompetitionCalendarConnection>;
  listCardCompetitionRankings?: Maybe<ModelCardCompetitionRankingConnection>;
  listCompetitionBoards?: Maybe<ModelCompetitionBoardConnection>;
  listCompetitionCalendarAndResultss?: Maybe<ModelCompetitionCalendarAndResultsConnection>;
  listCompetitionRankings?: Maybe<ModelCompetitionRankingConnection>;
  listCompetitionReportss?: Maybe<ModelCompetitionReportsConnection>;
  listCompetitionScorersRankings?: Maybe<ModelCompetitionScorersRankingConnection>;
  listCompetitionTeams?: Maybe<ModelCompetitionTeamConnection>;
  listCompetitions?: Maybe<ModelCompetitionConnection>;
  listCrossLinks?: Maybe<ModelCrossLinkConnection>;
  listEditorialDatas?: Maybe<ModelEditorialDataConnection>;
  listLastAndNextMatchs?: Maybe<ModelLastAndNextMatchConnection>;
  listLiveScores?: Maybe<ModelLiveScoreConnection>;
  listLmpHeroStickys?: Maybe<ModelLmpHeroStickyConnection>;
  listLmpHeros?: Maybe<ModelLmpHeroConnection>;
  listLmpLineups?: Maybe<ModelLmpLineupConnection>;
  listLmpMatchChanges?: Maybe<ModelLmpMatchChangeConnection>;
  listLmpPredictedLineupDetailss?: Maybe<ModelLmpPredictedLineupDetailsConnection>;
  listLmpPreviewTexts?: Maybe<ModelLmpPreviewTextConnection>;
  listLmpStatisticss?: Maybe<ModelLmpStatisticsConnection>;
  listMatchCards?: Maybe<ModelMatchCardConnection>;
  listMatchChanges?: Maybe<ModelMatchChangeConnection>;
  listMatchComments?: Maybe<ModelMatchCommentConnection>;
  listMatchCommentss?: Maybe<ModelMatchCommentsConnection>;
  listMatchDatas?: Maybe<ModelMatchDataConnection>;
  listMatchs?: Maybe<ModelMatchConnection>;
  listNotificationMatchs?: Maybe<ModelNotificationMatchConnection>;
  listPlayerDatas?: Maybe<ModelPlayerDataConnection>;
  listPlayerPagesStatss?: Maybe<ModelPlayerPagesStatsConnection>;
  listPlayerRankings?: Maybe<ModelPlayerRankingConnection>;
  listPlayerStatss?: Maybe<ModelPlayerStatsConnection>;
  listPlayers?: Maybe<ModelPlayerConnection>;
  listPredictedLineupDetailss?: Maybe<ModelPredictedLineupDetailsConnection>;
  listPredictedLineupHomepages?: Maybe<ModelPredictedLineupHomepageConnection>;
  listPredictedLineupRounds?: Maybe<ModelPredictedLineupRoundConnection>;
  listPredictedLineups?: Maybe<ModelPredictedLineupConnection>;
  listRankings?: Maybe<ModelRankingConnection>;
  listReportDetailss?: Maybe<ModelReportDetailsConnection>;
  listReports?: Maybe<ModelReportConnection>;
  listScorersRankingPlayerPages?: Maybe<ModelScorersRankingPlayerPageConnection>;
  listSeasons?: Maybe<ModelSeasonConnection>;
  listTeamCalendarAndResultss?: Maybe<ModelTeamCalendarAndResultsConnection>;
  listTeamPlayerss?: Maybe<ModelTeamPlayersConnection>;
  listTeamRankings?: Maybe<ModelTeamRankingConnection>;
  listTeams?: Maybe<ModelTeamConnection>;
  perryGetCrossLinkByMatchId?: Maybe<PerryCrossLinkByMatchId>;
};


export type QuerycomposerListCompetitionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetCalendarAndResultsGliderArgs = {
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};


export type QuerygetCardCompetitionCalendarArgs = {
  competitionId: Scalars['ID']['input'];
};


export type QuerygetCardCompetitionRankingArgs = {
  competitionId: Scalars['ID']['input'];
};


export type QuerygetCommentsByMatchIdArgs = {
  filter?: InputMaybe<ModelMatchCommentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetCompetitionArgs = {
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetCompetitionBoardArgs = {
  competitionId: Scalars['ID']['input'];
};


export type QuerygetCompetitionByIdArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetCompetitionBySeasonIdArgs = {
  filter?: InputMaybe<ModelCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetCompetitionCalendarAndResultsArgs = {
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};


export type QuerygetCompetitionRankingArgs = {
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};


export type QuerygetCompetitionReportsArgs = {
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};


export type QuerygetCompetitionScorersRankingArgs = {
  competitionId: Scalars['ID']['input'];
  page: Scalars['String']['input'];
  seasonId: Scalars['ID']['input'];
};


export type QuerygetCompetitionTeamArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetCrossLinkArgs = {
  matchId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetCrossLinkByMatchIdArgs = {
  filter?: InputMaybe<ModelCrossLinkFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetCurrentRoundArgs = {
  competitionId: Scalars['String']['input'];
  seasonId: Scalars['String']['input'];
};


export type QuerygetDayListArgs = {
  competitionId: Scalars['String']['input'];
  filter?: InputMaybe<ModelGetDayListFilterInput>;
  findCurrentSeason?: InputMaybe<Scalars['Boolean']['input']>;
  seasonId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetEditorialDataArgs = {
  editorialDataId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetEditorialDataByIdArgs = {
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelEditorialDataFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetLastAndNextMatchArgs = {
  teamId: Scalars['ID']['input'];
};


export type QuerygetLiveScoreArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetLmpHeroArgs = {
  matchId: Scalars['ID']['input'];
};


export type QuerygetLmpHeroStickyArgs = {
  matchId: Scalars['ID']['input'];
};


export type QuerygetLmpLineupArgs = {
  matchId: Scalars['ID']['input'];
};


export type QuerygetLmpMatchChangeArgs = {
  matchId: Scalars['ID']['input'];
};


export type QuerygetLmpPredictedLineupDetailsArgs = {
  matchId: Scalars['ID']['input'];
};


export type QuerygetLmpPreviewTextArgs = {
  matchId: Scalars['ID']['input'];
};


export type QuerygetLmpStatisticsArgs = {
  matchId: Scalars['ID']['input'];
};


export type QuerygetMatchArgs = {
  matchId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetMatchByDateArgs = {
  date?: InputMaybe<ModelIntKeyConditionInput>;
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetMatchByIdArgs = {
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetMatchByRoundArgs = {
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<ModelIntKeyConditionInput>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetMatchBySeasonAndCompIdArgs = {
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetMatchCardArgs = {
  matchId: Scalars['ID']['input'];
};


export type QuerygetMatchChangeArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetMatchCommentArgs = {
  commentId: Scalars['ID']['input'];
  matchId: Scalars['ID']['input'];
};


export type QuerygetMatchCommentsArgs = {
  matchId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
};


export type QuerygetMatchDataArgs = {
  matchId: Scalars['ID']['input'];
};


export type QuerygetMatchPlayerForReportArgs = {
  competitionId: Scalars['String']['input'];
  matchId: Scalars['String']['input'];
  seasonId: Scalars['String']['input'];
};


export type QuerygetMatchReportsByRoundArgs = {
  competitionId: Scalars['String']['input'];
  round: Scalars['Int']['input'];
  seasonId: Scalars['String']['input'];
};


export type QuerygetNotificationMatchArgs = {
  matchId: Scalars['ID']['input'];
};


export type QuerygetPlayerArgs = {
  playerId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetPlayerByIdArgs = {
  filter?: InputMaybe<ModelPlayerFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetPlayerDataArgs = {
  playerId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetPlayerPagesStatsArgs = {
  playerId: Scalars['ID']['input'];
};


export type QuerygetPlayerRankingArgs = {
  playerId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetPlayerRankingByPositionArgs = {
  filter?: InputMaybe<ModelPlayerRankingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<ModelIntKeyConditionInput>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetPlayerStatsArgs = {
  playerId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetPlayerStatsByPlayerIdArgs = {
  filter?: InputMaybe<ModelPlayerStatsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetPlayersByTeamArgs = {
  filter?: InputMaybe<ModelPlayerFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId?: InputMaybe<ModelIDKeyConditionInput>;
};


export type QuerygetPredictedLineupArgs = {
  matchId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetPredictedLineupByRoundArgs = {
  filter?: InputMaybe<ModelPredictedLineupFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<ModelIntKeyConditionInput>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetPredictedLineupDetailsArgs = {
  competitionId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type QuerygetPredictedLineupHomepageArgs = {
  competitionId: Scalars['ID']['input'];
};


export type QuerygetPredictedLineupRoundArgs = {
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetRankingArgs = {
  seasonAndCompId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type QuerygetRankingByPositionArgs = {
  filter?: InputMaybe<ModelRankingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<ModelIntKeyConditionInput>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerygetReportArgs = {
  matchId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};


export type QuerygetReportDetailsArgs = {
  competitionId: Scalars['ID']['input'];
  round: Scalars['Int']['input'];
  seasonId: Scalars['ID']['input'];
};


export type QuerygetScorersRankingPlayerPageArgs = {
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};


export type QuerygetSeasonArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetTeamArgs = {
  seasonAndCompId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type QuerygetTeamByIdArgs = {
  filter?: InputMaybe<ModelTeamFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<ModelIDKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerygetTeamCalendarAndResultsArgs = {
  teamId: Scalars['ID']['input'];
};


export type QuerygetTeamPlayersArgs = {
  teamId: Scalars['ID']['input'];
};


export type QuerygetTeamRankingArgs = {
  teamId: Scalars['ID']['input'];
};


export type QuerylistCalendarAndResultsGlidersArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelCalendarAndResultsGliderFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<ModelIDKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCardCompetitionCalendarsArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelCardCompetitionCalendarFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCardCompetitionRankingsArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelCardCompetitionRankingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCompetitionBoardsArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelCompetitionBoardFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCompetitionCalendarAndResultssArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelCompetitionCalendarAndResultsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<ModelIDKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCompetitionRankingsArgs = {
  competitionId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelCompetitionRankingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCompetitionReportssArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelCompetitionReportsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<ModelIDKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCompetitionScorersRankingsArgs = {
  filter?: InputMaybe<ModelCompetitionScorersRankingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
  seasonIdCompetitionId?: InputMaybe<ModelCompetitionScorersRankingPrimaryCompositeKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCompetitionTeamsArgs = {
  filter?: InputMaybe<ModelCompetitionTeamFilterInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCompetitionsArgs = {
  filter?: InputMaybe<ModelCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistCrossLinksArgs = {
  filter?: InputMaybe<ModelCrossLinkFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<ModelIDKeyConditionInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistEditorialDatasArgs = {
  editorialDataId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelEditorialDataFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLastAndNextMatchsArgs = {
  filter?: InputMaybe<ModelLastAndNextMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerylistLiveScoresArgs = {
  filter?: InputMaybe<ModelLiveScoreFilterInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLmpHeroStickysArgs = {
  filter?: InputMaybe<ModelLmpHeroStickyFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLmpHerosArgs = {
  filter?: InputMaybe<ModelLmpHeroFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLmpLineupsArgs = {
  filter?: InputMaybe<ModelLmpLineupFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLmpMatchChangesArgs = {
  filter?: InputMaybe<ModelLmpMatchChangeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLmpPredictedLineupDetailssArgs = {
  filter?: InputMaybe<ModelLmpPredictedLineupDetailsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLmpPreviewTextsArgs = {
  filter?: InputMaybe<ModelLmpPreviewTextFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistLmpStatisticssArgs = {
  filter?: InputMaybe<ModelLmpStatisticsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistMatchCardsArgs = {
  filter?: InputMaybe<ModelMatchCardFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistMatchChangesArgs = {
  filter?: InputMaybe<ModelMatchChangeFilterInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistMatchCommentsArgs = {
  commentId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelMatchCommentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistMatchCommentssArgs = {
  filter?: InputMaybe<ModelMatchCommentsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<ModelIntKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistMatchDatasArgs = {
  filter?: InputMaybe<ModelMatchDataFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistMatchsArgs = {
  filter?: InputMaybe<ModelMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<ModelIDKeyConditionInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistNotificationMatchsArgs = {
  filter?: InputMaybe<ModelNotificationMatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistPlayerDatasArgs = {
  filter?: InputMaybe<ModelPlayerDataFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<ModelIDKeyConditionInput>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistPlayerPagesStatssArgs = {
  filter?: InputMaybe<ModelPlayerPagesStatsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistPlayerRankingsArgs = {
  filter?: InputMaybe<ModelPlayerRankingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<ModelIDKeyConditionInput>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistPlayerStatssArgs = {
  filter?: InputMaybe<ModelPlayerStatsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<ModelIDKeyConditionInput>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistPlayersArgs = {
  filter?: InputMaybe<ModelPlayerFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<ModelIDKeyConditionInput>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistPredictedLineupDetailssArgs = {
  competitionId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelPredictedLineupDetailsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerylistPredictedLineupHomepagesArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelPredictedLineupHomepageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistPredictedLineupRoundsArgs = {
  filter?: InputMaybe<ModelPredictedLineupRoundFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistPredictedLineupsArgs = {
  filter?: InputMaybe<ModelPredictedLineupFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<ModelIDKeyConditionInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistRankingsArgs = {
  filter?: InputMaybe<ModelRankingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId?: InputMaybe<ModelIDKeyConditionInput>;
};


export type QuerylistReportDetailssArgs = {
  filter?: InputMaybe<ModelReportDetailsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Int']['input']>;
  seasonIdCompetitionId?: InputMaybe<ModelReportDetailsPrimaryCompositeKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistReportsArgs = {
  filter?: InputMaybe<ModelReportFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<ModelIDKeyConditionInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistScorersRankingPlayerPagesArgs = {
  competitionId?: InputMaybe<ModelIDKeyConditionInput>;
  filter?: InputMaybe<ModelScorersRankingPlayerPageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistSeasonsArgs = {
  filter?: InputMaybe<ModelSeasonFilterInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QuerylistTeamCalendarAndResultssArgs = {
  filter?: InputMaybe<ModelTeamCalendarAndResultsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerylistTeamPlayerssArgs = {
  filter?: InputMaybe<ModelTeamPlayersFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerylistTeamRankingsArgs = {
  filter?: InputMaybe<ModelTeamRankingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerylistTeamsArgs = {
  filter?: InputMaybe<ModelTeamFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId?: InputMaybe<ModelIDKeyConditionInput>;
};


export type QueryperryGetCrossLinkByMatchIdArgs = {
  matchId: Scalars['String']['input'];
};

export type Ranking = {
  __typename?: 'Ranking';
  competition?: Maybe<Competition>;
  createdAt: Scalars['AWSDateTime']['output'];
  matchDayId: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  rankingJson: Scalars['AWSJSON']['output'];
  roundName: Scalars['String']['output'];
  seasonAndCompId: Scalars['ID']['output'];
  team?: Maybe<Team>;
  teamId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type Report = {
  __typename?: 'Report';
  createdAt: Scalars['AWSDateTime']['output'];
  matchId: Scalars['ID']['output'];
  reportJson: Scalars['AWSJSON']['output'];
  seasonAndCompId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ReportByRoundMatch = {
  __typename?: 'ReportByRoundMatch';
  away?: Maybe<ReportByRoundTeam>;
  date?: Maybe<Scalars['AWSDateTime']['output']>;
  home?: Maybe<ReportByRoundTeam>;
  id?: Maybe<Scalars['ID']['output']>;
  reportStatus?: Maybe<Scalars['String']['output']>;
};

export type ReportByRoundTeam = {
  __typename?: 'ReportByRoundTeam';
  goal?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ReportDetails = {
  __typename?: 'ReportDetails';
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  reports?: Maybe<Array<Maybe<ReportDetailsMatch>>>;
  reportsHomepageUrl?: Maybe<Scalars['String']['output']>;
  round: Scalars['Int']['output'];
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ReportDetailsMatch = {
  __typename?: 'ReportDetailsMatch';
  away?: Maybe<ReportDetailsMatchTeam>;
  date?: Maybe<Scalars['String']['output']>;
  home?: Maybe<ReportDetailsMatchTeam>;
  matchId?: Maybe<Scalars['ID']['output']>;
  referees?: Maybe<Array<Maybe<ReportDetailsMatchTeamPlayer>>>;
  reportStatus?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ReportDetailsMatchInput = {
  away?: InputMaybe<ReportDetailsMatchTeamInput>;
  date?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<ReportDetailsMatchTeamInput>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  referees?: InputMaybe<Array<InputMaybe<ReportDetailsMatchTeamPlayerInput>>>;
  reportStatus?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ReportDetailsMatchTeam = {
  __typename?: 'ReportDetailsMatchTeam';
  goal?: Maybe<Scalars['Int']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  negativeLogoUrl?: Maybe<Scalars['String']['output']>;
  playerList?: Maybe<ReportDetailsMatchTeamPlayerList>;
  seoName?: Maybe<Scalars['String']['output']>;
  shortname?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['ID']['output']>;
};

export type ReportDetailsMatchTeamInput = {
  goal?: InputMaybe<Scalars['Int']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  negativeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  playerList?: InputMaybe<ReportDetailsMatchTeamPlayerListInput>;
  seoName?: InputMaybe<Scalars['String']['input']>;
  shortname?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type ReportDetailsMatchTeamPlayer = {
  __typename?: 'ReportDetailsMatchTeamPlayer';
  fullname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  playerPageLink?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  topPlayer?: Maybe<Scalars['Boolean']['output']>;
  vote?: Maybe<Scalars['String']['output']>;
};

export type ReportDetailsMatchTeamPlayerInput = {
  fullname?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  playerPageLink?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  topPlayer?: InputMaybe<Scalars['Boolean']['input']>;
  vote?: InputMaybe<Scalars['String']['input']>;
};

export type ReportDetailsMatchTeamPlayerList = {
  __typename?: 'ReportDetailsMatchTeamPlayerList';
  manager?: Maybe<ReportDetailsMatchTeamPlayer>;
  startingLineup?: Maybe<Array<Maybe<ReportDetailsMatchTeamPlayer>>>;
  substitutes?: Maybe<Array<Maybe<ReportDetailsMatchTeamPlayer>>>;
};

export type ReportDetailsMatchTeamPlayerListInput = {
  manager?: InputMaybe<ReportDetailsMatchTeamPlayerInput>;
  startingLineup?: InputMaybe<Array<InputMaybe<ReportDetailsMatchTeamPlayerInput>>>;
  substitutes?: InputMaybe<Array<InputMaybe<ReportDetailsMatchTeamPlayerInput>>>;
};

export type ScorersRanking = {
  __typename?: 'ScorersRanking';
  goal?: Maybe<Scalars['Int']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  playerId?: Maybe<Scalars['ID']['output']>;
  playerImageUrl?: Maybe<Scalars['String']['output']>;
  playerPageLink?: Maybe<Scalars['String']['output']>;
  playerSurname?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  seoTeamName?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['ID']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  teamUrl?: Maybe<Scalars['String']['output']>;
};

export type ScorersRankingInput = {
  goal?: InputMaybe<Scalars['Int']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  playerImageUrl?: InputMaybe<Scalars['String']['input']>;
  playerPageLink?: InputMaybe<Scalars['String']['input']>;
  playerSurname?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  seoTeamName?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  teamUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ScorersRankingPlayerPage = {
  __typename?: 'ScorersRankingPlayerPage';
  competitionCalendarUrl?: Maybe<Scalars['String']['output']>;
  competitionId: Scalars['ID']['output'];
  competitionName?: Maybe<Scalars['String']['output']>;
  competitionSlugName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  scorers?: Maybe<Array<Maybe<ScorersRanking>>>;
  seasonId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type Season = {
  __typename?: 'Season';
  competitions?: Maybe<ModelCompetitionConnection>;
  createdAt: Scalars['AWSDateTime']['output'];
  editorialData?: Maybe<Scalars['AWSJSON']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type SeasoncompetitionsArgs = {
  filter?: InputMaybe<ModelCompetitionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type SeoCustomData = {
  __typename?: 'SeoCustomData';
  customName?: Maybe<Scalars['String']['output']>;
  seoName?: Maybe<Scalars['String']['output']>;
};

export type SeoCustomDataInput = {
  customName?: InputMaybe<Scalars['String']['input']>;
  seoName?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onCreateCalendarAndResultsGlider?: Maybe<CalendarAndResultsGlider>;
  onCreateCardCompetitionCalendar?: Maybe<CardCompetitionCalendar>;
  onCreateCardCompetitionRanking?: Maybe<CardCompetitionRanking>;
  onCreateCompetition?: Maybe<Competition>;
  onCreateCompetitionBoard?: Maybe<CompetitionBoard>;
  onCreateCompetitionCalendarAndResults?: Maybe<CompetitionCalendarAndResults>;
  onCreateCompetitionRanking?: Maybe<CompetitionRanking>;
  onCreateCompetitionReports?: Maybe<CompetitionReports>;
  onCreateCompetitionScorersRanking?: Maybe<CompetitionScorersRanking>;
  onCreateCompetitionTeam?: Maybe<CompetitionTeam>;
  onCreateCrossLink?: Maybe<CrossLink>;
  onCreateEditorialData?: Maybe<EditorialData>;
  onCreateLastAndNextMatch?: Maybe<LastAndNextMatch>;
  onCreateLiveScore?: Maybe<LiveScore>;
  onCreateLmpHero?: Maybe<LmpHero>;
  onCreateLmpHeroSticky?: Maybe<LmpHeroSticky>;
  onCreateLmpLineup?: Maybe<LmpLineup>;
  onCreateLmpMatchChange?: Maybe<LmpMatchChange>;
  onCreateLmpPredictedLineupDetails?: Maybe<LmpPredictedLineupDetails>;
  onCreateLmpPreviewText?: Maybe<LmpPreviewText>;
  onCreateLmpStatistics?: Maybe<LmpStatistics>;
  onCreateMatch?: Maybe<Match>;
  onCreateMatchCard?: Maybe<MatchCard>;
  onCreateMatchChange?: Maybe<MatchChange>;
  onCreateMatchComment?: Maybe<MatchComment>;
  onCreateMatchComments?: Maybe<MatchComments>;
  onCreateMatchData?: Maybe<MatchData>;
  onCreateNotificationMatch?: Maybe<NotificationMatch>;
  onCreatePlayer?: Maybe<Player>;
  onCreatePlayerData?: Maybe<PlayerData>;
  onCreatePlayerPagesStats?: Maybe<PlayerPagesStats>;
  onCreatePlayerRanking?: Maybe<PlayerRanking>;
  onCreatePlayerStats?: Maybe<PlayerStats>;
  onCreatePredictedLineup?: Maybe<PredictedLineup>;
  onCreatePredictedLineupDetails?: Maybe<PredictedLineupDetails>;
  onCreatePredictedLineupHomepage?: Maybe<PredictedLineupHomepage>;
  onCreatePredictedLineupRound?: Maybe<PredictedLineupRound>;
  onCreateRanking?: Maybe<Ranking>;
  onCreateReport?: Maybe<Report>;
  onCreateReportDetails?: Maybe<ReportDetails>;
  onCreateScorersRankingPlayerPage?: Maybe<ScorersRankingPlayerPage>;
  onCreateSeason?: Maybe<Season>;
  onCreateTeam?: Maybe<Team>;
  onCreateTeamCalendarAndResults?: Maybe<TeamCalendarAndResults>;
  onCreateTeamPlayers?: Maybe<TeamPlayers>;
  onCreateTeamRanking?: Maybe<TeamRanking>;
  onDeleteCalendarAndResultsGlider?: Maybe<CalendarAndResultsGlider>;
  onDeleteCardCompetitionCalendar?: Maybe<CardCompetitionCalendar>;
  onDeleteCardCompetitionRanking?: Maybe<CardCompetitionRanking>;
  onDeleteCompetition?: Maybe<Competition>;
  onDeleteCompetitionBoard?: Maybe<CompetitionBoard>;
  onDeleteCompetitionCalendarAndResults?: Maybe<CompetitionCalendarAndResults>;
  onDeleteCompetitionRanking?: Maybe<CompetitionRanking>;
  onDeleteCompetitionReports?: Maybe<CompetitionReports>;
  onDeleteCompetitionScorersRanking?: Maybe<CompetitionScorersRanking>;
  onDeleteCompetitionTeam?: Maybe<CompetitionTeam>;
  onDeleteCrossLink?: Maybe<CrossLink>;
  onDeleteEditorialData?: Maybe<EditorialData>;
  onDeleteLastAndNextMatch?: Maybe<LastAndNextMatch>;
  onDeleteLiveScore?: Maybe<LiveScore>;
  onDeleteLmpHero?: Maybe<LmpHero>;
  onDeleteLmpHeroSticky?: Maybe<LmpHeroSticky>;
  onDeleteLmpLineup?: Maybe<LmpLineup>;
  onDeleteLmpMatchChange?: Maybe<LmpMatchChange>;
  onDeleteLmpPredictedLineupDetails?: Maybe<LmpPredictedLineupDetails>;
  onDeleteLmpPreviewText?: Maybe<LmpPreviewText>;
  onDeleteLmpStatistics?: Maybe<LmpStatistics>;
  onDeleteMatch?: Maybe<Match>;
  onDeleteMatchCard?: Maybe<MatchCard>;
  onDeleteMatchChange?: Maybe<MatchChange>;
  onDeleteMatchComment?: Maybe<MatchComment>;
  onDeleteMatchComments?: Maybe<MatchComments>;
  onDeleteMatchData?: Maybe<MatchData>;
  onDeleteNotificationMatch?: Maybe<NotificationMatch>;
  onDeletePlayer?: Maybe<Player>;
  onDeletePlayerData?: Maybe<PlayerData>;
  onDeletePlayerPagesStats?: Maybe<PlayerPagesStats>;
  onDeletePlayerRanking?: Maybe<PlayerRanking>;
  onDeletePlayerStats?: Maybe<PlayerStats>;
  onDeletePredictedLineup?: Maybe<PredictedLineup>;
  onDeletePredictedLineupDetails?: Maybe<PredictedLineupDetails>;
  onDeletePredictedLineupHomepage?: Maybe<PredictedLineupHomepage>;
  onDeletePredictedLineupRound?: Maybe<PredictedLineupRound>;
  onDeleteRanking?: Maybe<Ranking>;
  onDeleteReport?: Maybe<Report>;
  onDeleteReportDetails?: Maybe<ReportDetails>;
  onDeleteScorersRankingPlayerPage?: Maybe<ScorersRankingPlayerPage>;
  onDeleteSeason?: Maybe<Season>;
  onDeleteTeam?: Maybe<Team>;
  onDeleteTeamCalendarAndResults?: Maybe<TeamCalendarAndResults>;
  onDeleteTeamPlayers?: Maybe<TeamPlayers>;
  onDeleteTeamRanking?: Maybe<TeamRanking>;
  onUpdateCalendarAndResultsGlider?: Maybe<CalendarAndResultsGlider>;
  onUpdateCardCompetitionCalendar?: Maybe<CardCompetitionCalendar>;
  onUpdateCardCompetitionRanking?: Maybe<CardCompetitionRanking>;
  onUpdateCardFootballRankingByCompetitionId?: Maybe<CardCompetitionRanking>;
  onUpdateCompetition?: Maybe<Competition>;
  onUpdateCompetitionBoard?: Maybe<CompetitionBoard>;
  onUpdateCompetitionCalendarAndResults?: Maybe<CompetitionCalendarAndResults>;
  onUpdateCompetitionRanking?: Maybe<CompetitionRanking>;
  onUpdateCompetitionRankingBySeasonIdAndCompId?: Maybe<CompetitionRanking>;
  onUpdateCompetitionReports?: Maybe<CompetitionReports>;
  onUpdateCompetitionScorersRanking?: Maybe<CompetitionScorersRanking>;
  onUpdateCompetitionTeam?: Maybe<CompetitionTeam>;
  onUpdateCrossLink?: Maybe<CrossLink>;
  onUpdateEditorialData?: Maybe<EditorialData>;
  onUpdateLastAndNextMatch?: Maybe<LastAndNextMatch>;
  onUpdateLastAndNextMatchByTeamId?: Maybe<LastAndNextMatch>;
  onUpdateLiveScore?: Maybe<LiveScore>;
  onUpdateLiveScoreById?: Maybe<LiveScore>;
  onUpdateLmpHero?: Maybe<LmpHero>;
  onUpdateLmpHeroByMatchId?: Maybe<LmpHero>;
  onUpdateLmpHeroSticky?: Maybe<LmpHeroSticky>;
  onUpdateLmpHeroStickyByMatchId?: Maybe<LmpHeroSticky>;
  onUpdateLmpLineup?: Maybe<LmpLineup>;
  onUpdateLmpLineupByMatchId?: Maybe<LmpLineup>;
  onUpdateLmpMatchChange?: Maybe<LmpMatchChange>;
  onUpdateLmpMatchChangeByMatchId?: Maybe<LmpMatchChange>;
  onUpdateLmpPredictedLineupDetails?: Maybe<LmpPredictedLineupDetails>;
  onUpdateLmpPredictedLineupDetailsByMatchId?: Maybe<LmpPredictedLineupDetails>;
  onUpdateLmpPreviewText?: Maybe<LmpPreviewText>;
  onUpdateLmpPreviewTextByMatchId?: Maybe<LmpPreviewText>;
  onUpdateLmpStatistics?: Maybe<LmpStatistics>;
  onUpdateLmpStatisticsByMatchId?: Maybe<LmpStatistics>;
  onUpdateMatch?: Maybe<Match>;
  onUpdateMatchCard?: Maybe<MatchCard>;
  onUpdateMatchCardByMatchId?: Maybe<MatchCard>;
  onUpdateMatchChange?: Maybe<MatchChange>;
  onUpdateMatchChangeById?: Maybe<MatchChange>;
  onUpdateMatchComment?: Maybe<MatchComment>;
  onUpdateMatchComments?: Maybe<MatchComments>;
  onUpdateMatchCommentsByMatchIdAndPage?: Maybe<MatchComments>;
  onUpdateMatchData?: Maybe<MatchData>;
  onUpdateNotificationMatch?: Maybe<NotificationMatch>;
  onUpdateNotificationMatchByMatchId?: Maybe<NotificationMatch>;
  onUpdatePlayer?: Maybe<Player>;
  onUpdatePlayerData?: Maybe<PlayerData>;
  onUpdatePlayerPagesStats?: Maybe<PlayerPagesStats>;
  onUpdatePlayerRanking?: Maybe<PlayerRanking>;
  onUpdatePlayerStats?: Maybe<PlayerStats>;
  onUpdatePredictedLineup?: Maybe<PredictedLineup>;
  onUpdatePredictedLineupDetails?: Maybe<PredictedLineupDetails>;
  onUpdatePredictedLineupHomepage?: Maybe<PredictedLineupHomepage>;
  onUpdatePredictedLineupRound?: Maybe<PredictedLineupRound>;
  onUpdateRanking?: Maybe<Ranking>;
  onUpdateReport?: Maybe<Report>;
  onUpdateReportDetails?: Maybe<ReportDetails>;
  onUpdateScorersRankingPlayerPage?: Maybe<ScorersRankingPlayerPage>;
  onUpdateSeason?: Maybe<Season>;
  onUpdateTeam?: Maybe<Team>;
  onUpdateTeamCalendarAndResults?: Maybe<TeamCalendarAndResults>;
  onUpdateTeamPlayers?: Maybe<TeamPlayers>;
  onUpdateTeamRanking?: Maybe<TeamRanking>;
  onUpdateTeamRankingByTeamId?: Maybe<TeamRanking>;
};


export type SubscriptiononUpdateCardFootballRankingByCompetitionIdArgs = {
  competitionId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateCompetitionRankingBySeasonIdAndCompIdArgs = {
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateLastAndNextMatchByTeamIdArgs = {
  teamId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateLiveScoreByIdArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptiononUpdateLmpHeroByMatchIdArgs = {
  matchId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateLmpHeroStickyByMatchIdArgs = {
  matchId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateLmpLineupByMatchIdArgs = {
  matchId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateLmpMatchChangeByMatchIdArgs = {
  matchId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateLmpPredictedLineupDetailsByMatchIdArgs = {
  matchId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateLmpPreviewTextByMatchIdArgs = {
  matchId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateLmpStatisticsByMatchIdArgs = {
  matchId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateMatchCardByMatchIdArgs = {
  matchId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateMatchChangeByIdArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptiononUpdateMatchCommentsByMatchIdAndPageArgs = {
  matchId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
};


export type SubscriptiononUpdateNotificationMatchByMatchIdArgs = {
  matchId: Scalars['ID']['input'];
};


export type SubscriptiononUpdateTeamRankingByTeamIdArgs = {
  teamId: Scalars['ID']['input'];
};

export type Team = {
  __typename?: 'Team';
  competition?: Maybe<Competition>;
  createdAt: Scalars['AWSDateTime']['output'];
  editorialData?: Maybe<EditorialData>;
  editorialDataId: Scalars['ID']['output'];
  isPlaceholder?: Maybe<Scalars['Boolean']['output']>;
  players?: Maybe<ModelPlayerConnection>;
  seasonAndCompId: Scalars['ID']['output'];
  teamId: Scalars['ID']['output'];
  teamJson: Scalars['AWSJSON']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type TeamplayersArgs = {
  filter?: InputMaybe<ModelPlayerFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type TeamCalendarAndResults = {
  __typename?: 'TeamCalendarAndResults';
  createdAt: Scalars['AWSDateTime']['output'];
  matchDayList?: Maybe<Array<Maybe<CalendarAndResultsMatchDayList>>>;
  teamId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type TeamPlayers = {
  __typename?: 'TeamPlayers';
  competition?: Maybe<TeamPlayersCompetition>;
  createdAt: Scalars['AWSDateTime']['output'];
  players?: Maybe<Array<Maybe<TeamPlayersPlayer>>>;
  season?: Maybe<TeamPlayersSeason>;
  team?: Maybe<TeamPlayersTeam>;
  teamId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type TeamPlayersCompetition = {
  __typename?: 'TeamPlayersCompetition';
  homepageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  seoName?: Maybe<Scalars['String']['output']>;
};

export type TeamPlayersCompetitionInput = {
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seoName?: InputMaybe<Scalars['String']['input']>;
};

export type TeamPlayersPlayer = {
  __typename?: 'TeamPlayersPlayer';
  birthdate?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  fullname?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  jerseyNum?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  playerPageLink?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type TeamPlayersPlayerInput = {
  birthdate?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['String']['input']>;
  fullname?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  jerseyNum?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  playerPageLink?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type TeamPlayersSeason = {
  __typename?: 'TeamPlayersSeason';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type TeamPlayersSeasonInput = {
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type TeamPlayersTeam = {
  __typename?: 'TeamPlayersTeam';
  homepageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  seoName?: Maybe<Scalars['String']['output']>;
};

export type TeamPlayersTeamInput = {
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seoName?: InputMaybe<Scalars['String']['input']>;
};

export type TeamRanking = {
  __typename?: 'TeamRanking';
  createdAt: Scalars['AWSDateTime']['output'];
  rankingLists?: Maybe<Array<Maybe<TeamRankingRankingList>>>;
  teamId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type TeamRankingGroup = {
  __typename?: 'TeamRankingGroup';
  roundName?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Maybe<TeamRankingTeam>>>;
};

export type TeamRankingGroupInput = {
  roundName?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<InputMaybe<TeamRankingTeamInput>>>;
};

export type TeamRankingLastMatchesTrend = {
  __typename?: 'TeamRankingLastMatchesTrend';
  away?: Maybe<TeamRankingTrend>;
  home?: Maybe<TeamRankingTrend>;
  label?: Maybe<Scalars['String']['output']>;
};

export type TeamRankingLastMatchesTrendInput = {
  away?: InputMaybe<TeamRankingTrendInput>;
  home?: InputMaybe<TeamRankingTrendInput>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type TeamRankingRankingList = {
  __typename?: 'TeamRankingRankingList';
  competitionId: Scalars['ID']['output'];
  customCompetitionName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<TeamRankingGroup>>>;
  seasonId: Scalars['ID']['output'];
};

export type TeamRankingRankingListInput = {
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<TeamRankingGroupInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type TeamRankingTeam = {
  __typename?: 'TeamRankingTeam';
  games?: Maybe<Scalars['Int']['output']>;
  gamesDraw?: Maybe<Scalars['Int']['output']>;
  gamesLost?: Maybe<Scalars['Int']['output']>;
  gamesWon?: Maybe<Scalars['Int']['output']>;
  goalsConceded?: Maybe<Scalars['Int']['output']>;
  goalsDifference?: Maybe<Scalars['Int']['output']>;
  goalsScored?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastMatchesTrend?: Maybe<Array<Maybe<TeamRankingLastMatchesTrend>>>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  qualification?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  teamUrl?: Maybe<Scalars['String']['output']>;
  trend?: Maybe<Scalars['String']['output']>;
};

export type TeamRankingTeamInput = {
  games?: InputMaybe<Scalars['Int']['input']>;
  gamesDraw?: InputMaybe<Scalars['Int']['input']>;
  gamesLost?: InputMaybe<Scalars['Int']['input']>;
  gamesWon?: InputMaybe<Scalars['Int']['input']>;
  goalsConceded?: InputMaybe<Scalars['Int']['input']>;
  goalsDifference?: InputMaybe<Scalars['Int']['input']>;
  goalsScored?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  lastMatchesTrend?: InputMaybe<Array<InputMaybe<TeamRankingLastMatchesTrendInput>>>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  qualification?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  teamUrl?: InputMaybe<Scalars['String']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
};

export type TeamRankingTrend = {
  __typename?: 'TeamRankingTrend';
  goal?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TeamRankingTrendInput = {
  goal?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCalendarAndResultsGliderInput = {
  competitionId: Scalars['ID']['input'];
  currentRound?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Array<InputMaybe<CalendarAndResultsGliderRoundInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type UpdateCardCompetitionCalendarInput = {
  calendarAndResultsLink?: InputMaybe<Scalars['String']['input']>;
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  matchRoundList?: InputMaybe<Array<InputMaybe<CardCompetitionCalendarMatchRoundInput>>>;
};

export type UpdateCardCompetitionRankingInput = {
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<CardCompetitionRankingGroupInput>>>;
  rankingLink?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompetitionBoardInput = {
  boardSponsorLink?: InputMaybe<Scalars['String']['input']>;
  competitionId: Scalars['ID']['input'];
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  matchList?: InputMaybe<Array<InputMaybe<CompetitionBoardPhaseRoundInput>>>;
};

export type UpdateCompetitionCalendarAndResultsInput = {
  competitionId: Scalars['ID']['input'];
  currentRound?: InputMaybe<Scalars['Int']['input']>;
  customCompetitionName?: InputMaybe<Scalars['String']['input']>;
  matchRoundList?: InputMaybe<Array<InputMaybe<CompetitionCalendarAndResultsMatchRoundInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type UpdateCompetitionInput = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  competitionJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  previousSeasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCompetitionRankingInput = {
  competitionId: Scalars['ID']['input'];
  rankingLists?: InputMaybe<Array<InputMaybe<CompetitionRankingRankingListInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type UpdateCompetitionReportsInput = {
  competitionId: Scalars['ID']['input'];
  reports?: InputMaybe<Array<InputMaybe<CompetitionReportsListInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type UpdateCompetitionScorersRankingInput = {
  competitionId: Scalars['ID']['input'];
  competitionScorersUrl?: InputMaybe<Scalars['String']['input']>;
  competitionSeoName?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['String']['input'];
  pages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scorers?: InputMaybe<Array<InputMaybe<CompetitionScorersRankingScorerInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type UpdateCompetitionTeamInput = {
  competitions?: InputMaybe<Array<InputMaybe<CompetitionTeamCompetitionInput>>>;
  id: Scalars['ID']['input'];
};

export type UpdateCrossLinkInput = {
  crossLinkJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  matchId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
};

export type UpdateEditorialDataInput = {
  editorialDataId: Scalars['ID']['input'];
  editorialJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
};

export type UpdateLastAndNextMatchInput = {
  lastMatch?: InputMaybe<LastAndNextMatchMatchInput>;
  nextMatch?: InputMaybe<LastAndNextMatchMatchInput>;
  teamId: Scalars['ID']['input'];
};

export type UpdateLiveScoreInput = {
  currentDay?: InputMaybe<Array<InputMaybe<LiveScoreDayInput>>>;
  id: Scalars['ID']['input'];
  nextDay?: InputMaybe<Array<InputMaybe<LiveScoreDayInput>>>;
  previousDay?: InputMaybe<Array<InputMaybe<LiveScoreDayInput>>>;
};

export type UpdateLmpHeroInput = {
  away?: InputMaybe<LmpHeroTeamInput>;
  competition?: InputMaybe<LmpHeroCompetitionInput>;
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseWinnerTeamId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  hasFollowMatch?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<LmpHeroTeamInput>;
  matchDetailUrl?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['ID']['input'];
  round?: InputMaybe<Scalars['Int']['input']>;
  roundGroup?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusStartDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  venue?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLmpHeroStickyInput = {
  away?: InputMaybe<LmpHeroTeamInput>;
  competition?: InputMaybe<LmpHeroCompetitionInput>;
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseWinnerTeamId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  home?: InputMaybe<LmpHeroTeamInput>;
  matchDetailUrl?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['ID']['input'];
  round?: InputMaybe<Scalars['Int']['input']>;
  roundGroup?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusStartDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  venue?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLmpLineupInput = {
  away?: InputMaybe<LmpLineupTeamInput>;
  home?: InputMaybe<LmpLineupTeamInput>;
  matchId: Scalars['ID']['input'];
  referees?: InputMaybe<Array<InputMaybe<LmpLineupRefereeInput>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLmpMatchChangeInput = {
  matchId: Scalars['ID']['input'];
  matchList?: InputMaybe<Array<InputMaybe<LmpMatchChangeMatchInput>>>;
};

export type UpdateLmpPredictedLineupDetailsInput = {
  away?: InputMaybe<LmpPredictedLineupDetailsTeamInput>;
  date?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<LmpPredictedLineupDetailsTeamInput>;
  matchId: Scalars['ID']['input'];
  round?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLmpPreviewTextInput = {
  away?: InputMaybe<LmpPreviewTextDataTeamInput>;
  calendar?: InputMaybe<LmpPreviewTextDataInfoInput>;
  competition?: InputMaybe<LmpPreviewTextDataInfoInput>;
  competitionName?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<LmpPreviewTextDataTeamInput>;
  matchId: Scalars['ID']['input'];
  matchStartDateTime?: InputMaybe<Scalars['String']['input']>;
  ranking?: InputMaybe<LmpPreviewTextDataInfoInput>;
  results?: InputMaybe<LmpPreviewTextDataInfoInput>;
  venue?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLmpStatisticsInput = {
  away?: InputMaybe<LmpStatisticsTeamInput>;
  home?: InputMaybe<LmpStatisticsTeamInput>;
  matchId: Scalars['ID']['input'];
  matchStatisticsList?: InputMaybe<Array<InputMaybe<LmpStatisticsMatchStatisticsInput>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMatchCardInput = {
  away?: InputMaybe<MatchCardTeamInput>;
  competition?: InputMaybe<MatchCardCompetitionInput>;
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseWinnerTeamId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  home?: InputMaybe<MatchCardTeamInput>;
  matchDetailUrl?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMatchChangeInput = {
  id: Scalars['ID']['input'];
  matchList?: InputMaybe<Array<InputMaybe<MatchChangeMatchInput>>>;
};

export type UpdateMatchCommentInput = {
  commentId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['String']['input']>;
  matchCommentJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  matchId: Scalars['ID']['input'];
  minute?: InputMaybe<Scalars['Int']['input']>;
  player1Id?: InputMaybe<Scalars['ID']['input']>;
  player2Id?: InputMaybe<Scalars['ID']['input']>;
  seasonAndCompId?: InputMaybe<Scalars['ID']['input']>;
  second?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMatchCommentsInput = {
  awayTeam?: InputMaybe<SeoCustomDataInput>;
  comments?: InputMaybe<Array<InputMaybe<MatchCommentsCommentInput>>>;
  competition?: InputMaybe<SeoCustomDataInput>;
  firstCommentDate?: InputMaybe<Scalars['String']['input']>;
  homeTeam?: InputMaybe<SeoCustomDataInput>;
  lastCommentDate?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['ID']['input'];
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pagination?: InputMaybe<MatchCommentsPaginationInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMatchDataInput = {
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
  matchId: Scalars['ID']['input'];
  messageType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMatchInput = {
  awayTeamId?: InputMaybe<Scalars['ID']['input']>;
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Int']['input']>;
  homeTeamId?: InputMaybe<Scalars['ID']['input']>;
  matchId: Scalars['ID']['input'];
  matchJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  refereeId?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Int']['input']>;
  roundGroup?: InputMaybe<Scalars['String']['input']>;
  scheduleJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNotificationMatchInput = {
  away?: InputMaybe<NotificationMatchTeamInput>;
  competitionPhase?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseRound?: InputMaybe<Scalars['String']['input']>;
  competitionPhaseWinnerTeamId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  home?: InputMaybe<NotificationMatchTeamInput>;
  matchDetailUrl?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['ID']['input'];
  matchJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  round?: InputMaybe<Scalars['Int']['input']>;
  roundGroup?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updates?: InputMaybe<NotificationMatchUpdatesInput>;
};

export type UpdatePlayerDataInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  competitionId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlayerInput = {
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  playerId: Scalars['ID']['input'];
  playerJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePlayerPagesStatsInput = {
  playerId: Scalars['ID']['input'];
  playerRole?: InputMaybe<Scalars['String']['input']>;
  statistics?: InputMaybe<Array<InputMaybe<PlayerPagesStatsSeasonCompStatInput>>>;
};

export type UpdatePlayerRankingInput = {
  playerId: Scalars['ID']['input'];
  playerRankingJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePlayerStatsInput = {
  playerId: Scalars['ID']['input'];
  seasonAndCompId: Scalars['ID']['input'];
  statsJson?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type UpdatePredictedLineupDetailsInput = {
  competitionId: Scalars['ID']['input'];
  hasHeadshots?: InputMaybe<Scalars['Boolean']['input']>;
  matchData?: InputMaybe<PredictedLineupMatchInput>;
  predictedHpLink?: InputMaybe<Scalars['String']['input']>;
  predictedSponsorLink?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['ID']['input'];
};

export type UpdatePredictedLineupHomepageInput = {
  competitionId: Scalars['ID']['input'];
  matchList?: InputMaybe<Array<InputMaybe<PredictedLineupMatchInput>>>;
  round?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePredictedLineupInput = {
  awayTeamId?: InputMaybe<Scalars['ID']['input']>;
  homeTeamId?: InputMaybe<Scalars['ID']['input']>;
  matchId: Scalars['ID']['input'];
  predictedLineupJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  round?: InputMaybe<Scalars['Int']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePredictedLineupRoundInput = {
  round?: InputMaybe<Scalars['Int']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
};

export type UpdateRankingInput = {
  matchDayId?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  rankingJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type UpdateReportDetailsInput = {
  competitionId: Scalars['ID']['input'];
  reports?: InputMaybe<Array<InputMaybe<ReportDetailsMatchInput>>>;
  reportsHomepageUrl?: InputMaybe<Scalars['String']['input']>;
  round: Scalars['Int']['input'];
  seasonId: Scalars['ID']['input'];
};

export type UpdateReportInput = {
  matchId: Scalars['ID']['input'];
  reportJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScorersRankingPlayerPageInput = {
  competitionCalendarUrl?: InputMaybe<Scalars['String']['input']>;
  competitionId: Scalars['ID']['input'];
  competitionName?: InputMaybe<Scalars['String']['input']>;
  competitionSlugName?: InputMaybe<Scalars['String']['input']>;
  scorers?: InputMaybe<Array<InputMaybe<ScorersRankingInput>>>;
  seasonId: Scalars['ID']['input'];
};

export type UpdateSeasonInput = {
  editorialData?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateTeamCalendarAndResultsInput = {
  matchDayList?: InputMaybe<Array<InputMaybe<CalendarAndResultsMatchDayListInput>>>;
  teamId: Scalars['ID']['input'];
};

export type UpdateTeamInput = {
  editorialDataId?: InputMaybe<Scalars['ID']['input']>;
  isPlaceholder?: InputMaybe<Scalars['Boolean']['input']>;
  seasonAndCompId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  teamJson?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type UpdateTeamPlayersInput = {
  competition?: InputMaybe<TeamPlayersCompetitionInput>;
  players?: InputMaybe<Array<InputMaybe<TeamPlayersPlayerInput>>>;
  season?: InputMaybe<TeamPlayersSeasonInput>;
  team?: InputMaybe<TeamPlayersTeamInput>;
  teamId: Scalars['ID']['input'];
};

export type UpdateTeamRankingInput = {
  rankingLists?: InputMaybe<Array<InputMaybe<TeamRankingRankingListInput>>>;
  teamId: Scalars['ID']['input'];
};

export type GetCompetitionBoardQueryVariables = Exact<{
  competitionId: Scalars['ID']['input'];
}>;


export type GetCompetitionBoardQuery = { __typename?: 'Query', getCompetitionBoard?: { __typename?: 'CompetitionBoard', boardSponsorLink?: string | null, competitionId: string, customCompetitionName?: string | null, matchList?: Array<{ __typename?: 'CompetitionBoardPhaseRound', competitionPhase?: string | null, competitionPhaseRound?: string | null, competitionPhaseWinnerTeamId?: string | null, date?: string | null, gamesPhaseCount?: number | null, id: string, link?: string | null, round?: number | null, roundGroup?: string | null, status?: string | null, away?: { __typename?: 'CompetitionBoardTeam', goal?: number | null, id: string, logoUrl?: string | null, name?: string | null, prevMatch?: string | null, shootoutGoal?: number | null, shortName?: string | null } | null, home?: { __typename?: 'CompetitionBoardTeam', goal?: number | null, id: string, logoUrl?: string | null, name?: string | null, prevMatch?: string | null, shootoutGoal?: number | null, shortName?: string | null } | null, linkedMatch?: { __typename?: 'CompetitionBoardLinkedMatch', competitionPhaseRound?: string | null, status?: string | null, date?: string | null, id: string, link?: string | null, away?: { __typename?: 'CompetitionBoardTeam', goal?: number | null, name?: string | null, shootoutGoal?: number | null, shortName?: string | null } | null, home?: { __typename?: 'CompetitionBoardTeam', goal?: number | null, name?: string | null, shootoutGoal?: number | null, shortName?: string | null } | null } | null } | null> | null } | null };

export type GetCompetitionCalendarAndResultsQueryVariables = Exact<{
  seasonId: Scalars['ID']['input'];
  competitionId: Scalars['ID']['input'];
}>;


export type GetCompetitionCalendarAndResultsQuery = { __typename?: 'Query', competitionCalendarAndResults?: { __typename?: 'CompetitionCalendarAndResults', competitionId: string, customCompetitionName?: string | null, currentRound?: number | null, seasonId: string, matchRoundList?: Array<{ __typename?: 'CompetitionCalendarAndResultsMatchRound', competitionPhase?: string | null, round?: number | null, status?: string | null, matchDayList?: Array<{ __typename?: 'CompetitionCalendarAndResultsMatchDay', date?: string | null, matchList?: Array<{ __typename?: 'CompetitionCalendarAndResultsMatch', competitionPhaseWinnerTeamId?: string | null, date?: string | null, id: string, link?: string | null, roundGroup?: string | null, competitionPhaseRound?: string | null, status?: string | null, liveOnSky?: string | null, away?: { __typename?: 'CompetitionCalendarAndResultsTeam', goal?: number | null, id: string, logoUrl?: string | null, name?: string | null, seoName?: string | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, shootoutGoal?: number | null, totalGoalLegs?: number | null } | null, home?: { __typename?: 'CompetitionCalendarAndResultsTeam', goal?: number | null, id: string, logoUrl?: string | null, name?: string | null, seoName?: string | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, shootoutGoal?: number | null, totalGoalLegs?: number | null } | null } | null> | null } | null> | null } | null> | null } | null };

export type GetPredictedLineupHomepageQueryVariables = Exact<{
  competitionId: Scalars['ID']['input'];
}>;


export type GetPredictedLineupHomepageQuery = { __typename?: 'Query', competitionPredictedLineup?: { __typename?: 'PredictedLineupHomepage', competitionId: string, round: string, matchList?: Array<{ __typename?: 'PredictedLineupMatch', date?: string | null, lmpLineupLink?: string | null, matchId: string, status?: string | null, away?: { __typename?: 'PredictedLineupTeam', predictedTeamLink?: string | null, formation?: string | null, id: string, logo?: string | null, negativeLogoUrl?: string | null, customName?: string | null, customSeoName?: string | null, teamShortName?: string | null, playerList?: { __typename?: 'PredictedLineupPlayerList', disqualifiedPlayers?: string | null, potentialPlayers?: string | null, substitutePlayers?: string | null, unavailablePlayers?: string | null, manager?: string | null, predictedLineup?: Array<{ __typename?: 'PredictedLineupPlayer', formationPlace?: string | null, fullName?: string | null, id?: string | null, jerseyNum?: number | null, name?: string | null, photoUrl?: string | null, role?: string | null, surname?: string | null, playerPageLink?: string | null } | null> | null } | null } | null, home?: { __typename?: 'PredictedLineupTeam', predictedTeamLink?: string | null, formation?: string | null, id: string, logo?: string | null, negativeLogoUrl?: string | null, customName?: string | null, customSeoName?: string | null, teamShortName?: string | null, playerList?: { __typename?: 'PredictedLineupPlayerList', disqualifiedPlayers?: string | null, potentialPlayers?: string | null, substitutePlayers?: string | null, unavailablePlayers?: string | null, manager?: string | null, predictedLineup?: Array<{ __typename?: 'PredictedLineupPlayer', formationPlace?: string | null, fullName?: string | null, id?: string | null, jerseyNum?: number | null, name?: string | null, photoUrl?: string | null, role?: string | null, surname?: string | null, playerPageLink?: string | null } | null> | null } | null } | null } | null> | null } | null };

export type GetCompetitionRankingQueryVariables = Exact<{
  seasonId: Scalars['ID']['input'];
  competitionId: Scalars['ID']['input'];
}>;


export type GetCompetitionRankingQuery = { __typename?: 'Query', getCompetitionRanking?: { __typename?: 'CompetitionRanking', competitionId: string, seasonId: string, rankingLists?: Array<{ __typename?: 'CompetitionRankingRankingList', competitionId: string, customCompetitionName?: string | null, seasonId: string, groups?: Array<{ __typename?: 'CompetitionRankingGroup', roundName?: string | null, teams?: Array<{ __typename?: 'CompetitionRankingTeam', games?: number | null, gamesDraw?: number | null, gamesLost?: number | null, gamesWon?: number | null, goalsConceded?: number | null, goalsDifference?: number | null, goalsScored?: number | null, id: string, logoUrl?: string | null, points?: number | null, position?: number | null, qualification?: string | null, teamName?: string | null, teamUrl?: string | null, trend?: string | null, lastMatchesTrend?: Array<{ __typename?: 'CompetitionRankingLastMatchesTrend', label?: string | null, home?: { __typename?: 'CompetitionRankingTrend', goal?: number | null, name?: string | null } | null, away?: { __typename?: 'CompetitionRankingTrend', goal?: number | null, name?: string | null } | null } | null> | null } | null> | null } | null> | null } | null> | null } | null };

export type GetCompetitionScorersRankingQueryVariables = Exact<{
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
  page: Scalars['String']['input'];
}>;


export type GetCompetitionScorersRankingQuery = { __typename?: 'Query', getCompetitionScorersRanking?: { __typename?: 'CompetitionScorersRanking', competitionId: string, seasonId: string, competitionSeoName?: string | null, competitionScorersUrl?: string | null, page: string, pages?: Array<string | null> | null, scorers?: Array<{ __typename?: 'CompetitionScorersRankingScorer', areaIn?: number | null, areaOut?: number | null, goal?: number | null, head?: number | null, logoUrl?: string | null, playerId?: string | null, penalty?: number | null, playerName?: string | null, position?: number | null, seoTeamName?: string | null, teamId?: string | null, teamUrl?: string | null, playerPageLink?: string | null } | null> | null } | null };

export type GetCardCompetitionCalendarQueryVariables = Exact<{
  competitionId: Scalars['ID']['input'];
}>;


export type GetCardCompetitionCalendarQuery = { __typename?: 'Query', getCardCompetitionCalendar?: { __typename?: 'CardCompetitionCalendar', competitionId: string, customCompetitionName?: string | null, calendarAndResultsLink?: string | null, matchRoundList?: Array<{ __typename?: 'CardCompetitionCalendarMatchRound', competitionPhase?: string | null, round?: number | null, matchDayList?: Array<{ __typename?: 'CardCompetitionCalendarMatchDay', date?: string | null, matchList?: Array<{ __typename?: 'CardCompetitionCalendarMatch', competitionPhaseWinnerTeamId?: string | null, date?: string | null, id?: string | null, link?: string | null, roundGroup?: string | null, competitionPhaseRound?: string | null, status?: string | null, away?: { __typename?: 'CardCompetitionCalendarMatchTeam', id?: string | null, logoUrl?: string | null, negativeLogoUrl?: string | null, name?: string | null, seoName?: string | null } | null, home?: { __typename?: 'CardCompetitionCalendarMatchTeam', id?: string | null, logoUrl?: string | null, negativeLogoUrl?: string | null, name?: string | null, seoName?: string | null } | null } | null> | null } | null> | null } | null> | null } | null };

export type GetCardCompetitionRankingQueryVariables = Exact<{
  competitionId: Scalars['ID']['input'];
}>;


export type GetCardCompetitionRankingQuery = { __typename?: 'Query', getCardCompetitionRanking?: { __typename?: 'CardCompetitionRanking', competitionId: string, customCompetitionName?: string | null, rankingLink?: string | null, groups?: Array<{ __typename?: 'CardCompetitionRankingGroup', roundName?: string | null, teams?: Array<{ __typename?: 'CardCompetitionRankingTeam', games?: number | null, id: string, logoUrl?: string | null, negativeLogoUrl?: string | null, points?: number | null, position?: number | null, teamName?: string | null, teamUrl?: string | null, trend?: string | null } | null> | null } | null> | null } | null };

export type GetCompetitionTeamQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCompetitionTeamQuery = { __typename?: 'Query', getCompetitionTeam?: { __typename?: 'CompetitionTeam', id: string, competitions?: Array<{ __typename?: 'CompetitionTeamCompetition', homepageUrl?: string | null, id: string, logoUrl?: string | null, name?: string | null, seasonAndCompId: string, seasonLabel?: string | null, teams?: Array<{ __typename?: 'CompetitionTeamTeam', homepageUrl?: string | null, id: string, logoUrl?: string | null, name?: string | null } | null> | null } | null> | null } | null };

export type GetLmpHeroStickyQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type GetLmpHeroStickyQuery = { __typename?: 'Query', getLmpHeroSticky?: { __typename?: 'LmpHeroSticky', date?: any | null, matchId: string, status?: string | null, home?: { __typename?: 'LmpHeroTeam', goal?: number | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, shootoutGoal?: number | null, totalGoalLegs?: number | null, logoUrl?: string | null, negativeLogoUrl?: string | null, name?: string | null } | null, away?: { __typename?: 'LmpHeroTeam', goal?: number | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, shootoutGoal?: number | null, totalGoalLegs?: number | null, logoUrl?: string | null, negativeLogoUrl?: string | null, name?: string | null } | null } | null };

export type GetLmpHeroQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type GetLmpHeroQuery = { __typename?: 'Query', getLmpHero?: { __typename?: 'LmpHero', hasFollowMatch?: boolean | null, competitionPhase?: string | null, competitionPhaseRound?: string | null, competitionPhaseWinnerTeamId?: string | null, date?: any | null, matchDetailUrl?: string | null, matchId: string, round?: number | null, roundGroup?: string | null, status?: string | null, statusStartDateTime?: any | null, venue?: string | null, competition?: { __typename?: 'LmpHeroCompetition', id?: string | null, homepageUrl?: string | null, logoUrl?: string | null, name?: string | null } | null, home?: { __typename?: 'LmpHeroTeam', goal?: number | null, homepageUrl?: string | null, id?: string | null, logoUrl?: string | null, negativeLogoUrl?: string | null, name?: string | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, seoName?: string | null, shootoutGoal?: number | null, totalGoalLegs?: number | null, scoreboard?: Array<{ __typename?: 'LmpHeroScoreboard', minute?: number | null, player?: string | null, type?: string | null, matchStatus?: string | null } | null> | null } | null, away?: { __typename?: 'LmpHeroTeam', goal?: number | null, homepageUrl?: string | null, id?: string | null, logoUrl?: string | null, negativeLogoUrl?: string | null, name?: string | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, seoName?: string | null, shootoutGoal?: number | null, totalGoalLegs?: number | null, scoreboard?: Array<{ __typename?: 'LmpHeroScoreboard', minute?: number | null, player?: string | null, type?: string | null, matchStatus?: string | null } | null> | null } | null } | null };

export type GetLmpLineupQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type GetLmpLineupQuery = { __typename?: 'Query', lineups?: { __typename?: 'LmpLineup', matchId: string, status?: string | null, referees?: Array<{ __typename?: 'LmpLineupReferee', fullname?: string | null, id?: string | null, name?: string | null, surname?: string | null } | null> | null, home?: { __typename?: 'LmpLineupTeam', formation?: string | null, id?: string | null, logoUrl?: string | null, negativeLogoUrl?: string | null, name?: string | null, topPlayerId?: string | null, playerList?: { __typename?: 'LmpLineupPlayerList', manager?: { __typename?: 'LmpLineupManager', fullname?: string | null, id?: string | null, name?: string | null, role?: string | null, surname?: string | null } | null, startingLineup?: Array<{ __typename?: 'LmpLineupPlayerDetails', formationPlace?: string | null, fullname?: string | null, id?: string | null, jerseyNum?: number | null, name?: string | null, role?: string | null, surname?: string | null, playerPageLink?: string | null } | null> | null, substitutes?: Array<{ __typename?: 'LmpLineupPlayerDetails', formationPlace?: string | null, fullname?: string | null, id?: string | null, jerseyNum?: number | null, name?: string | null, role?: string | null, surname?: string | null, playerPageLink?: string | null } | null> | null } | null, goals?: Array<{ __typename?: 'LmpLineupEvent', id?: string | null, minutes?: number | null, type?: string | null } | null> | null, scorersCards?: Array<{ __typename?: 'LmpLineupEvent', id?: string | null, minutes?: number | null, type?: string | null } | null> | null, substitution?: Array<{ __typename?: 'LmpLineupPlayerSubstitution', minutes?: number | null, playerIdIn?: string | null, playerIdOut?: string | null } | null> | null } | null, away?: { __typename?: 'LmpLineupTeam', formation?: string | null, id?: string | null, logoUrl?: string | null, negativeLogoUrl?: string | null, name?: string | null, topPlayerId?: string | null, playerList?: { __typename?: 'LmpLineupPlayerList', manager?: { __typename?: 'LmpLineupManager', fullname?: string | null, id?: string | null, name?: string | null, role?: string | null, surname?: string | null } | null, startingLineup?: Array<{ __typename?: 'LmpLineupPlayerDetails', formationPlace?: string | null, fullname?: string | null, id?: string | null, jerseyNum?: number | null, name?: string | null, role?: string | null, surname?: string | null, playerPageLink?: string | null } | null> | null, substitutes?: Array<{ __typename?: 'LmpLineupPlayerDetails', formationPlace?: string | null, fullname?: string | null, id?: string | null, jerseyNum?: number | null, name?: string | null, role?: string | null, surname?: string | null, playerPageLink?: string | null } | null> | null } | null, goals?: Array<{ __typename?: 'LmpLineupEvent', id?: string | null, minutes?: number | null, type?: string | null } | null> | null, scorersCards?: Array<{ __typename?: 'LmpLineupEvent', id?: string | null, minutes?: number | null, type?: string | null } | null> | null, substitution?: Array<{ __typename?: 'LmpLineupPlayerSubstitution', minutes?: number | null, playerIdIn?: string | null, playerIdOut?: string | null } | null> | null } | null } | null };

export type GetLmpMatchChangeQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type GetLmpMatchChangeQuery = { __typename?: 'Query', getLmpMatchChange?: { __typename?: 'LmpMatchChange', matchId: string, matchList?: Array<{ __typename?: 'LmpMatchChangeMatch', id: string, link?: string | null, status?: string | null, date?: any | null, away?: { __typename?: 'LmpMatchChangeTeam', id: string, goal?: number | null, shortName?: string | null } | null, home?: { __typename?: 'LmpMatchChangeTeam', goal?: number | null, id: string, shortName?: string | null } | null } | null> | null } | null };

export type GetMatchCommentsQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetMatchCommentsQuery = { __typename?: 'Query', getMatchComments?: { __typename?: 'MatchComments', matchId: string, matchStatus?: string | null, page: number, url?: string | null, firstCommentDate?: string | null, lastCommentDate?: string | null, homeTeam?: { __typename?: 'SeoCustomData', seoName?: string | null, customName?: string | null } | null, awayTeam?: { __typename?: 'SeoCustomData', seoName?: string | null, customName?: string | null } | null, competition?: { __typename?: 'SeoCustomData', seoName?: string | null, customName?: string | null } | null, comments?: Array<{ __typename?: 'MatchCommentsComment', commentId?: string | null, type?: string | null, time?: string | null, message?: string | null, createdAt?: string | null, updatedAt?: string | null } | null> | null, pagination?: { __typename?: 'MatchCommentsPagination', nextLink?: string | null, prevLink?: string | null, items?: number | null, itemsPerPage?: number | null } | null } | null };

export type GetLmpStatisticsQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type GetLmpStatisticsQuery = { __typename?: 'Query', getLmpStatistics?: { __typename?: 'LmpStatistics', matchId: string, status?: string | null, home?: { __typename?: 'LmpStatisticsTeam', id?: string | null, logoUrl?: string | null, name?: string | null } | null, away?: { __typename?: 'LmpStatisticsTeam', id?: string | null, logoUrl?: string | null, name?: string | null } | null, matchStatisticsList?: Array<{ __typename?: 'LmpStatisticsMatchStatistics', id?: string | null, value?: { __typename?: 'LmpStatisticsValue', away?: string | null, home?: string | null } | null } | null> | null } | null };

export type GetPredictedLineupLmpQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type GetPredictedLineupLmpQuery = { __typename?: 'Query', predictedLineupLmp?: { __typename?: 'LmpPredictedLineupDetails', date?: string | null, matchId: string, round?: string | null, status?: string | null, away?: { __typename?: 'LmpPredictedLineupDetailsTeam', customName?: string | null, customSeoName?: string | null, formation?: string | null, id: string, logo?: string | null, negativeLogoUrl?: string | null, predictedTeamLink?: string | null, teamShortName?: string | null, playerList?: { __typename?: 'LmpPredictedLineupDetailsPlayerList', disqualifiedPlayers?: string | null, manager?: string | null, potentialPlayers?: string | null, substitutePlayers?: string | null, unavailablePlayers?: string | null, predictedLineup?: Array<{ __typename?: 'LmpPredictedLineupDetailsPlayer', formationPlace?: string | null, fullName?: string | null, id?: string | null, jerseyNum?: number | null, name?: string | null, photoUrl?: string | null, role?: string | null, surname?: string | null, playerPageLink?: string | null } | null> | null } | null } | null, home?: { __typename?: 'LmpPredictedLineupDetailsTeam', customName?: string | null, customSeoName?: string | null, formation?: string | null, id: string, logo?: string | null, negativeLogoUrl?: string | null, predictedTeamLink?: string | null, teamShortName?: string | null, playerList?: { __typename?: 'LmpPredictedLineupDetailsPlayerList', disqualifiedPlayers?: string | null, potentialPlayers?: string | null, substitutePlayers?: string | null, unavailablePlayers?: string | null, manager?: string | null, predictedLineup?: Array<{ __typename?: 'LmpPredictedLineupDetailsPlayer', formationPlace?: string | null, fullName?: string | null, id?: string | null, jerseyNum?: number | null, name?: string | null, photoUrl?: string | null, role?: string | null, surname?: string | null, playerPageLink?: string | null } | null> | null } | null } | null } | null };

export type GetLmpPreviewTextQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type GetLmpPreviewTextQuery = { __typename?: 'Query', getLmpPreviewText?: { __typename?: 'LmpPreviewText', competitionName?: string | null, matchId: string, matchStartDateTime?: string | null, venue?: string | null, away?: { __typename?: 'LmpPreviewTextDataTeam', coach?: string | null, link?: string | null, name?: string | null } | null, home?: { __typename?: 'LmpPreviewTextDataTeam', coach?: string | null, link?: string | null, name?: string | null } | null, calendar?: { __typename?: 'LmpPreviewTextDataInfo', link?: string | null, text?: string | null } | null, competition?: { __typename?: 'LmpPreviewTextDataInfo', link?: string | null, text?: string | null } | null, ranking?: { __typename?: 'LmpPreviewTextDataInfo', link?: string | null, text?: string | null } | null, results?: { __typename?: 'LmpPreviewTextDataInfo', link?: string | null, text?: string | null } | null } | null };

export type GetPredictedLineupDetailsQueryVariables = Exact<{
  teamId: Scalars['ID']['input'];
  competitionId: Scalars['ID']['input'];
}>;


export type GetPredictedLineupDetailsQuery = { __typename?: 'Query', matchPredictedLineup?: { __typename?: 'PredictedLineupDetails', competitionId: string, teamId: string, predictedHpLink?: string | null, predictedSponsorLink?: string | null, hasHeadshots?: boolean | null, matchData?: { __typename?: 'PredictedLineupMatch', date?: string | null, lmpLineupLink?: string | null, lmpLink?: string | null, matchId: string, away?: { __typename?: 'PredictedLineupTeam', predictedTeamLink?: string | null, formation?: string | null, id: string, logo?: string | null, negativeLogoUrl?: string | null, customName?: string | null, customSeoName?: string | null, teamShortName?: string | null, playerList?: { __typename?: 'PredictedLineupPlayerList', disqualifiedPlayers?: string | null, manager?: string | null, potentialPlayers?: string | null, substitutePlayers?: string | null, unavailablePlayers?: string | null, predictedLineup?: Array<{ __typename?: 'PredictedLineupPlayer', formationPlace?: string | null, fullName?: string | null, id?: string | null, jerseyNum?: number | null, name?: string | null, photoUrl?: string | null, fallbackPhotoUrl?: string | null, role?: string | null, surname?: string | null, playerPageLink?: string | null } | null> | null } | null } | null, home?: { __typename?: 'PredictedLineupTeam', predictedTeamLink?: string | null, formation?: string | null, id: string, logo?: string | null, negativeLogoUrl?: string | null, customName?: string | null, customSeoName?: string | null, teamShortName?: string | null, playerList?: { __typename?: 'PredictedLineupPlayerList', disqualifiedPlayers?: string | null, manager?: string | null, potentialPlayers?: string | null, substitutePlayers?: string | null, unavailablePlayers?: string | null, predictedLineup?: Array<{ __typename?: 'PredictedLineupPlayer', formationPlace?: string | null, fullName?: string | null, id?: string | null, jerseyNum?: number | null, name?: string | null, photoUrl?: string | null, fallbackPhotoUrl?: string | null, role?: string | null, surname?: string | null, playerPageLink?: string | null } | null> | null } | null } | null } | null } | null };

export type GetReportDetailsQueryVariables = Exact<{
  seasonId: Scalars['ID']['input'];
  competitionId: Scalars['ID']['input'];
  round: Scalars['Int']['input'];
}>;


export type GetReportDetailsQuery = { __typename?: 'Query', getReportDetails?: { __typename?: 'ReportDetails', competitionId: string, seasonId: string, round: number, reportsHomepageUrl?: string | null, createdAt: any, updatedAt: any, reports?: Array<{ __typename?: 'ReportDetailsMatch', matchId?: string | null, status?: string | null, reportStatus?: string | null, date?: string | null, referees?: Array<{ __typename?: 'ReportDetailsMatchTeamPlayer', id?: string | null, role?: string | null, fullname?: string | null, vote?: string | null, topPlayer?: boolean | null } | null> | null, home?: { __typename?: 'ReportDetailsMatchTeam', teamId?: string | null, shortname?: string | null, seoName?: string | null, name?: string | null, logoUrl?: string | null, negativeLogoUrl?: string | null, goal?: number | null, playerList?: { __typename?: 'ReportDetailsMatchTeamPlayerList', manager?: { __typename?: 'ReportDetailsMatchTeamPlayer', id?: string | null, role?: string | null, fullname?: string | null, vote?: string | null, topPlayer?: boolean | null } | null, startingLineup?: Array<{ __typename?: 'ReportDetailsMatchTeamPlayer', id?: string | null, role?: string | null, fullname?: string | null, vote?: string | null, topPlayer?: boolean | null, playerPageLink?: string | null } | null> | null, substitutes?: Array<{ __typename?: 'ReportDetailsMatchTeamPlayer', id?: string | null, role?: string | null, fullname?: string | null, vote?: string | null, topPlayer?: boolean | null, playerPageLink?: string | null } | null> | null } | null } | null, away?: { __typename?: 'ReportDetailsMatchTeam', teamId?: string | null, shortname?: string | null, seoName?: string | null, name?: string | null, logoUrl?: string | null, negativeLogoUrl?: string | null, goal?: number | null, playerList?: { __typename?: 'ReportDetailsMatchTeamPlayerList', manager?: { __typename?: 'ReportDetailsMatchTeamPlayer', id?: string | null, role?: string | null, vote?: string | null, topPlayer?: boolean | null, fullname?: string | null } | null, startingLineup?: Array<{ __typename?: 'ReportDetailsMatchTeamPlayer', id?: string | null, role?: string | null, fullname?: string | null, vote?: string | null, topPlayer?: boolean | null, playerPageLink?: string | null } | null> | null, substitutes?: Array<{ __typename?: 'ReportDetailsMatchTeamPlayer', id?: string | null, role?: string | null, fullname?: string | null, vote?: string | null, topPlayer?: boolean | null, playerPageLink?: string | null } | null> | null } | null } | null } | null> | null } | null };

export type GetCompetitionReportsQueryVariables = Exact<{
  seasonId: Scalars['ID']['input'];
  competitionId: Scalars['ID']['input'];
}>;


export type GetCompetitionReportsQuery = { __typename?: 'Query', getCompetitionReports?: { __typename?: 'CompetitionReports', seasonId: string, competitionId: string, reports?: Array<{ __typename?: 'CompetitionReportsList', round?: number | null, competitionPhase?: string | null, reportsDetailsUrl?: string | null, matchList?: Array<{ __typename?: 'CompetitionReportsMatch', matchId?: string | null, date?: string | null, reportStatus?: string | null, reportUrl?: string | null, status?: string | null, statusLabel?: string | null, roundGroup?: string | null, home?: { __typename?: 'CompetitionReportsMatchTeam', teamId?: string | null, name?: string | null, seoName?: string | null, goal?: number | null, logoUrl?: string | null } | null, away?: { __typename?: 'CompetitionReportsMatchTeam', teamId?: string | null, name?: string | null, seoName?: string | null, goal?: number | null, logoUrl?: string | null } | null } | null> | null } | null> | null } | null };

export type GetPlayerStatsQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
}>;


export type GetPlayerStatsQuery = { __typename?: 'Query', getPlayerPagesStats?: { __typename?: 'PlayerPagesStats', playerId: string, playerRole: string, statistics?: Array<{ __typename?: 'PlayerPagesStatsSeasonCompStat', seasonAndCompId?: string | null, customSeasonName?: string | null, customCompetitionName?: string | null, charts?: Array<{ __typename?: 'PlayerPagesStatsChartStats', type?: string | null, success?: number | null, failure?: number | null } | null> | null, stats?: Array<{ __typename?: 'PlayerPagesStatsNumericStats', type?: string | null, value?: number | null } | null> | null } | null> | null } | null };

export type GetScorersRankingPlayerPageQueryVariables = Exact<{
  competitionId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
}>;


export type GetScorersRankingPlayerPageQuery = { __typename?: 'Query', getScorersRankingPlayerPage?: { __typename?: 'ScorersRankingPlayerPage', competitionSlugName?: string | null, competitionName?: string | null, competitionCalendarUrl?: string | null, scorers?: Array<{ __typename?: 'ScorersRanking', playerId?: string | null, teamId?: string | null, playerSurname?: string | null, seoTeamName?: string | null, teamName?: string | null, teamUrl?: string | null, logoUrl?: string | null, position?: number | null, goal?: number | null, playerPageLink?: string | null, playerImageUrl?: string | null } | null> | null } | null };

export type GetTeamCalendarAndResultsQueryVariables = Exact<{
  teamId: Scalars['ID']['input'];
}>;


export type GetTeamCalendarAndResultsQuery = { __typename?: 'Query', teamCalendarAndResults?: { __typename?: 'TeamCalendarAndResults', teamId: string, matchDayList?: Array<{ __typename?: 'CalendarAndResultsMatchDayList', competitionId: string, competitionPhase?: string | null, competitionPhaseRound?: string | null, customCompetitionName?: string | null, date?: string | null, round?: number | null, roundGroup?: string | null, seasonId: string, matchList?: Array<{ __typename?: 'CalendarAndResultsMatchList', competitionPhaseWinnerTeamId?: string | null, date?: string | null, id: string, link?: string | null, status?: string | null, liveOnSky?: string | null, away?: { __typename?: 'CalendarAndResultsTeam', goal?: number | null, homepageUrl?: string | null, id: string, logoUrl?: string | null, name?: string | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, seoName?: string | null, shootoutGoal?: number | null, totalGoalLegs?: number | null } | null, home?: { __typename?: 'CalendarAndResultsTeam', goal?: number | null, homepageUrl?: string | null, id: string, logoUrl?: string | null, name?: string | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, seoName?: string | null, shootoutGoal?: number | null, totalGoalLegs?: number | null } | null } | null> | null } | null> | null } | null };

export type GetLastAndNextMatchQueryVariables = Exact<{
  teamId: Scalars['ID']['input'];
}>;


export type GetLastAndNextMatchQuery = { __typename?: 'Query', getLastAndNextMatch?: { __typename?: 'LastAndNextMatch', teamId: string, createdAt: any, updatedAt: any, lastMatch?: { __typename?: 'LastAndNextMatchMatch', id?: string | null, round?: number | null, roundGroup?: string | null, competitionPhase?: string | null, competitionPhaseRound?: string | null, competitionPhaseWinnerTeamId?: string | null, status?: string | null, date?: string | null, matchDetailUrl?: string | null, liveOnSky?: string | null, competition?: { __typename?: 'LastAndNextMatchMatchCompetition', id?: string | null, name?: string | null, homepageUrl?: string | null, logoUrl?: string | null } | null, home?: { __typename?: 'LastAndNextMatchMatchTeam', id?: string | null, name?: string | null, goal?: number | null, homepageUrl?: string | null, logoUrl?: string | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, shootoutGoal?: number | null, totalGoalLegs?: number | null } | null, away?: { __typename?: 'LastAndNextMatchMatchTeam', id?: string | null, name?: string | null, goal?: number | null, homepageUrl?: string | null, logoUrl?: string | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, shootoutGoal?: number | null, totalGoalLegs?: number | null } | null } | null, nextMatch?: { __typename?: 'LastAndNextMatchMatch', id?: string | null, round?: number | null, roundGroup?: string | null, competitionPhase?: string | null, competitionPhaseRound?: string | null, competitionPhaseWinnerTeamId?: string | null, status?: string | null, date?: string | null, matchDetailUrl?: string | null, liveOnSky?: string | null, competition?: { __typename?: 'LastAndNextMatchMatchCompetition', id?: string | null, name?: string | null, homepageUrl?: string | null, logoUrl?: string | null } | null, home?: { __typename?: 'LastAndNextMatchMatchTeam', id?: string | null, name?: string | null, goal?: number | null, homepageUrl?: string | null, logoUrl?: string | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, shootoutGoal?: number | null, totalGoalLegs?: number | null } | null, away?: { __typename?: 'LastAndNextMatchMatchTeam', id?: string | null, name?: string | null, goal?: number | null, homepageUrl?: string | null, logoUrl?: string | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, shootoutGoal?: number | null, totalGoalLegs?: number | null } | null } | null } | null };

export type GetTeamPlayersQueryVariables = Exact<{
  teamId: Scalars['ID']['input'];
}>;


export type GetTeamPlayersQuery = { __typename?: 'Query', getTeamPlayers?: { __typename?: 'TeamPlayers', teamId: string, team?: { __typename?: 'TeamPlayersTeam', id: string, name?: string | null, seoName?: string | null, logoUrl?: string | null, homepageUrl?: string | null } | null, competition?: { __typename?: 'TeamPlayersCompetition', id: string, name?: string | null, seoName?: string | null, logoUrl?: string | null, homepageUrl?: string | null } | null, season?: { __typename?: 'TeamPlayersSeason', id: string, label?: string | null } | null, players?: Array<{ __typename?: 'TeamPlayersPlayer', id: string, name?: string | null, surname?: string | null, fullname?: string | null, flag?: string | null, birthdate?: string | null, jerseyNum?: number | null, height?: number | null, weight?: number | null, role?: string | null, playerPageLink?: string | null } | null> | null } | null };

export type GetTeamRankingQueryVariables = Exact<{
  teamId: Scalars['ID']['input'];
}>;


export type GetTeamRankingQuery = { __typename?: 'Query', getTeamRanking?: { __typename?: 'TeamRanking', teamId: string, rankingLists?: Array<{ __typename?: 'TeamRankingRankingList', competitionId: string, customCompetitionName?: string | null, seasonId: string, groups?: Array<{ __typename?: 'TeamRankingGroup', roundName?: string | null, teams?: Array<{ __typename?: 'TeamRankingTeam', games?: number | null, gamesDraw?: number | null, gamesLost?: number | null, gamesWon?: number | null, goalsConceded?: number | null, goalsDifference?: number | null, goalsScored?: number | null, id: string, logoUrl?: string | null, points?: number | null, position?: number | null, qualification?: string | null, teamName?: string | null, teamUrl?: string | null, trend?: string | null, lastMatchesTrend?: Array<{ __typename?: 'TeamRankingLastMatchesTrend', label?: string | null, home?: { __typename?: 'TeamRankingTrend', goal?: number | null, name?: string | null } | null, away?: { __typename?: 'TeamRankingTrend', goal?: number | null, name?: string | null } | null } | null> | null } | null> | null } | null> | null } | null> | null } | null };

export type CardCompetitionRankingSubscriptionSubscriptionVariables = Exact<{
  competitionId: Scalars['ID']['input'];
}>;


export type CardCompetitionRankingSubscriptionSubscription = { __typename?: 'Subscription', onUpdateCardFootballRankingByCompetitionId?: { __typename?: 'CardCompetitionRanking', competitionId: string, customCompetitionName?: string | null, rankingLink?: string | null, groups?: Array<{ __typename?: 'CardCompetitionRankingGroup', roundName?: string | null, teams?: Array<{ __typename?: 'CardCompetitionRankingTeam', games?: number | null, id: string, logoUrl?: string | null, negativeLogoUrl?: string | null, points?: number | null, position?: number | null, teamName?: string | null, teamUrl?: string | null, trend?: string | null } | null> | null } | null> | null } | null };

export type LmpHeroStickySubscriptionSubscriptionVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type LmpHeroStickySubscriptionSubscription = { __typename?: 'Subscription', onUpdateLmpHeroStickyByMatchId?: { __typename?: 'LmpHeroSticky', matchId: string, status?: string | null, home?: { __typename?: 'LmpHeroTeam', goal?: number | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, shootoutGoal?: number | null, totalGoalLegs?: number | null } | null, away?: { __typename?: 'LmpHeroTeam', goal?: number | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, shootoutGoal?: number | null, totalGoalLegs?: number | null } | null } | null };

export type LmpHeroSubscriptionSubscriptionVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type LmpHeroSubscriptionSubscription = { __typename?: 'Subscription', onUpdateLmpHeroByMatchId?: { __typename?: 'LmpHero', matchId: string, status?: string | null, statusStartDateTime?: any | null, home?: { __typename?: 'LmpHeroTeam', goal?: number | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, shootoutGoal?: number | null, totalGoalLegs?: number | null, scoreboard?: Array<{ __typename?: 'LmpHeroScoreboard', minute?: number | null, player?: string | null, type?: string | null, matchStatus?: string | null } | null> | null } | null, away?: { __typename?: 'LmpHeroTeam', goal?: number | null, overtimeGoal?: number | null, penaltiesGoal?: number | null, regularTimeGoal?: number | null, shootoutGoal?: number | null, totalGoalLegs?: number | null, scoreboard?: Array<{ __typename?: 'LmpHeroScoreboard', minute?: number | null, player?: string | null, type?: string | null, matchStatus?: string | null } | null> | null } | null } | null };

export type LmpLineupSubscriptionSubscriptionVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type LmpLineupSubscriptionSubscription = { __typename?: 'Subscription', lineups?: { __typename?: 'LmpLineup', matchId: string, status?: string | null, referees?: Array<{ __typename?: 'LmpLineupReferee', fullname?: string | null, id?: string | null, name?: string | null, surname?: string | null } | null> | null, home?: { __typename?: 'LmpLineupTeam', formation?: string | null, id?: string | null, logoUrl?: string | null, name?: string | null, topPlayerId?: string | null, playerList?: { __typename?: 'LmpLineupPlayerList', manager?: { __typename?: 'LmpLineupManager', fullname?: string | null, id?: string | null, name?: string | null, role?: string | null, surname?: string | null } | null, startingLineup?: Array<{ __typename?: 'LmpLineupPlayerDetails', formationPlace?: string | null, fullname?: string | null, id?: string | null, jerseyNum?: number | null, name?: string | null, role?: string | null, surname?: string | null } | null> | null, substitutes?: Array<{ __typename?: 'LmpLineupPlayerDetails', formationPlace?: string | null, fullname?: string | null, id?: string | null, jerseyNum?: number | null, name?: string | null, role?: string | null, surname?: string | null } | null> | null } | null, goals?: Array<{ __typename?: 'LmpLineupEvent', id?: string | null, minutes?: number | null, type?: string | null } | null> | null, scorersCards?: Array<{ __typename?: 'LmpLineupEvent', id?: string | null, minutes?: number | null, type?: string | null } | null> | null, substitution?: Array<{ __typename?: 'LmpLineupPlayerSubstitution', minutes?: number | null, playerIdIn?: string | null, playerIdOut?: string | null } | null> | null } | null, away?: { __typename?: 'LmpLineupTeam', formation?: string | null, id?: string | null, logoUrl?: string | null, name?: string | null, topPlayerId?: string | null, playerList?: { __typename?: 'LmpLineupPlayerList', manager?: { __typename?: 'LmpLineupManager', fullname?: string | null, id?: string | null, name?: string | null, role?: string | null, surname?: string | null } | null, startingLineup?: Array<{ __typename?: 'LmpLineupPlayerDetails', formationPlace?: string | null, fullname?: string | null, id?: string | null, jerseyNum?: number | null, name?: string | null, role?: string | null, surname?: string | null } | null> | null, substitutes?: Array<{ __typename?: 'LmpLineupPlayerDetails', formationPlace?: string | null, fullname?: string | null, id?: string | null, jerseyNum?: number | null, name?: string | null, role?: string | null, surname?: string | null } | null> | null } | null, goals?: Array<{ __typename?: 'LmpLineupEvent', id?: string | null, minutes?: number | null, type?: string | null } | null> | null, scorersCards?: Array<{ __typename?: 'LmpLineupEvent', id?: string | null, minutes?: number | null, type?: string | null } | null> | null, substitution?: Array<{ __typename?: 'LmpLineupPlayerSubstitution', minutes?: number | null, playerIdIn?: string | null, playerIdOut?: string | null } | null> | null } | null } | null };

export type OnUpdateLmpMatchChangeByMatchIdSubscriptionVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type OnUpdateLmpMatchChangeByMatchIdSubscription = { __typename?: 'Subscription', onUpdateLmpMatchChangeByMatchId?: { __typename?: 'LmpMatchChange', matchId: string, matchList?: Array<{ __typename?: 'LmpMatchChangeMatch', id: string, link?: string | null, status?: string | null, date?: any | null, away?: { __typename?: 'LmpMatchChangeTeam', id: string, goal?: number | null, shortName?: string | null } | null, home?: { __typename?: 'LmpMatchChangeTeam', goal?: number | null, id: string, shortName?: string | null } | null } | null> | null } | null };

export type OnUpdateMatchCommentsByMatchIdAndPageSubscriptionVariables = Exact<{
  matchId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
}>;


export type OnUpdateMatchCommentsByMatchIdAndPageSubscription = { __typename?: 'Subscription', onUpdateMatchCommentsByMatchIdAndPage?: { __typename?: 'MatchComments', matchId: string, matchStatus?: string | null, page: number, firstCommentDate?: string | null, lastCommentDate?: string | null, comments?: Array<{ __typename?: 'MatchCommentsComment', commentId?: string | null, type?: string | null, time?: string | null, message?: string | null, createdAt?: string | null, updatedAt?: string | null } | null> | null, pagination?: { __typename?: 'MatchCommentsPagination', nextLink?: string | null, prevLink?: string | null, items?: number | null, itemsPerPage?: number | null } | null } | null };

export type LmpStatisticsSubscriptionSubscriptionVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type LmpStatisticsSubscriptionSubscription = { __typename?: 'Subscription', onUpdateLmpStatisticsByMatchId?: { __typename?: 'LmpStatistics', matchId: string, status?: string | null, matchStatisticsList?: Array<{ __typename?: 'LmpStatisticsMatchStatistics', id?: string | null, value?: { __typename?: 'LmpStatisticsValue', away?: string | null, home?: string | null } | null } | null> | null } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const GetCompetitionBoardDocument = new TypedDocumentString(`
    query GetCompetitionBoard($competitionId: ID!) {
  getCompetitionBoard(competitionId: $competitionId) {
    boardSponsorLink
    competitionId
    customCompetitionName
    matchList {
      away {
        goal
        id
        logoUrl
        name
        prevMatch
        shootoutGoal
        shortName
      }
      competitionPhase
      competitionPhaseRound
      competitionPhaseWinnerTeamId
      date
      gamesPhaseCount
      home {
        goal
        id
        logoUrl
        name
        prevMatch
        shootoutGoal
        shortName
      }
      id
      link
      linkedMatch {
        away {
          goal
          name
          shootoutGoal
          shortName
        }
        competitionPhaseRound
        status
        date
        home {
          goal
          name
          shootoutGoal
          shortName
        }
        id
        link
      }
      round
      roundGroup
      status
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompetitionBoardQuery, GetCompetitionBoardQueryVariables>;
export const GetCompetitionCalendarAndResultsDocument = new TypedDocumentString(`
    query GetCompetitionCalendarAndResults($seasonId: ID!, $competitionId: ID!) {
  competitionCalendarAndResults: getCompetitionCalendarAndResults(
    seasonId: $seasonId
    competitionId: $competitionId
  ) {
    competitionId
    customCompetitionName
    currentRound
    seasonId
    matchRoundList {
      competitionPhase
      round
      status
      matchDayList {
        date
        matchList {
          competitionPhaseWinnerTeamId
          date
          id
          link
          roundGroup
          competitionPhaseRound
          status
          away {
            goal
            id
            logoUrl
            name
            seoName
            overtimeGoal
            penaltiesGoal
            regularTimeGoal
            shootoutGoal
            totalGoalLegs
          }
          home {
            goal
            id
            logoUrl
            name
            seoName
            overtimeGoal
            penaltiesGoal
            regularTimeGoal
            shootoutGoal
            totalGoalLegs
          }
          liveOnSky
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompetitionCalendarAndResultsQuery, GetCompetitionCalendarAndResultsQueryVariables>;
export const GetPredictedLineupHomepageDocument = new TypedDocumentString(`
    query GetPredictedLineupHomepage($competitionId: ID!) {
  competitionPredictedLineup: getPredictedLineupHomepage(
    competitionId: $competitionId
  ) {
    competitionId
    round
    matchList {
      date
      lmpLineupLink
      matchId
      status
      away {
        predictedTeamLink
        formation
        id
        logo
        negativeLogoUrl
        customName
        customSeoName
        teamShortName
        playerList {
          predictedLineup {
            formationPlace
            fullName
            id
            jerseyNum
            name
            photoUrl
            role
            surname
            playerPageLink
          }
          disqualifiedPlayers
          potentialPlayers
          substitutePlayers
          unavailablePlayers
          manager
        }
      }
      home {
        predictedTeamLink
        formation
        id
        logo
        negativeLogoUrl
        customName
        customSeoName
        teamShortName
        playerList {
          predictedLineup {
            formationPlace
            fullName
            id
            jerseyNum
            name
            photoUrl
            role
            surname
            playerPageLink
          }
          disqualifiedPlayers
          potentialPlayers
          substitutePlayers
          unavailablePlayers
          manager
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetPredictedLineupHomepageQuery, GetPredictedLineupHomepageQueryVariables>;
export const GetCompetitionRankingDocument = new TypedDocumentString(`
    query GetCompetitionRanking($seasonId: ID!, $competitionId: ID!) {
  getCompetitionRanking(seasonId: $seasonId, competitionId: $competitionId) {
    competitionId
    seasonId
    rankingLists {
      competitionId
      customCompetitionName
      seasonId
      groups {
        roundName
        teams {
          games
          gamesDraw
          gamesLost
          gamesWon
          goalsConceded
          goalsDifference
          goalsScored
          id
          logoUrl
          points
          position
          qualification
          teamName
          teamUrl
          trend
          lastMatchesTrend {
            label
            home {
              goal
              name
            }
            away {
              goal
              name
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompetitionRankingQuery, GetCompetitionRankingQueryVariables>;
export const GetCompetitionScorersRankingDocument = new TypedDocumentString(`
    query GetCompetitionScorersRanking($competitionId: ID!, $seasonId: ID!, $page: String!) {
  getCompetitionScorersRanking(
    competitionId: $competitionId
    page: $page
    seasonId: $seasonId
  ) {
    competitionId
    seasonId
    competitionSeoName
    competitionScorersUrl
    page
    pages
    scorers {
      areaIn
      areaOut
      goal
      head
      logoUrl
      playerId
      penalty
      playerName
      position
      seoTeamName
      teamId
      teamUrl
      playerPageLink
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompetitionScorersRankingQuery, GetCompetitionScorersRankingQueryVariables>;
export const GetCardCompetitionCalendarDocument = new TypedDocumentString(`
    query GetCardCompetitionCalendar($competitionId: ID!) {
  getCardCompetitionCalendar(competitionId: $competitionId) {
    competitionId
    customCompetitionName
    calendarAndResultsLink
    matchRoundList {
      competitionPhase
      round
      matchDayList {
        date
        matchList {
          competitionPhaseWinnerTeamId
          date
          id
          link
          roundGroup
          competitionPhaseRound
          status
          away {
            id
            logoUrl
            negativeLogoUrl
            name
            seoName
          }
          home {
            id
            logoUrl
            negativeLogoUrl
            name
            seoName
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCardCompetitionCalendarQuery, GetCardCompetitionCalendarQueryVariables>;
export const GetCardCompetitionRankingDocument = new TypedDocumentString(`
    query GetCardCompetitionRanking($competitionId: ID!) {
  getCardCompetitionRanking(competitionId: $competitionId) {
    competitionId
    customCompetitionName
    rankingLink
    groups {
      roundName
      teams {
        games
        id
        logoUrl
        negativeLogoUrl
        points
        position
        teamName
        teamUrl
        trend
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCardCompetitionRankingQuery, GetCardCompetitionRankingQueryVariables>;
export const GetCompetitionTeamDocument = new TypedDocumentString(`
    query GetCompetitionTeam($id: ID!) {
  getCompetitionTeam(id: $id) {
    id
    competitions {
      homepageUrl
      id
      logoUrl
      name
      seasonAndCompId
      seasonLabel
      teams {
        homepageUrl
        id
        logoUrl
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompetitionTeamQuery, GetCompetitionTeamQueryVariables>;
export const GetLmpHeroStickyDocument = new TypedDocumentString(`
    query GetLmpHeroSticky($matchId: ID!) {
  getLmpHeroSticky(matchId: $matchId) {
    date
    matchId
    status
    home {
      goal
      overtimeGoal
      penaltiesGoal
      regularTimeGoal
      shootoutGoal
      totalGoalLegs
      logoUrl
      negativeLogoUrl
      name
    }
    away {
      goal
      overtimeGoal
      penaltiesGoal
      regularTimeGoal
      shootoutGoal
      totalGoalLegs
      logoUrl
      negativeLogoUrl
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetLmpHeroStickyQuery, GetLmpHeroStickyQueryVariables>;
export const GetLmpHeroDocument = new TypedDocumentString(`
    query GetLmpHero($matchId: ID!) {
  getLmpHero(matchId: $matchId) {
    hasFollowMatch
    competitionPhase
    competitionPhaseRound
    competitionPhaseWinnerTeamId
    date
    matchDetailUrl
    matchId
    round
    roundGroup
    status
    statusStartDateTime
    venue
    competition {
      id
      homepageUrl
      logoUrl
      name
    }
    home {
      goal
      homepageUrl
      id
      logoUrl
      negativeLogoUrl
      name
      overtimeGoal
      penaltiesGoal
      regularTimeGoal
      seoName
      shootoutGoal
      totalGoalLegs
      scoreboard {
        minute
        player
        type
        matchStatus
      }
    }
    away {
      goal
      homepageUrl
      id
      logoUrl
      negativeLogoUrl
      name
      overtimeGoal
      penaltiesGoal
      regularTimeGoal
      seoName
      shootoutGoal
      totalGoalLegs
      scoreboard {
        minute
        player
        type
        matchStatus
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetLmpHeroQuery, GetLmpHeroQueryVariables>;
export const GetLmpLineupDocument = new TypedDocumentString(`
    query GetLmpLineup($matchId: ID!) {
  lineups: getLmpLineup(matchId: $matchId) {
    matchId
    status
    referees {
      fullname
      id
      name
      surname
    }
    home {
      formation
      id
      logoUrl
      negativeLogoUrl
      name
      topPlayerId
      playerList {
        manager {
          fullname
          id
          name
          role
          surname
        }
        startingLineup {
          formationPlace
          fullname
          id
          jerseyNum
          name
          role
          surname
          playerPageLink
        }
        substitutes {
          formationPlace
          fullname
          id
          jerseyNum
          name
          role
          surname
          playerPageLink
        }
      }
      goals {
        id
        minutes
        type
      }
      scorersCards {
        id
        minutes
        type
      }
      substitution {
        minutes
        playerIdIn
        playerIdOut
      }
    }
    away {
      formation
      id
      logoUrl
      negativeLogoUrl
      name
      topPlayerId
      playerList {
        manager {
          fullname
          id
          name
          role
          surname
        }
        startingLineup {
          formationPlace
          fullname
          id
          jerseyNum
          name
          role
          surname
          playerPageLink
        }
        substitutes {
          formationPlace
          fullname
          id
          jerseyNum
          name
          role
          surname
          playerPageLink
        }
      }
      goals {
        id
        minutes
        type
      }
      scorersCards {
        id
        minutes
        type
      }
      substitution {
        minutes
        playerIdIn
        playerIdOut
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetLmpLineupQuery, GetLmpLineupQueryVariables>;
export const GetLmpMatchChangeDocument = new TypedDocumentString(`
    query GetLmpMatchChange($matchId: ID!) {
  getLmpMatchChange(matchId: $matchId) {
    matchId
    matchList {
      id
      link
      status
      date
      away {
        id
        goal
        shortName
      }
      home {
        goal
        id
        shortName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetLmpMatchChangeQuery, GetLmpMatchChangeQueryVariables>;
export const GetMatchCommentsDocument = new TypedDocumentString(`
    query GetMatchComments($matchId: ID!, $page: Int!) {
  getMatchComments(matchId: $matchId, page: $page) {
    matchId
    matchStatus
    page
    url
    firstCommentDate
    lastCommentDate
    homeTeam {
      seoName
      customName
    }
    awayTeam {
      seoName
      customName
    }
    competition {
      seoName
      customName
    }
    comments {
      commentId
      type
      time
      message
      createdAt
      updatedAt
    }
    pagination {
      nextLink
      prevLink
      items
      itemsPerPage
    }
  }
}
    `) as unknown as TypedDocumentString<GetMatchCommentsQuery, GetMatchCommentsQueryVariables>;
export const GetLmpStatisticsDocument = new TypedDocumentString(`
    query GetLmpStatistics($matchId: ID!) {
  getLmpStatistics(matchId: $matchId) {
    matchId
    status
    home {
      id
      logoUrl
      name
    }
    away {
      id
      logoUrl
      name
    }
    matchStatisticsList {
      id
      value {
        away
        home
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetLmpStatisticsQuery, GetLmpStatisticsQueryVariables>;
export const GetPredictedLineupLmpDocument = new TypedDocumentString(`
    query GetPredictedLineupLmp($matchId: ID!) {
  predictedLineupLmp: getLmpPredictedLineupDetails(matchId: $matchId) {
    date
    matchId
    round
    status
    away {
      customName
      customSeoName
      formation
      id
      logo
      negativeLogoUrl
      predictedTeamLink
      teamShortName
      playerList {
        disqualifiedPlayers
        manager
        potentialPlayers
        substitutePlayers
        unavailablePlayers
        predictedLineup {
          formationPlace
          fullName
          id
          jerseyNum
          name
          photoUrl
          role
          surname
          playerPageLink
        }
      }
    }
    home {
      customName
      customSeoName
      formation
      id
      logo
      negativeLogoUrl
      predictedTeamLink
      teamShortName
      playerList {
        disqualifiedPlayers
        potentialPlayers
        substitutePlayers
        unavailablePlayers
        manager
        predictedLineup {
          formationPlace
          fullName
          id
          jerseyNum
          name
          photoUrl
          role
          surname
          playerPageLink
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetPredictedLineupLmpQuery, GetPredictedLineupLmpQueryVariables>;
export const GetLmpPreviewTextDocument = new TypedDocumentString(`
    query GetLmpPreviewText($matchId: ID!) {
  getLmpPreviewText(matchId: $matchId) {
    competitionName
    matchId
    matchStartDateTime
    venue
    away {
      coach
      link
      name
    }
    home {
      coach
      link
      name
    }
    calendar {
      link
      text
    }
    competition {
      link
      text
    }
    ranking {
      link
      text
    }
    results {
      link
      text
    }
  }
}
    `) as unknown as TypedDocumentString<GetLmpPreviewTextQuery, GetLmpPreviewTextQueryVariables>;
export const GetPredictedLineupDetailsDocument = new TypedDocumentString(`
    query GetPredictedLineupDetails($teamId: ID!, $competitionId: ID!) {
  matchPredictedLineup: getPredictedLineupDetails(
    teamId: $teamId
    competitionId: $competitionId
  ) {
    competitionId
    teamId
    predictedHpLink
    predictedSponsorLink
    hasHeadshots
    matchData {
      date
      lmpLineupLink
      lmpLink
      matchId
      away {
        predictedTeamLink
        formation
        id
        logo
        negativeLogoUrl
        customName
        customSeoName
        teamShortName
        playerList {
          disqualifiedPlayers
          manager
          potentialPlayers
          predictedLineup {
            formationPlace
            fullName
            id
            jerseyNum
            name
            photoUrl
            fallbackPhotoUrl
            role
            surname
            playerPageLink
          }
          substitutePlayers
          unavailablePlayers
        }
      }
      home {
        predictedTeamLink
        formation
        id
        logo
        negativeLogoUrl
        customName
        customSeoName
        teamShortName
        playerList {
          disqualifiedPlayers
          manager
          potentialPlayers
          predictedLineup {
            formationPlace
            fullName
            id
            jerseyNum
            name
            photoUrl
            fallbackPhotoUrl
            role
            surname
            playerPageLink
          }
          substitutePlayers
          unavailablePlayers
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetPredictedLineupDetailsQuery, GetPredictedLineupDetailsQueryVariables>;
export const GetReportDetailsDocument = new TypedDocumentString(`
    query GetReportDetails($seasonId: ID!, $competitionId: ID!, $round: Int!) {
  getReportDetails(
    competitionId: $competitionId
    round: $round
    seasonId: $seasonId
  ) {
    competitionId
    seasonId
    round
    reportsHomepageUrl
    reports {
      matchId
      status
      reportStatus
      date
      referees {
        id
        role
        fullname
        vote
        topPlayer
      }
      home {
        teamId
        shortname
        seoName
        name
        logoUrl
        negativeLogoUrl
        goal
        playerList {
          manager {
            id
            role
            fullname
            vote
            topPlayer
          }
          startingLineup {
            id
            role
            fullname
            vote
            topPlayer
            playerPageLink
          }
          substitutes {
            id
            role
            fullname
            vote
            topPlayer
            playerPageLink
          }
        }
      }
      away {
        teamId
        shortname
        seoName
        name
        logoUrl
        negativeLogoUrl
        goal
        playerList {
          manager {
            id
            role
            vote
            topPlayer
            fullname
          }
          startingLineup {
            id
            role
            fullname
            vote
            topPlayer
            playerPageLink
          }
          substitutes {
            id
            role
            fullname
            vote
            topPlayer
            playerPageLink
          }
        }
      }
    }
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetReportDetailsQuery, GetReportDetailsQueryVariables>;
export const GetCompetitionReportsDocument = new TypedDocumentString(`
    query GetCompetitionReports($seasonId: ID!, $competitionId: ID!) {
  getCompetitionReports(seasonId: $seasonId, competitionId: $competitionId) {
    seasonId
    competitionId
    reports {
      round
      competitionPhase
      reportsDetailsUrl
      matchList {
        matchId
        date
        reportStatus
        reportUrl
        status
        statusLabel
        roundGroup
        home {
          teamId
          name
          seoName
          goal
          logoUrl
        }
        away {
          teamId
          name
          seoName
          goal
          logoUrl
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompetitionReportsQuery, GetCompetitionReportsQueryVariables>;
export const GetPlayerStatsDocument = new TypedDocumentString(`
    query GetPlayerStats($playerId: ID!) {
  getPlayerPagesStats(playerId: $playerId) {
    playerId
    playerRole
    statistics {
      seasonAndCompId
      customSeasonName
      customCompetitionName
      charts {
        type
        success
        failure
      }
      stats {
        type
        value
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetPlayerStatsQuery, GetPlayerStatsQueryVariables>;
export const GetScorersRankingPlayerPageDocument = new TypedDocumentString(`
    query GetScorersRankingPlayerPage($competitionId: ID!, $seasonId: ID!) {
  getScorersRankingPlayerPage(competitionId: $competitionId, seasonId: $seasonId) {
    competitionSlugName
    competitionName
    competitionCalendarUrl
    scorers {
      playerId
      teamId
      playerSurname
      seoTeamName
      teamName
      teamUrl
      logoUrl
      position
      goal
      playerPageLink
      playerImageUrl
    }
  }
}
    `) as unknown as TypedDocumentString<GetScorersRankingPlayerPageQuery, GetScorersRankingPlayerPageQueryVariables>;
export const GetTeamCalendarAndResultsDocument = new TypedDocumentString(`
    query GetTeamCalendarAndResults($teamId: ID!) {
  teamCalendarAndResults: getTeamCalendarAndResults(teamId: $teamId) {
    teamId
    matchDayList {
      competitionId
      competitionPhase
      competitionPhaseRound
      customCompetitionName
      date
      round
      roundGroup
      seasonId
      matchList {
        competitionPhaseWinnerTeamId
        date
        id
        link
        status
        away {
          goal
          homepageUrl
          id
          logoUrl
          name
          overtimeGoal
          penaltiesGoal
          regularTimeGoal
          seoName
          shootoutGoal
          totalGoalLegs
        }
        home {
          goal
          homepageUrl
          id
          logoUrl
          name
          overtimeGoal
          penaltiesGoal
          regularTimeGoal
          seoName
          shootoutGoal
          totalGoalLegs
        }
        liveOnSky
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetTeamCalendarAndResultsQuery, GetTeamCalendarAndResultsQueryVariables>;
export const GetLastAndNextMatchDocument = new TypedDocumentString(`
    query GetLastAndNextMatch($teamId: ID!) {
  getLastAndNextMatch(teamId: $teamId) {
    teamId
    createdAt
    updatedAt
    lastMatch {
      id
      round
      roundGroup
      competitionPhase
      competitionPhaseRound
      competitionPhaseWinnerTeamId
      status
      date
      matchDetailUrl
      competition {
        id
        name
        homepageUrl
        logoUrl
      }
      home {
        id
        name
        goal
        homepageUrl
        logoUrl
        overtimeGoal
        penaltiesGoal
        regularTimeGoal
        shootoutGoal
        totalGoalLegs
      }
      away {
        id
        name
        goal
        homepageUrl
        logoUrl
        overtimeGoal
        penaltiesGoal
        regularTimeGoal
        shootoutGoal
        totalGoalLegs
      }
      liveOnSky
    }
    nextMatch {
      id
      round
      roundGroup
      competitionPhase
      competitionPhaseRound
      competitionPhaseWinnerTeamId
      status
      date
      matchDetailUrl
      competition {
        id
        name
        homepageUrl
        logoUrl
      }
      home {
        id
        name
        goal
        homepageUrl
        logoUrl
        overtimeGoal
        penaltiesGoal
        regularTimeGoal
        shootoutGoal
        totalGoalLegs
      }
      away {
        id
        name
        goal
        homepageUrl
        logoUrl
        overtimeGoal
        penaltiesGoal
        regularTimeGoal
        shootoutGoal
        totalGoalLegs
      }
      liveOnSky
    }
  }
}
    `) as unknown as TypedDocumentString<GetLastAndNextMatchQuery, GetLastAndNextMatchQueryVariables>;
export const GetTeamPlayersDocument = new TypedDocumentString(`
    query GetTeamPlayers($teamId: ID!) {
  getTeamPlayers(teamId: $teamId) {
    teamId
    team {
      id
      name
      seoName
      logoUrl
      homepageUrl
    }
    competition {
      id
      name
      seoName
      logoUrl
      homepageUrl
    }
    season {
      id
      label
    }
    players {
      id
      name
      surname
      fullname
      flag
      birthdate
      jerseyNum
      height
      weight
      role
      playerPageLink
    }
  }
}
    `) as unknown as TypedDocumentString<GetTeamPlayersQuery, GetTeamPlayersQueryVariables>;
export const GetTeamRankingDocument = new TypedDocumentString(`
    query GetTeamRanking($teamId: ID!) {
  getTeamRanking(teamId: $teamId) {
    teamId
    rankingLists {
      competitionId
      customCompetitionName
      seasonId
      groups {
        roundName
        teams {
          games
          gamesDraw
          gamesLost
          gamesWon
          goalsConceded
          goalsDifference
          goalsScored
          id
          logoUrl
          points
          position
          qualification
          teamName
          teamUrl
          trend
          lastMatchesTrend {
            label
            home {
              goal
              name
            }
            away {
              goal
              name
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetTeamRankingQuery, GetTeamRankingQueryVariables>;
export const CardCompetitionRankingSubscriptionDocument = new TypedDocumentString(`
    subscription CardCompetitionRankingSubscription($competitionId: ID!) {
  onUpdateCardFootballRankingByCompetitionId(competitionId: $competitionId) {
    competitionId
    customCompetitionName
    rankingLink
    groups {
      roundName
      teams {
        games
        id
        logoUrl
        negativeLogoUrl
        points
        position
        teamName
        teamUrl
        trend
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CardCompetitionRankingSubscriptionSubscription, CardCompetitionRankingSubscriptionSubscriptionVariables>;
export const LmpHeroStickySubscriptionDocument = new TypedDocumentString(`
    subscription LmpHeroStickySubscription($matchId: ID!) {
  onUpdateLmpHeroStickyByMatchId(matchId: $matchId) {
    matchId
    status
    home {
      goal
      overtimeGoal
      penaltiesGoal
      regularTimeGoal
      shootoutGoal
      totalGoalLegs
    }
    away {
      goal
      overtimeGoal
      penaltiesGoal
      regularTimeGoal
      shootoutGoal
      totalGoalLegs
    }
  }
}
    `) as unknown as TypedDocumentString<LmpHeroStickySubscriptionSubscription, LmpHeroStickySubscriptionSubscriptionVariables>;
export const LmpHeroSubscriptionDocument = new TypedDocumentString(`
    subscription LmpHeroSubscription($matchId: ID!) {
  onUpdateLmpHeroByMatchId(matchId: $matchId) {
    matchId
    status
    statusStartDateTime
    home {
      goal
      overtimeGoal
      penaltiesGoal
      regularTimeGoal
      shootoutGoal
      totalGoalLegs
      scoreboard {
        minute
        player
        type
        matchStatus
      }
    }
    away {
      goal
      overtimeGoal
      penaltiesGoal
      regularTimeGoal
      shootoutGoal
      totalGoalLegs
      scoreboard {
        minute
        player
        type
        matchStatus
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LmpHeroSubscriptionSubscription, LmpHeroSubscriptionSubscriptionVariables>;
export const LmpLineupSubscriptionDocument = new TypedDocumentString(`
    subscription LmpLineupSubscription($matchId: ID!) {
  lineups: onUpdateLmpLineupByMatchId(matchId: $matchId) {
    matchId
    status
    referees {
      fullname
      id
      name
      surname
    }
    home {
      formation
      id
      logoUrl
      name
      topPlayerId
      playerList {
        manager {
          fullname
          id
          name
          role
          surname
        }
        startingLineup {
          formationPlace
          fullname
          id
          jerseyNum
          name
          role
          surname
        }
        substitutes {
          formationPlace
          fullname
          id
          jerseyNum
          name
          role
          surname
        }
      }
      goals {
        id
        minutes
        type
      }
      scorersCards {
        id
        minutes
        type
      }
      substitution {
        minutes
        playerIdIn
        playerIdOut
      }
    }
    away {
      formation
      id
      logoUrl
      name
      topPlayerId
      playerList {
        manager {
          fullname
          id
          name
          role
          surname
        }
        startingLineup {
          formationPlace
          fullname
          id
          jerseyNum
          name
          role
          surname
        }
        substitutes {
          formationPlace
          fullname
          id
          jerseyNum
          name
          role
          surname
        }
      }
      goals {
        id
        minutes
        type
      }
      scorersCards {
        id
        minutes
        type
      }
      substitution {
        minutes
        playerIdIn
        playerIdOut
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LmpLineupSubscriptionSubscription, LmpLineupSubscriptionSubscriptionVariables>;
export const OnUpdateLmpMatchChangeByMatchIdDocument = new TypedDocumentString(`
    subscription OnUpdateLmpMatchChangeByMatchId($matchId: ID!) {
  onUpdateLmpMatchChangeByMatchId(matchId: $matchId) {
    matchId
    matchList {
      id
      link
      status
      date
      away {
        id
        goal
        shortName
      }
      home {
        goal
        id
        shortName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<OnUpdateLmpMatchChangeByMatchIdSubscription, OnUpdateLmpMatchChangeByMatchIdSubscriptionVariables>;
export const OnUpdateMatchCommentsByMatchIdAndPageDocument = new TypedDocumentString(`
    subscription OnUpdateMatchCommentsByMatchIdAndPage($matchId: ID!, $page: Int!) {
  onUpdateMatchCommentsByMatchIdAndPage(matchId: $matchId, page: $page) {
    matchId
    matchStatus
    page
    firstCommentDate
    lastCommentDate
    comments {
      commentId
      type
      time
      message
      createdAt
      updatedAt
    }
    pagination {
      nextLink
      prevLink
      items
      itemsPerPage
    }
  }
}
    `) as unknown as TypedDocumentString<OnUpdateMatchCommentsByMatchIdAndPageSubscription, OnUpdateMatchCommentsByMatchIdAndPageSubscriptionVariables>;
export const LmpStatisticsSubscriptionDocument = new TypedDocumentString(`
    subscription LmpStatisticsSubscription($matchId: ID!) {
  onUpdateLmpStatisticsByMatchId(matchId: $matchId) {
    matchId
    status
    matchStatisticsList {
      id
      value {
        away
        home
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LmpStatisticsSubscriptionSubscription, LmpStatisticsSubscriptionSubscriptionVariables>;